import { Entity, Gender, PermissionLevels, TimespanUnit } from '../../index.js';
import { BlameLogType } from '../../blamelog/index.js';
import { CaseState, CaseStatus, CaseType, SystemEndReason, } from '../../cases/index.js';
import { CaseTag } from '../../cases/index.js';
import { CollectorType, PaymentOptionType } from '../../collectors/index.js';
import { ConnectConnectionStatus } from '../../connect/connections/index.js';
import { ConnectCaseMappingStatus, RetractionReason, } from '../../connect/mappings/index.js';
import { ProductService } from '../../connect/products/index.js';
import { UdbetalingsRekvisitioner } from '../../court/index.js';
import { SubmitToCourtError } from '../../court/auto-submit.js';
import { CreditorState } from '../../creditor/index.js';
import { AlternativeContactType, CompanyStarCycle, DissolvedStatus, FoundationCode, PrivateStarCycle, RelationType, RKIStates, } from '../../customers/index.js';
import { RKIRegistrationError, RKIRegistries, } from '../../debt-register/index.js';
import { DocumentTypes } from '../../documents/index.js';
import { CaseVoucherTags } from '../../economy/index.js';
import { DepositShareType } from '../../economy/billing/organize.js';
import { Timing } from '../../economy/billing-appendix-setups/index.js';
import { CaseVoucherSource, PaymentType, State, } from '../../economy/case-vouchers/index.js';
import { PaymentPlanEntryStatus } from '../../economy/payment-plans/index.js';
import { PayoutState, PayoutType } from '../../economy/payouts/index.js';
import { VoucherTypeIds, VoucherCategory, VoucherTypeSetting, CompoundingPeriod, ImposeInterestFrequency, } from '../../economy/vouchers/index.js';
import { EmbedPlacement } from '../../embeds/index.js';
import { ImportState } from '../../imports/types.js';
import { AggregationType } from '../../insights/aggregations.js';
import { BulkActionType } from '../../insights/bulk-actions.js';
import { DiscountType, IntentType } from '../../intents/index.js';
import { InteractionType, PhoneIncomingTag, PhoneOutgoingTag, ReturnReason, } from '../../interactions/index.js';
import { PerformedByType } from '../../performed-by/index.js';
import { SystemProcedure, SystemProcedureId } from '../../procedures/index.js';
import { TemplateTag, TemplateMention, TemplateType, } from '../../templates/index.js';
import { TenantStatus } from '../../tenants/index.js';
import { SKU } from '../../tenants/billing.js';
import { TribunalCaseStatus, TribunalCaseType, } from '../../tribunal/cases/types.js';
import { CourtMeetingState, DistraintType, TribunalJobType, } from '../../tribunal/jobs/types.js';
import { UpdateType } from '../../updates/index.js';
import { VoucherApplicationTarget, VoucherApplicationType, InterestFrom, } from '../../voucher-applications/index.js';
import { PathWarning, RequirementType, TimingType, TodoType, } from '../../workflows/index.js';
import { FilterType } from '../../insights/index.js';
export default {
    is: {
        currently: 'da',
    },
    langs: {
        en: 'Engelsk',
        da: 'Dansk',
        sv: 'Svensk',
        no: 'Norsk',
        fi: 'Finsk',
        nl: 'Hollandsk',
        de: 'Tysk',
        fr: 'Fransk',
        es: 'Spansk',
        cs: 'Tjekkisk',
        el: 'Græsk',
    },
    changelogs: {
        bookDemo: 'Få en online demo',
        close: 'Forstået',
        changelog: 'Ændringslog',
    },
    tribunalCaseTypes: {
        [TribunalCaseType.DKBetalingspaakrav]: '🇩🇰 Betalingspåkrav',
        [TribunalCaseType.DKFogedrekvisition]: '🇩🇰 Fogedrekvisition',
        [TribunalCaseType.GLStaevning]: '🇬🇱 Stævning',
        [TribunalCaseType.GLFogedBegaering]: '🇬🇱 Fogedbegæring',
        [TribunalCaseType.GLBetalingspaakrav]: '🇬🇱 Betalingspåkrav',
    },
    tribunalCaseStatuses: {
        [TribunalCaseStatus.Created]: 'Oprettet',
        [TribunalCaseStatus.Awaiting1Paategning]: 'Afventer 1.-påtegning',
        [TribunalCaseStatus.ClosedBecauseOfObjection]: 'Lukket grundet indsigelse',
        [TribunalCaseStatus.Closed]: 'Afsluttet',
        [TribunalCaseStatus.Awaiting2Paategning]: 'Afventer 2.-påtegning',
        [TribunalCaseStatus.AwaitingNoticeForBailiffMeeting]: 'Afventer mødeindkaldelse',
        [TribunalCaseStatus.AwaitingBailiffMeeting]: 'Afventer fogedmøde',
        [TribunalCaseStatus.AwaitingVerdict]: 'Afventer dom',
        [TribunalCaseStatus.AwaitingNoticeForFogedmoede]: 'Afventer indkaldelse',
        [TribunalCaseStatus.AwaitingFogedmoede]: 'Afventer fogedmøde',
    },
    tribunalJobTypes: {
        [TribunalJobType.GLCreateBetalingspaakrav]: 'Opret betalingspåkrav',
        [TribunalJobType.GLResendBetalingspaakrav]: 'Fremsendelse af revideret betalingspåkrav',
        [TribunalJobType.CreateBetalingspaakrav]: 'Opret betalingspåkrav',
        [TribunalJobType.ResendBetalingspaakrav]: 'Fremsendelse af revideret betalingspåkrav',
        [TribunalJobType.Register1Paategning]: 'Registrering af 1.-påtegning',
        [TribunalJobType.ClosedObjection]: 'Lukket efter 1.-påtegning grundet indsigelse',
        [TribunalJobType.Register2Paategning]: 'Registrering af 2.-påtegning',
        [TribunalJobType.CreateFogedrekvisition]: 'Opret fogedrekvisition',
        [TribunalJobType.RegisterInsolvency]: 'Registrér insolvenserklæring',
        [TribunalJobType.RegisterPolicePresentation]: 'Registrér politifremstilling',
        [TribunalJobType.CreateStaevning]: 'Opret stævning',
        [TribunalJobType.ResendStaevning]: 'Genfremsend stævning',
        [TribunalJobType.RegisterVerdict]: 'Dom registreret',
        [TribunalJobType.CreateFogedbegaering]: 'Opret fogedbegæring',
        [TribunalJobType.ResendFogedbegaering]: 'Genfremsend fogedbegæring',
        [TribunalJobType.CourtMeeting]: 'Retsmøde',
        [TribunalJobType.RegisterInsolvens]: 'Registrér insolvens',
        [TribunalJobType.Distraint]: 'Udlæg',
    },
    distraintType: {
        [DistraintType.Property]: 'Fast ejendom',
        [DistraintType.Vehicle]: 'Motorkøretøj',
        [DistraintType.RentDepositum]: 'Depositum i lejebolig',
        [DistraintType.CooperativeHousing]: 'Andelsbolig',
        [DistraintType.Diverse]: 'Diverse',
        [DistraintType.MorgageDeed]: 'Ejerpantebrev',
        [DistraintType.WithheldTax]: 'Tilbageholdt skat',
    },
    tenantStatus: {
        [TenantStatus.Active]: 'Aktiv',
        [TenantStatus.Demo]: 'Demo',
        [TenantStatus.Disabled]: 'Deaktiveret',
        [TenantStatus.GettingStarted]: 'Afventer go-live',
        [TenantStatus.Sandbox]: 'Sandbox',
    },
    tenantStatusPlural: {
        [TenantStatus.Active]: 'Aktive',
        [TenantStatus.Demo]: 'Demoer',
        [TenantStatus.Disabled]: 'Deaktiverede',
        [TenantStatus.GettingStarted]: 'Afventer go-live',
        [TenantStatus.Sandbox]: 'Sandboxes',
    },
    tenantBillingUnits: {
        "Concatenated SMS'": 'Sammenkædede SMSer',
        'Min.': 'Min.',
        'Pcs.': 'Stk.',
        Months: 'Måneder',
    },
    tenantBilling: {
        invoices: 'Fakturaer',
        invoice: 'Faktura',
        creditNote: 'Kreditnota',
        noInvoicesYet: 'Ingen fakturaer at vise',
        backToTenantBilling: 'Tilbage til fakturaer',
    },
    tenantSKU: {
        [SKU.DomesticSMS]: 'SMS national',
        [SKU.InternationalSMS]: 'SMS international',
        [SKU.DomesticAutoCall]: 'Automatisk opkald national',
        [SKU.InternationalAutoCall]: 'Automatisk opkald international',
        [SKU.DomesticLetter]: 'Kuvertering, national porto, papir og håndtering',
        [SKU.InternationalLetter]: 'Kuvertering, international porto, papir og håndtering',
        [SKU.ReturnLetter]: 'Håndtering af returpost',
        [SKU.DigitalSignature]: 'Digital signatur',
        [SKU.PhoneLookup]: 'Telefonnummeropslag',
        [SKU.EmailLookup]: 'Emailopslag',
        [SKU.CaseCreation]: 'Sagsoprettelse',
        [SKU.MigratedCaseCreation]: 'Sagoprettelse (migreret sag)',
        [SKU.MonthlyBaseFee]: 'Månedligt licensgebyr',
        [SKU.SupportAgreement]: 'Supportaftale',
        [SKU.EBoks]: 'e-Boks-besked',
        [SKU.NemId]: 'NemId-validering',
        [SKU.MitID]: 'MitID-validering',
        [SKU.FreezingSystemSignOn]: 'Indefrysning tilmelding',
        [SKU.FreezingSystemSignOff]: 'Indefrysning afmelding',
        [SKU.Consultancy]: 'Konsulentbistand',
    },
    caseVoucherTableLabels: {
        overview: 'Sagens økonomi',
        detailed: 'Sagens økonomi udspecificeret',
        principalWithReferenceCaseVouchers: 'Sagens hovedstol med referenceposteringer',
    },
    caseVoucherTables: {
        createNewTable: 'Tilføj tabel',
        name: 'Navn på flettefelt',
        description: 'Beskrivelse',
        includeHeader: 'Vis overskrift i tabel',
        includeSumRow: 'Vis sum i tabel',
        includeDeleted: 'Vis slettede posteringer',
        includeFIKPaymentDetails: 'Vis FIK betalings-ID genereret af sagsposteringens referencenummer',
        includeDueDate: 'Vis forfaldsdato',
        excludeNotDueCaseVouchers: 'Skjul ikke forfaldne fakturaer',
        onlyShowSelectedVoucherCategories: 'Vis kun udvalgte sagsposteringskategorier',
        includeReferenceCaseVouchers: 'Vis referenceposteringer',
        filterOnCaseVoucherProperties: 'Filtrer på sagsposteringsattributter',
        groupBy: 'Grupper sagsposteringer',
        groupByText: 'Tekst',
        matchPropertiesShouldBeTrue: 'Skal være sand',
        matchPropertiesShouldBeFalse: 'Skal være falsk',
    },
    economyCategories: {
        [VoucherCategory.DISBURSEMENT]: 'Udlæg',
        [VoucherCategory.FEE]: 'Honorar',
        [VoucherCategory.COLLECTIONCOMMISSION]: 'Inddrivelseshonorar',
        [VoucherCategory.OVERPAYMENT]: 'Overindbetaling',
        [VoucherCategory.PAYOUT]: 'Udbetaling',
        [VoucherCategory.TRANSACTION]: 'Transaktioner',
        [VoucherCategory.COST]: 'Omkostninger',
        [VoucherCategory.COURTCOST]: 'Retslige omkostninger',
        [VoucherCategory.INTEREST]: 'Renter',
        [VoucherCategory.PRINCIPAL]: 'Hovedstol',
        [VoucherCategory.VAT]: 'Moms',
    },
    pluralEconomyVoucherTypeLabels: {
        [VoucherTypeIds.PRINCIPAL]: 'Hovedstole',
        [VoucherTypeIds.INVOICE]: 'Fakturaer',
        [VoucherTypeIds.ONACCOUNTINVOICE]: 'Acontofakturaer',
        [VoucherTypeIds.DOM]: 'Dom',
        [VoucherTypeIds.FINALINVOICE]: 'Opgørelser',
        [VoucherTypeIds.CONTROLFEE]: 'Kontrolafgifter',
        [VoucherTypeIds.ADMINISTRATIONCOST]: 'Administrationsgebyrer',
        [VoucherTypeIds.CREDITNOTE]: 'Kreditnotaer',
        [VoucherTypeIds.YEARLYINTEREST]: 'Årlige renter',
        [VoucherTypeIds.PROCESSINTEREST]: 'Procesrenter',
        [VoucherTypeIds.GLPROCESSINTEREST]: 'Procesrenter (GL)',
        [VoucherTypeIds.COMPOUNDINTEREST_DAILY_CAP]: 'Renters rente (daglig rentetilskrivning)',
        [VoucherTypeIds.COMPOUNDINTEREST_MONTHLY_CAP]: 'Renters rente (månedlig rentetilskrivning)',
        [VoucherTypeIds.COMPOUNDINTEREST_QUARTERLY_CAP]: 'Renters rente (kvartalsvis rentetilskrivning)',
        [VoucherTypeIds.REMINDERFEE]: 'Rykkergebyrer',
        [VoucherTypeIds.COLLECTIONCOST]: 'Inkassoomkostninger',
        [VoucherTypeIds.COLLECTIONFEE]: 'Inkassogebyrer',
        [VoucherTypeIds.BAILIFFSFEE]: 'Betalingspåkravsgebyrer',
        [VoucherTypeIds.WRITFEE]: 'Stævningsgebyrer',
        [VoucherTypeIds.COURTCLAIMCOSTWITHOUTCIVILCOURT]: 'Retsgebyrer uden civilretten',
        [VoucherTypeIds.COURTCLAIMSALARY]: 'Retsgebyrsalærer',
        [VoucherTypeIds.BAILIFSSALARY]: 'Sagsomkostninger',
        [VoucherTypeIds.FOGEDREKVISITIONSFEE]: 'Fogedrekvisitionsgebyrer',
        [VoucherTypeIds.POLICEPRESENTATIONFEE]: 'Politifremstilling gebyrer',
        [VoucherTypeIds.COURTCLAIMCOSTWITHBAILIFFSCOURT]: 'Retsgebyrer med fogedretten',
        [VoucherTypeIds.WRITSALARY]: 'Betalingspåkravssalærer',
        [VoucherTypeIds.COMPENSATIONCOST]: 'Kompensationsgebyrer',
        [VoucherTypeIds.Folkeregisteropslag]: 'Folkeregisteropslag',
        [VoucherTypeIds.IMMATERIALRETLIGESAGER]: 'Immaterielretlige sager',
        [VoucherTypeIds.CIVILCOURTCOST]: 'Omkostninger til civilretten',
        [VoucherTypeIds.DEPOSIT]: 'Indbetalinger',
        [VoucherTypeIds.WITHDRAWAL]: 'Udbetalinger',
        [VoucherTypeIds.OVERPAYMENT]: 'Overindbetalinger',
        [VoucherTypeIds.COLLECTIONCOMMISSION]: 'Inddrivelseshonorarer',
        [VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE]: 'Inddrivelseshonorarer (overvågning)',
        [VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT]: 'Inddrivelseshonorarer (kreditorindbetaling)',
        [VoucherTypeIds.JURIDISKBISTAND]: 'Juridisk bistand',
        [VoucherTypeIds.ENDCASEFEE]: 'Sagsafslutningshonorarer',
        [VoucherTypeIds.STARTCASEFEE]: 'Sagsopstartshonorarer',
        [VoucherTypeIds.BPKFEE]: 'Betalingspåkravshonorarer',
        [VoucherTypeIds.FOGEDFEE]: 'Fogedrekvisitionshonorarer',
        [VoucherTypeIds.RKIREGISTRATIONFEE]: 'RKI-registreringshonorarer',
        [VoucherTypeIds.BPKDISBURSEMENT]: 'Betalingspåkravsudlæg',
        [VoucherTypeIds.POLICEDISBURSEMENT]: 'Politifremstillingsudlæg',
        [VoucherTypeIds.FOGEDDISBURSEMENT]: 'Fogedrekvisitionsudlæg',
        [VoucherTypeIds.VAT]: 'Moms',
        [VoucherTypeIds.GAELDSBREV]: 'Gældsbreve',
        [VoucherTypeIds.SETTLEMENT]: 'Frivillige forlig',
        [VoucherTypeIds.FIXEDINTEREST]: 'Fast rente',
        [VoucherTypeIds.UDTRAEKSGEBYR]: 'Udtræksgebyrer',
        [VoucherTypeIds.DEPOSITPAYOUT]: 'Udbetalinger af indbetalinger',
        [VoucherTypeIds.FOLKEREGISTEROPSLAG]: 'Folkeregisteropslag',
        [VoucherTypeIds.ANMELDELSEAFKRAV]: 'Anmeldelse af krav',
        [VoucherTypeIds.MeetingFee]: 'Mødesalærer',
        [VoucherTypeIds.STAEVNINGSGEBYR]: 'Stævningsgebyr',
        [VoucherTypeIds.BERAMMELSESAFGIFT]: 'Berammelsesafgifter',
        [VoucherTypeIds.AFLYSNINGAFUDLAEG]: 'Aflysning af udlæg',
        [VoucherTypeIds.LOCKSMITHFEE]: 'Låsesmedsgebyrer',
        [VoucherTypeIds.DRIVINGFEE]: 'Kørselsomkostninger',
        [VoucherTypeIds.OTHERFEE]: 'Anden omkostning',
        [VoucherTypeIds.REFUND]: 'Refusioner',
    },
    economyVoucherTypeLabels: {
        [VoucherTypeIds.PRINCIPAL]: 'Hovedstol',
        [VoucherTypeIds.INVOICE]: 'Faktura',
        [VoucherTypeIds.ONACCOUNTINVOICE]: 'Acontofaktura',
        [VoucherTypeIds.DOM]: 'Dom',
        [VoucherTypeIds.FINALINVOICE]: 'Opgørelse',
        [VoucherTypeIds.CONTROLFEE]: 'Kontrolafgift',
        [VoucherTypeIds.ADMINISTRATIONCOST]: 'Administrationsgebyr',
        [VoucherTypeIds.CREDITNOTE]: 'Kreditnota',
        [VoucherTypeIds.YEARLYINTEREST]: 'Årlig rente',
        [VoucherTypeIds.PROCESSINTEREST]: 'Procesrente',
        [VoucherTypeIds.GLPROCESSINTEREST]: 'Procesrente (GL)',
        [VoucherTypeIds.COMPOUNDINTEREST_DAILY_CAP]: 'Renters rente (daglig rentetilskrivning)',
        [VoucherTypeIds.COMPOUNDINTEREST_MONTHLY_CAP]: 'Renters rente (månedlig rentetilskrivning)',
        [VoucherTypeIds.COMPOUNDINTEREST_QUARTERLY_CAP]: 'Renters rente (kvartalsvis rentetilskrivning)',
        [VoucherTypeIds.REMINDERFEE]: 'Rykkergebyr',
        [VoucherTypeIds.COLLECTIONCOST]: 'Inkassoomkostning',
        [VoucherTypeIds.COLLECTIONFEE]: 'Inkassogebyr',
        [VoucherTypeIds.COMPENSATIONCOST]: 'Kompensationsgebyr',
        [VoucherTypeIds.Folkeregisteropslag]: 'Folkeregisteropslag',
        [VoucherTypeIds.IMMATERIALRETLIGESAGER]: 'Immaterielretlige sager',
        [VoucherTypeIds.DEPOSIT]: 'Indbetaling',
        [VoucherTypeIds.WITHDRAWAL]: 'Udbetaling',
        [VoucherTypeIds.OVERPAYMENT]: 'Overindbetaling',
        [VoucherTypeIds.COLLECTIONCOMMISSION]: 'Inddrivelseshonorar',
        [VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE]: 'Inddrivelseshonorar (overvågning)',
        [VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT]: 'Inddrivelseshonorar (kreditorindbetaling)',
        [VoucherTypeIds.JURIDISKBISTAND]: 'Juridisk bistand',
        [VoucherTypeIds.ENDCASEFEE]: 'Sagsafslutningshonorar',
        [VoucherTypeIds.STARTCASEFEE]: 'Sagsopstartshonorar',
        [VoucherTypeIds.BPKFEE]: 'Betalingspåkravshonorar',
        [VoucherTypeIds.FOGEDFEE]: 'Fogedrekvisitionshonorar',
        [VoucherTypeIds.RKIREGISTRATIONFEE]: 'RKI-registreringshonorar',
        [VoucherTypeIds.BPKDISBURSEMENT]: 'Betalingspåkravsudlæg',
        [VoucherTypeIds.POLICEDISBURSEMENT]: 'Politifremstillingsudlæg',
        [VoucherTypeIds.COURTCLAIMCOSTWITHBAILIFFSCOURT]: 'Retsgebyr med fogedretten',
        [VoucherTypeIds.CIVILCOURTCOST]: 'Omkostning til civilretten',
        [VoucherTypeIds.FOGEDDISBURSEMENT]: 'Fogedrekvisitionsudlæg',
        [VoucherTypeIds.COURTCLAIMCOSTWITHOUTCIVILCOURT]: 'Retsgebyr uden civilretten',
        [VoucherTypeIds.COURTCLAIMSALARY]: 'Retsgebyrsalær',
        [VoucherTypeIds.VAT]: 'Moms',
        [VoucherTypeIds.BAILIFFSFEE]: 'Betalingspåkravsgebyr',
        [VoucherTypeIds.BAILIFSSALARY]: 'Sagsomkostninger',
        [VoucherTypeIds.FOGEDREKVISITIONSFEE]: 'Fogedrekvisitionsgebyr',
        [VoucherTypeIds.POLICEPRESENTATIONFEE]: 'Politifremstillingsgebyr',
        [VoucherTypeIds.WRITFEE]: 'Stævningsgebyr',
        [VoucherTypeIds.WRITSALARY]: 'Stævningssalær',
        [VoucherTypeIds.GAELDSBREV]: 'Gældsbrev',
        [VoucherTypeIds.SETTLEMENT]: 'Frivilligt forlig',
        [VoucherTypeIds.FIXEDINTEREST]: 'Fast rente',
        [VoucherTypeIds.UDTRAEKSGEBYR]: 'Udtræksgebyr',
        [VoucherTypeIds.DEPOSITPAYOUT]: 'Udbetaling af indbetaling',
        [VoucherTypeIds.FOLKEREGISTEROPSLAG]: 'Folkeregisteropslag',
        [VoucherTypeIds.ANMELDELSEAFKRAV]: 'Anmeldelse af krav',
        [VoucherTypeIds.MeetingFee]: 'Mødesalær',
        [VoucherTypeIds.STAEVNINGSGEBYR]: 'Stævningsgebyr',
        [VoucherTypeIds.BERAMMELSESAFGIFT]: 'Berammelsesafgift',
        [VoucherTypeIds.AFLYSNINGAFUDLAEG]: 'Aflysning af udlæg',
        [VoucherTypeIds.LOCKSMITHFEE]: 'Låsesmedsgebyr',
        [VoucherTypeIds.DRIVINGFEE]: 'Kørselsomkostning',
        [VoucherTypeIds.OTHERFEE]: 'Andre omkostninger',
        [VoucherTypeIds.REFUND]: 'Refusion',
    },
    connectionReasons: {
        someoneAddedTheFollowingVouchers: 'tilføjede følgende postering(er)',
        addedTheFollowingVouchers: 'Følgende postering(er) blev tilføjet',
        someoneDeletedTheFollowingVouchers: 'slettede følgende postering(er)',
        deletedTheFollowingVouchers: 'Følgende postering(er) blev slettet',
        thatResultedIn: 'Det resulterede i følgende afregning',
    },
    economyDownloadPostings: {
        postingReference: 'Bilagsnummer',
        creditorReference: 'Kreditorreference',
        transactionId: 'Posterings-id.',
        type: 'Type',
        ofVoucher: 'Af postering',
        date: 'Dato',
        currency: 'Valuta',
        amount: 'Beløb',
        accountType: 'Konto type',
        account: 'Konto',
    },
    systemTankHandles: {
        DEPOSITS: 'Indbetalinger',
    },
    billingModels: {
        name: 'Navn',
        preventNegativeCreditorBalance: 'Undgå negativ kreditorbalance',
        selectVouchersGroup: 'Vælg posteringer',
        systemConnector: 'Systemafregningsmodel',
        tenantConnector: 'Oprettet afregningsmodel',
        voucherCategory: 'Posteringskategori',
        voucherType: 'Posteringstype',
        allVouchers: 'Alle posteringer',
        categoriesOrTypesFilter: 'Vælg posteringer som skal honoreres',
        caseTagFilter: 'Filtér honorering',
        caseTagSurveillanceFilter: 'Overvågning',
        caseTagCompanyFilter: 'Erhvervssager',
        caseTagPrivateFilter: 'Personsager',
        voucherTagFilter: 'Honorér efter hvem som har pålagt posteringen',
        imposedByCollector: 'Pålagt af inddriver',
        imposedByCreditor: 'Pålagt af kreditor',
        feeFraction: 'Honorér en andel af posteringen',
        feeFractionPlaceholder: 'Procentvis andel som skal honoreres',
        addShare: 'Tilføj honorering',
        byVoucherCategory: 'Efter posteringskategori',
        byVoucherType: 'Efter posteringstype',
        createBillingModel: 'Opret afregningsmodel',
        simulateBilling: 'Simulér afregning',
        simulateCompany: 'Simulér en virksomhed',
        simulateSurveillance: 'Simulér overvågning',
        simulateAmount: 'Beløb på indbetaling',
        previewBillingModel: 'Forhåndsvis afregningsmodel',
        selectBillingModel: 'Vælg afregningsmodel',
    },
    billingAppendixSetups: {
        tenantBillingAppendixSetup: 'Egne bilagsopsætninger',
        systemBillingAppendixSetup: 'Standard bilagsopsætninger',
        name: 'Navn',
        billingAppendixSetups: 'Opsætninger af afregningsbilag',
        noBillingAppendixSetupsToShow: 'Ingen bilagsopsætninger at vise',
        newBillingAppendixSetup: 'Ny bilagsopsætning',
        addBillingAppendixSetup: 'Opret bilagsopsætning',
        billing: 'Afregning',
        createNew: 'Opret bilagsopsætning',
        addNewSetup: 'Tilføj bilagsopsætning',
        appendixHandle: 'Navn på bilag',
        selectBillingAppendixSetup: 'Vælg bilagsopsætning',
        previewBillingAppendixSetup: 'Forhåndsvis bilagsopsætning',
    },
    billingAppendixSetupTimings: {
        [Timing.Manual]: 'Manuel afregning',
        [Timing.ASAP]: 'Hurtigst muligt',
        [Timing.OnCaseEnd]: 'Efter sagsafslutning',
        [Timing.Weekly]: 'Ugentligt',
        [Timing.Monthly]: 'Månedligt',
        [Timing.Quarterly]: 'Kvartalvist',
    },
    caseVoucherStates: {
        [State.Unmapped]: 'Oprettet',
        [State.Unknown]: 'Uidentificeret',
        [State.Archived]: 'Arkiveret',
        [State.Overpayment]: 'Overindbetaling',
        [State.FullPayment]: 'Fuld betaling',
        [State.PartialPayment]: 'Delbetaling',
        [State.PaymentPlanEntryPayment]: 'Betaling af afdrag',
        [State.UnkownPaymentPlanPayment]: 'Ukendt afdragsbetaling',
        [State.AccordPayment]: 'Akkordbetaling',
        [State.PrincipalPayment]: 'Hovedstolsbetaling',
        [State.Pending]: 'Afventer',
    },
    caseVoucherSources: {
        [CaseVoucherSource.Collector]: 'Inddriver',
        [CaseVoucherSource.Creditor]: 'Kreditor',
    },
    depositShareType: {
        [DepositShareType.AdjustmentCredit]: 'Justering - kredit',
        [DepositShareType.AdjustmentDebit]: 'Justering - debet',
        [DepositShareType.Deposit]: 'Indbetaling',
    },
    voucherTypeSettings: {
        voucherType: 'Posteringstype',
        category: 'Kategori',
        vat: 'Moms',
        setting: 'Indstilling',
        createNewVoucherType: 'Opret ny posteringstype',
        create: 'Opret',
        customCaseVoucherType: 'Oprettede sagsposteringstyper',
        standardCaseVoucherType: 'Standard sagsposteringstyper',
        customBillingVoucherType: 'Oprettede afregningsposteringstyper',
        standardBillingVoucherType: 'Standard afregningsposteringstyper',
        caseVoucherType: 'Sagsposteringstype',
        caseVoucherTypeDesc: 'Navnet på posteringstypen, kategorien og eventuel indstilling.',
        label: 'Navn',
        noSetting: 'Ingen',
        interstDays: 'Rentedage',
        interstDaysDesc: 'Antal rentedage per år.',
        interestRounding: 'Afrunding',
        interestRoundingDesc: 'Hvordan skal rentetilskrivningen afrundes?',
        interestRoundingContent: 'Afrundes til nærmeste øre dagligt',
        interestCompoundingPeriod: 'Rentetilskrivning',
        interestCompoundingPeriodDesc: 'Hvor ofte renten skal tilskrives hovedstolen. Dette kaldes også kapitaliseringsperioden.',
        interestCompoundVouchers: 'Tilskrivningsposteringer',
        interestCompoundVouchersDesc: 'Posteringstyper som skal betegnes som tilskrevede renter hvis de ligger som referencer til samme hovedstolspostering',
        interestFrequency: 'Rente beregningsfrekvens',
        interestFrequencyDesc: 'Hvor ofte renten beregnes.',
        interestTable: 'Rentesatstabel',
        interestTableDesc: 'Rentesatsens udvikling over tid.',
        interestTableFromDate: 'Fra dato',
        interestTableRate: 'Rentesats',
        billingVoucherType: 'Afregningsposteringstype',
        billingVoucherTypeDesc: 'Navnet på posteringstypen og kategorien.',
    },
    voucherTypeSetting: {
        [VoucherTypeSetting.AmountFromTable]: 'Beløb fra tabel',
        [VoucherTypeSetting.InterestFromTable]: 'Rente fra tabel',
        [VoucherTypeSetting.CompoundInterest]: 'Renters rente',
        [VoucherTypeSetting.FixedInterest]: 'Fast rente',
        [VoucherTypeSetting.YearlyInterest]: 'Årlig rente',
        [VoucherTypeSetting.TextAsLabel]: 'Tekst som label',
    },
    compoundingPeriod: {
        [CompoundingPeriod.Daily]: 'Dailigt',
        [CompoundingPeriod.Monthly]: 'Månedligt',
        [CompoundingPeriod.Quarterly]: 'Kvartalvist',
    },
    imposeInterestFrequency: {
        [ImposeInterestFrequency.Daily]: 'Dagligt',
    },
    economy: {
        groupPostings: 'Grupper posteringer i udtækket',
        generalBillingSettings: 'Indstillinger for afregning',
        sendingBillingByEmail: 'Afsendelse af afregninger per email',
        doNotAttachBillingAppendicesInEmails: 'Undlad at vedhæfte afregningsbilag',
        billingModels: 'Afregningsmodeller',
        tenantBillingModels: 'Egne afregningsmodeller',
        defaultBillingModels: 'Standard afregningsmodeller',
        noBillingModelsToShow: 'Ingen afregningsmodeller at vise',
        newBillingModel: 'Afregningsmodel',
        addBillingModel: 'Opret afregningsmodel',
        billingAppendixSetup: 'Bilagsopsætning',
        sureYouWantToRemoveVouchersFromTanks: 'Er du sikker på, at du vil slette posteringerne fra bilaget?',
        removeVouchersFromTanks: 'Slet posteringer fra bilag',
        depositInTheseTanks: 'Indbetalingen er indeholdt i følgende bilag',
        allVouchers: 'Alle posteringer',
        standardPrice: 'listepris:',
        regNumber: 'Reg. nr.',
        accountNumber: 'Kontonummer',
        addNewPipeFilter: 'Tilføj nyt filter',
        pipeFilterSave: 'Gem',
        pipeFilterHandle: 'Filterhandle',
        pipeFilterEndOfMonth: 'Slutningen af måneden',
        pipeFilterSelectVoucherTypes: 'Vælg posteringstyper',
        pipeSettings: 'Indstillinger',
        added: 'Tilføjede ',
        newVouchers: ' nye posteringer',
        newVouchersModal: 'Nye indbetalinger',
        map: 'Venligst journaliser',
        deposits: 'indbetalinger',
        uploadDeposits: 'Registrer indbetalinger',
        depositFile: 'Indbetalingsfil',
        noText: 'Ingen tekst',
        sureYouWantToDelTank: 'Er du sikker på at du vil slette eksporten?',
        sureYouWantToDelTankContent: 'Er du sikker på at du vil slette denne del af eksporten?',
        caseEconomy: 'Sagens økonomi',
        voucherAlreadyExists: 'findes allerede på sag',
        histItemHeader: 'Økonomi',
        addVoucher: 'Tilføj postering',
        sum: 'Sum',
        voucherType: 'Posteringstype',
        account: 'Konto',
        contraaccount: 'Modkonto',
        referenceId: 'Referencenummer',
        text: 'Beskrivelse',
        amount: 'Beløb',
        originalAmount: 'Oprindeligt beløb',
        date: 'Dato',
        dueDate: 'Forfaldsdato',
        expirationDate: 'Forældelsesdato',
        expirationFromDate: 'Speciel startdato for forældelse',
        expirationManualSet: 'Forældelsesdato manuelt sat',
        addAppendix: 'Tilføj bilag',
        referenceVoucher: 'Referencepostering som posteringen skal tilknyttes',
        selectReferenceVoucher: 'Vælg referencepostering',
        interestRate: 'Renteprocent',
        interestAmount: 'Rentebeløb',
        interest: 'Rente',
        interestStartDate: 'Rentestartdato',
        interestStartDays: 'Dage til rentestart',
        interestEndDate: 'Renteslutdato',
        imposedByCreditor: 'Indleveret af kreditor',
        debtIrrecoverable: 'Uerholdelig',
        debtExpied: 'Forældet',
        markExpired: 'Foræld og luk sag',
        markSomeExpired: 'Foræld',
        markSomeExpiredPostings: 'posteringer',
        sureYouWantToMarkIrrecoverable: 'Er du sikker på at du vil markere denne sag uerholdelig?',
        sureYouWantToMarkExpired: 'Er du sikker på at du vil markere posteringer forældet?',
        markIrrecoverable: 'Erklær uerholdelig',
        voucherCreationNotSupported: 'Posteringstypen er ikke understøttet på nuværende tidspunkt.',
        voucherCreationCreate: 'Opret',
        voucherCreationErrorMessage: 'Der skete en fejl',
        voucherCreationIncludeInterest: 'Tilføj procesrente',
        voucherCreationCreditorDeposit: 'Indbetaling til kreditor',
        caseVoucherInfoType: 'Type',
        caseVoucherInfoTypeSeeDetails: 'Se detaljer om sagsposteringstypen',
        caseVoucherInfoCreatedAt: 'Oprettet',
        voucherInfoId: 'Posterings-id',
        voucherInfoCreatedBy: 'Oprettet af',
        caseVoucherInfoCategory: 'Kategori',
        caseVoucherInfoState: 'Status',
        caseVoucherInfoHeaderTheVoucher: 'Posteringen',
        caseVoucherInfoHeaderMeta: 'Information',
        caseVoucherInfoHeaderInterest: 'Rentedetaljer',
        voucherInfoText: 'Tekst',
        voucherInfoAmount: 'Beløb',
        voucherInfoCardtype: 'Korttype',
        voucherInfoCardexpires: 'Kort udløber',
        voucherInfoMaskedcard: 'Sløret kort',
        voucherInfoTextOnStmt: 'Tekst på udtog',
        voucherInfoCasePreview: 'Sag',
        voucherInfoMoveToCase: 'Postering flyttet til sag',
        voucherInfoCreditorName: 'Kreditor',
        voucherInfoAppendix: 'Bilag',
        voucherInfoRefVoucher: 'Referencepostering',
        voucherInfoInterestHis: 'Renteberegning',
        voucherInfoIfrom: 'Fra',
        voucherInfoITo: 'Til',
        voucherInfoIInterval: 'Interval',
        voucherInfoIRVA: 'Ref.posteringsbeløb',
        voucherInfoICompoundedAmount: 'Tilskrevet rente',
        voucherInfoIDays: 'dage',
        voucherInfoDeleteVoucher: 'Slet postering',
        deleteVoucherWichIsInTank: 'Indbetalingen er indeholdt i ovenstående bilag og kan derfor ikke slettes. Fjern indbetalingen fra bilagene, før du kan slette betalingen.',
        voucherInfovoucherContraAccountName: 'Modkonto',
        voucherInfoMarkVoucherExpired: 'Forældet',
        voucherInfoUnmarkVoucherExpired: 'Fjern forældelsesmarkering',
        voucherInfoMarkVoucherIrrecoverable: 'Uerholdelig',
        imposedBySelectorMessage: 'Postering pålagt af',
        noVouchers: 'Ingen posteringer at vise',
        billingHeader: 'Afregn kreditorer',
        billingButtonText: 'Afregn alle kreditorer',
        billingHeaderHistory: 'Afregninger',
        currency: 'Valuta',
        billingModel: 'Afregningsmodel',
        billingModelStart: 'Fra',
        billingModelEnd: 'Til',
        ongoing: 'Igangværende arbejde',
        bill: 'Afregn',
        aggregation: 'Sammentælling',
        postings: 'Posteringer',
        sendBillings: 'Afsend afregninger til kreditorer',
        billingsSent: 'Afregninger afsendt',
        bookkeepingMapping: 'Map bogføringskonti',
        bookkeepingMappingBase: 'Generelt',
        bookkeepingMappingFees: 'Honorarer',
        bookkeepingMappingDisbursements: 'Udlæg',
        bookkeepingMappingAccount: 'Konto',
        bookkeepingMappingAccountType: 'Kontotype',
        bookkeepingMappingReverse: 'Omvendt fortegn',
        bookkeepingMappingExclude: 'Ekskluder',
        bookkeepingMappingIncludeVat: 'Inkluder moms',
        bookkeepingMappingContraAccountOn: 'Modkonto',
        bookkeepingMappingContraAccount: 'Modposteringens konto',
        bookkeepingMappingContraAccountType: 'Modposteringens kontotype',
        bookkeepingMappingCreditorReferenceId: 'Kreditor reference-id',
        bookkeepingMappingBankOrPSP: 'Bank eller indløser',
        bankAccountsDesc: 'Her kan du tilføje, fjerne og omdøbe dine bankkonti.',
        bankAccountsPlaceholder: 'Navnet på din nye konto',
        bankAccountsNewAccountName: 'Tilføj bankkonto',
        acquiresDesc: 'Her kan du omdøbe dine indløsere.',
        nothingToShow: 'Endnu ikke noget at vise.',
        accountName: 'Kontoens nye navn',
        sureYouWantToDeleteAccount: 'Er du sikker på at du vil slette',
        selectInterestType: 'Vælg rentetype',
        selectInterestRate: 'Vælg rentesats',
        selectInterestStart: 'Vælg rentestartsdato',
    },
    economyAppendixHeaders: {
        type: 'Type',
        date: 'Dato',
        voucherId: 'Posterings-Id',
        voucherType: 'Posteringstype',
        text: 'Tekst',
        amount: 'Beløb',
        currency: 'Valuta',
    },
    caseVoucherTags: {
        [CaseVoucherTags.IMPOSEDBYCOLLECTOR]: 'Pålagt af inddriver',
        [CaseVoucherTags.IMPOSEDBYCREDITOR]: 'Pålagt af kreditor',
        [CaseVoucherTags.CREDITORTRANSACTION]: 'Kreditortransaktion',
        [CaseVoucherTags.ECONOMIC_IMPORT]: 'E-conomic import',
        [CaseVoucherTags.EXPIRED]: 'Forældet',
        [CaseVoucherTags.IRRECOVERABLE]: 'Uerholdelig',
    },
    caseTags: {
        [CaseTag.SURVEILLANCE]: 'Overvågning',
    },
    transactionImports: {
        transactionImportsHeader: 'Transaction imports',
        selectType: 'Vælg type af betaling',
    },
    caseVouchers: {
        source: 'Kilde',
        irrecoverableDate: 'Uerholdelig dato',
        expirationDate: 'Forældesesdato',
        expired: 'Forældet',
        case: 'Sag',
        map: 'Registrér',
        mapHeader: 'Registrér betaling på sag',
        deleteWarning: 'Er du sikker på at du vil slette denne indbetaling? Denne handling kan ikke fortrydes',
        exportFileName: 'case-vouchers',
        voucherId: 'Postering-id',
        voucherReferenceId: 'Posteringsreference',
        caseId: 'Sagsnummer',
        creditor: 'Kreditor',
        creditorReference: 'Kreditorreference',
        customerReference: 'Kundereference',
        account: 'Konto',
        accountId: 'Konto-id',
    },
    payouts: {
        caseReferenceId: 'Sagsreference',
        caseSeqId: 'Sagsid',
        billingId: 'Afregnings-id',
        court: 'Retskreds',
        creditorReference: 'Kreditorreference',
        type: 'Type',
        account: 'Konto',
        text: 'Tekst',
        state: 'Status',
        amount: 'Beløb',
        currency: 'Valuta',
        createdAt: 'Oprettet',
        updatedAt: 'Opdateret',
        complete: 'Udført',
        completeOnExport: 'Marker udført ved eksport',
        exportFileName: 'udbetalinger',
    },
    payoutState: {
        [PayoutState.Completed]: 'Udført',
        [PayoutState.Created]: 'Oprettet',
        [PayoutState.DataUpdated]: 'Data opdateret',
        [PayoutState.Failed]: 'Fejlet',
        [PayoutState.Initiated]: 'Igangsat',
    },
    payoutType: {
        [PayoutType.CourtFee]: 'Retsafgifter',
        [PayoutType.CreditorReceivables]: 'Kreditortilgodehavender',
        [PayoutType.Overpayment]: 'Overindbetaling',
    },
    clientBilling: {
        clientBilling: 'Kreditorafregning',
        isAdjustment: 'Justering af afregning',
        billings: 'Afregninger',
        seeDetails: 'Se detaljer om kreditorafregning',
        fetchingUpdatedEconomy: 'Henter nyeste information',
        caseSeqId: 'Sagsnummer',
        caseReferenceId: 'Sagsreference-id',
        deposits: 'Indbetalinger',
        fees: 'Honorarer',
        disbursements: 'Udlæg',
        showPerDeposit: 'Vis per indbetaling',
        voucherType: 'Posteringstype',
        original: 'Oprindelig',
        paid: 'Indbetalt',
        residue: 'Resterende',
        collector: 'Inddriver',
        creditor: 'Kreditor',
        overpayment: 'Overindbetaling',
        text: 'Tekst',
        addVoucher: 'Tilføj postering',
        otherPayments: 'af andre indbetalinger.',
        noVouchers: 'Ingen posteringer',
        hoursOf: 'timer á',
        hourOf: 'time á',
        hourlyRateOn: 'Timepris',
        hourlyRate: 'Timepris',
        hourlyRateHours: 'Timer',
        hourlyRateMinutes: 'Minutter',
    },
    search: {
        migratedId: 'Migreret j.nr.',
        noResults: 'Ingen resultater',
        voucherReferenceId: 'Posterings-id',
        cvr: 'CVR',
        cpr: 'CPR',
        phone: 'Telefonnr.',
    },
    deposits: {
        pickPaymentType: 'Vælg betalingstype',
        unknownDeposit: 'Uidentificérbar',
        unknownDepositSubHeader: 'Kunne ikke identificere betalingen',
        archive: 'Arkivér',
        exportDesc: 'Eksport af indbetalinger til bank eller via PSP (kortbetalinger osv.).',
        unknownDesc: 'Her kan du se en liste over uidentificérbare indbetalinger.',
        transactionLookUpDesc: 'Her kan du slå indbetalinger op baseret på posterings-id.',
        transactionLookUpPlaceholder: 'Indtast et posterings-id. (f.eks. 12341234)',
        transactionLookUpNotFound: 'Posteringen kunne ikke findes.',
        transactionLookUpNotDeposit: 'Denne postering er ikke en indbetaling.',
        transactionLookUpButton: 'Søg',
        transactionLookUpDeposit: 'Indbetaling',
        downloadSample: 'Hent eksempel',
        downloadSampleQuantity: 'Antal indbetalinger i eksemplet',
        linkBank: 'Tilknyt bankkonto',
        selectBankAccount: 'Vælg bankkonto',
        dropHere: 'Træk og slip indbetalingsfil her',
        upload: 'Registrer indbetalinger',
        deposits: 'Betalinger',
        map: 'Registrer betalinger',
        handleTransaction: 'Håndtér betaling',
        addSingleDepositHeader: 'Indtast indbetaling manuelt',
        addSingleDepositPaymentType: 'Betalingstype',
        addSingleDepositDate: 'Dato',
        addSingleDepositText: 'Tekst',
        addSingleDepositAmount: 'Beløb',
        addSingleDepositAddAndClose: 'Tilføj og luk',
        addSingleDepositAddAndClear: 'Tilføj og ryd',
    },
    depositsPaymentTypes: {
        [PaymentType.Mastercard]: 'MasterCard',
        [PaymentType.Swish]: 'Swish',
        [PaymentType.Vipps]: 'Vipps',
        [PaymentType.Visa]: 'Visa',
        [PaymentType.Dankort]: 'Dankort',
        [PaymentType.MobilePay]: 'MobilePay',
        [PaymentType.Betalingsservice]: 'Betalingsservice',
        [PaymentType.Leverandørservice]: 'Leverandørservice',
        [PaymentType.BankTransfer]: 'Bankoverførsel',
        [PaymentType.FIK]: 'FIK',
        [PaymentType.IBAN]: 'IBAN',
        [PaymentType.Creditor]: 'Kreditor',
        [PaymentType.PayPal]: 'PayPal',
        [PaymentType.ApplePay]: 'Apple Pay',
        [PaymentType.GooglePay]: 'Google Pay',
    },
    billingReasons: {
        caseVoucherInlineDeleted: 'Postering (senere slettet)',
        caseVoucherPatchedCaseId: 'blev tilknyttet sagen',
        caseVoucherPatched: 'blev redigeret',
        caseVoucherCreated: 'tilføjet til sagen',
        caseVoucherDeleted: 'slettet fra sagen',
        billingModelChanged: 'Afregningsmodel ændret',
        billingStartDateChanged: 'Startdato for afregning ændret',
    },
    billing: {
        ongoingWork: 'Igangværende arbejde',
        bills: 'Afregninger',
        billingSequentialId: 'Id',
        case: 'Sag',
        date: 'Dato',
        type: 'Type',
        text: 'Tekst',
        customerReferenceId: 'Kunderef.',
        revenue: 'Honorarer',
        vat: 'Moms',
        payout: 'Udbetaling',
        disbursements: 'Udlæg',
        overpayments: 'Overindbetalinger',
        balance: 'Kreditorbevægelse',
        amount: 'Beløb',
        deposits: 'Indbetalinger',
        deposit: 'Indbetaling',
        bill: 'Afregn',
        delete: 'Fjern',
        deleteApproval: 'Er du sikker på, at du vil slette posteringerne fra afregningen? Handlingen kan ikke fortrydes.',
        adjustments: 'Justeringer',
        billingPrevented: 'Afventende afregninger',
        billingStartDate: 'Start afregning af indbetalinger fra',
        appendix: 'Bilag',
        readyForBilling: 'Klar til afregning',
        awaitingCaseEnd: 'Afventer sagsafslutning',
        appendixMissing: 'Mangler bilag',
        billSelected: 'Afregn valgte',
        addBillingVoucher: 'Tilføj postering',
        recipient: 'Modtager',
        billingSent: 'Afsendt',
        sendBilling: 'Afsend',
        information: 'Information',
        addedToPayouts: 'Tilføjet til udbetalinger',
        addToPayouts: 'Tilføj til udbetalinger',
        invoiceNo: 'Fakturanr.',
        specifiedByBankTransfer: 'bedes angivet ved bankoverførsel',
        paymentTerms: 'Betalingsbetingelser: Netto',
        daysAndBillingDate: 'dage - Forfaldsdato',
        billingAlreadySentAlert: 'Afregningen er allerede afsendt. Er du sikker på, at du vil sende afregningen igen?',
        amountWillBeWithdrawnToAccount: 'udbetales til bankkonto',
        amountShouldBePaidToAccount: 'indbetales på bankkonto',
        preview: 'Forhåndsvisning',
        PDFPreview: 'PDF',
        ExcelPreview: 'Excel',
        forPayout: 'Til udbetaling',
        collectionCommission: 'Inddrivelseshonorar',
        fees: 'Honorarer',
        otherVat: 'Anden moms',
        subtotal: 'Subtotal',
        total: 'Total',
        billingCollectionBillingSequentialId: 'Id',
        billingCollectionBillingDate: 'Dato',
        billingCollectionBillingAddedToPayouts: 'Tilføjet til udbetalinger',
        billingCollectionBillingSent: 'Afsendt',
        billingCollectionBillingBalance: 'Kreditorbevægelse',
        billingsAppendix: 'Bilag',
        billingsType: 'Type',
        billingsCreditor: 'Kreditor',
        billingsCases: 'Sager',
        billingsCurrency: 'Valuta',
        generateAppendix: 'Generér bilag',
        awaitingGeneration: 'Posteringer klar til bogføring',
        warnThisWillAffectBilling: 'Denne handling vil påvirke allerede afregnede indbetalinger. Er du sikker på, at du vil fortsætte?',
        deletionWarning: 'Er du sikker på, at du vil slette denne afregning? Denne handling kan ikke fortrydes. Vær opmærksom på, at sletningen ikke håndterer justeringer – disse skal du selv tage dig af manuelt. Desuden tages der ikke højde for, om afregningen allerede er udsendt eller bogført.',
    },
    creditorBilling: {
        newBillingFrom: 'Ny afregning fra',
        dear: 'Kære',
        herebyForwarded: 'Hermed fremsendes:',
        seeAttached: 'Se venligst vedhæftede.',
    },
    bookkeeping: {
        settleAll: 'Afregn alle kreditorer',
        preview: 'Forhåndsvisning',
        type: 'Type',
        date: 'Dato',
        text: 'Tekst',
        amount: 'Beløb',
        account: 'Konto',
        contraAccount: 'Modkonto',
        debtorVoucher: 'Debitorpostering',
        showMoreVouchers: 'Vis flere posteringer',
        showing: 'Viser',
        of: 'ud af',
        vouchers: 'posteringer',
        exportNdownload: 'Eksportér og download',
        history: 'Historie',
        noHistorical: 'Ingen historisk data',
    },
    blameLogs: {
        overview: 'Overblik',
        userVisits: 'Brugerbesøg',
        debtorUpdates: 'Debitorændringer',
        economy: 'Økonomi',
        interactions: 'Interaktioner',
        noEntries: 'Ingen handlinger',
        blameLog: 'Handlingslog',
        logged: 'Handling',
        ago: 'siden',
        type: 'Type',
        content: 'Indhold',
        subject: 'Emne',
        stepTitle: 'Step titel',
        chainTitle: 'Workflow titel',
        viewLetter: 'Se brev',
        phoneNumber: 'Telefon nummer',
        label: 'Label',
        workflow: 'Workflow',
        noLogs: 'Endnu ingen logs',
        settings: 'Indstillinger',
        toggled: 'Skiftet til',
        trueActivated: 'aktiveret',
        falseActivated: 'deaktiveret',
        key: 'Nøgle',
        code: 'Kode',
        username: 'Brugernavn',
        password: 'Adgangskode',
        trueChanged: 'Ændret',
        falseChanged: 'Uændret',
        experianClientId: 'Experian klientnummer',
        to: 'til',
        when: 'Hvornår',
        procedure: 'Genvej',
        removed: 'Fjernet',
        other: 'Andre handlinger',
        description: 'Beskrivelse',
        note: 'Note',
        createdAt: 'Oprettet',
        trueYes: 'Ja',
        falseNo: 'Nej',
        dunning: 'Dunning',
        connectorBillingModel: 'Afregningsmodel',
    },
    blameLogSimplfiedType: {
        [BlameLogType.CaseVisit]: 'Sagsbesøg',
        [BlameLogType.CaseVoucherDelete]: 'Postering slettet',
        [BlameLogType.UnknownCaseVoucherMapped]: 'Uidentificerbar indbetaling tilføjet',
        [BlameLogType.CaseVoucherPatch]: 'Postering opdateret',
        [BlameLogType.UserOnCustomerVisit]: 'Kundebesøg',
        [BlameLogType.CreditorVisit]: 'Kreditorbesøg',
        [BlameLogType.VisitedBy]: 'Besøg',
        [BlameLogType.CaseVoucherIrrecoverable]: 'Postering uerholdelig',
        [BlameLogType.CaseVoucherExpired]: 'Postering forældet',
        [BlameLogType.InteractionDelete]: 'Interaktion slettet',
        [BlameLogType.InteractionRollback]: 'Interaktion tilbagerullet',
        [BlameLogType.WorkflowRollback]: 'Workflow tilbagerullet',
        [BlameLogType.InteractionHideFromClient]: 'Interaktion skjult for kreditor',
        [BlameLogType.DebtorWebLoginEId]: 'Login på debitorweb med e-ID',
        [BlameLogType.DebtorUpdateName]: 'Navn ændret',
        [BlameLogType.DebtorUpdatePhone]: 'Telefon ændret',
        [BlameLogType.DebtorUpdateAddress]: 'Adresse ændret',
        [BlameLogType.DebtorUpdateEmail]: 'Email ændret',
        [BlameLogType.DebtorUpdateCourt]: 'Retskreds ændret',
        [BlameLogType.DebtorUpdateBirthdate]: 'Fødselsdag ændret',
        [BlameLogType.DebtorUpdateCVR]: 'CVR ændret',
        [BlameLogType.DebtorUpdateCPR]: 'CPR ændret',
        [BlameLogType.AKSConfiguration]: 'AKS-konfiguration',
        [BlameLogType.RKIAuto]: 'Automatisk RKI',
        [BlameLogType.RKIIgnoreOppositions]: 'Ignorer RKI-indsigelser',
        [BlameLogType.RKIDeleteOnCaseEnd]: 'Slet automatisk RKI registrering ved sagsafslutning',
        [BlameLogType.RKIOpen]: 'Åben RKI',
        [BlameLogType.AKSClientID]: 'Experian klientnummer',
        [BlameLogType.RKIOveride]: 'Overskriv auto RKI',
        [BlameLogType.AKSActivated]: 'AKS aktiveret',
        [BlameLogType.PriceList]: 'Prisliste',
        [BlameLogType.UserPasswordUpdate]: 'Brugers kodeord ændret',
        [BlameLogType.TriggerShortcut]: 'Trigger-ændring',
        [BlameLogType.WorkflowChange]: 'Workflow-ændring',
        [BlameLogType.DeleteUpdate]: 'Opgave slettet',
        [BlameLogType.ConnectorBillingUpdate]: 'Afregningsmodel ændret',
        [BlameLogType.CreditorSettingsUpdate]: 'Kreditorindstillinger ændret',
        [BlameLogType.BulkAction]: 'Massebehandling',
    },
    caseTypes: {
        [CaseType.CLIENT]: 'Kreditorsag',
        [CaseType.TENANT]: 'Tenantsag',
    },
    cases: {
        case: 'Sag',
        customerReferenceId: 'Referencenr.',
        creditor: 'Kreditor',
        debt: 'Oprindelig',
        deposits: 'Indbetalt',
        balance: 'Gæld',
        status: 'Sagsstatus',
        caseVoucher: 'Postering',
        amount: 'Beløb',
        workflow: 'Workflow',
        responsible: 'Ansvarlig',
        showAll: 'Vis alle',
        caseInfo: 'Sagsinformation',
        cases: 'Sager',
        createNewCase: 'Opret sag',
        caseOverview: 'Alle sager',
        casesLeft: 'Sager tilbage',
        casePaused: 'Sag i bero',
        dueDateIsIn: 'Næste opgave udføres om',
        days: 'dage',
        pressCommandOrCtrlToContinue: 'Tryk command eller control for også at fortsætte sagen.',
        source: 'Kilde',
        sourceClient: 'Sagen oprinder fra denne dunning-sag',
        referenceId: 'Kreditors sagsreferencenummer (f.eks. et kundenummer eller et patientnummer)',
        createdAt: 'Oprettelsesdato',
        caseState: {
            [CaseState.ALL]: 'Alle sager',
            [CaseState.ACTIVE]: 'Aktive sager',
            [CaseState.CLOSED]: 'Lukkede sager',
        },
        caseStatus: {
            [CaseStatus.VERIFIED]: 'Godkendt',
            [CaseStatus.PENDING]: 'Ny sag',
            [CaseStatus.ENDED]: 'Afsluttet',
        },
        VERIFIED: 'Godkendt',
        PENDING: 'Ny sag',
        ENDED: 'Afsluttet',
        verify: 'Godkend',
        end: 'Afslut',
        reVerify: 'Godkend igen',
        endCase: 'Afslut sag',
        choosEndReason: 'Vælg en afslutningsårsag',
        caseGroup: 'Sagsgruppe',
        pause: 'Pause',
        pauseCase: 'Sæt sag på pause',
        pauseReason: 'Pauseårsag',
        pauseComment: 'Eventuel kommentar',
        dunning: 'Dunning',
        debtCollection: 'Inkasso',
        blameLog: 'Handlingslog',
        logged: 'Handling',
        ago: 'siden',
        newCase: 'Opret sag',
        caseReferenceId: 'Kreditors sagsreferencenummer (f.eks. et kundenummer)',
        file: 'Fakturafil',
        debtorName: 'Navn',
        address: 'Adresse',
        phone: 'Telefonnummer',
        email: 'Email',
        cpr: 'CPR',
        cvr: 'CVR',
        debtorHaveObjections: 'Debitor har gjort indsigelse',
        isCompany: 'Debitor er en virksomhed',
        theDetails: 'Info',
        theDebt: 'Kravet',
        theDebtor: 'Debitor',
        manual: 'Manuel',
        fromFile: 'Fra fil',
        dropFile: 'Træk faktura herhen',
        clickHereToUpload: 'Eller upload',
        addDebt: 'Ny faktura',
        issueDate: 'Fakturadato',
        dueDate: 'Forfaldsdato',
        sendNoteToCollector: 'Send besked til inddriver',
        sendNoteToCollectorButton: 'Send besked',
        note: 'Note',
        caseHasBeenDeleted: 'Sagen er blevet slettet',
        missingCreateAccess: 'Aftalen er ophørt, og der kan derfor ikke oprettes nye sager. Kontakt os for nærmere information',
        newCaseCreate: 'Stamdata',
        newCaseEconomy: 'Økonomi',
        newCaseDone: 'Færdig',
        noDebts: 'Ingen krav',
        noDebtsExplainer: "Tilføj krav med '+' knappen",
        newCaseCreateExplainer: 'Du er nu i gang med at oprette en ny sag. Her kan du indsætte kundenummeret fra jeres system.',
        newCaseEconomyExplainer: 'Din sag er nu oprettet, og herunder skal sagens økonomi tilføjes.',
        newCaseCreationWarning: 'Når du klikker dig videre vil sagen være oprettet i systemet. Har du ikke alle informationer til at oprette sagen, anbefales det du ikke fortsætter før du har al information om gælden og skyldner',
        deleteCase: 'Slet sag',
        sureYouWantToDeleteCase: 'Er du sikker på at du vil slette denne sag?',
    },
    mergeCases: {
        header: 'Sammenlæg sagen med en anden',
        explanation: 'Sammenlæg denne sag med den forneden valgte sag. Posteringer vil blive flyttet til den valgte sag, og denne sag vil blive lukket med status "Sagen er lagt sammen med en anden".',
        searchPlaceholder: 'Søg efter sager på samme kreditor',
        mergeBtn: 'Sammenlæg sager',
        undoCaseMerge: 'Fortryd sammenlægning',
    },
    customers: {
        addParty: 'Tilføj part',
        contact: 'Kontaktperson',
        selectType: 'Vælg type',
        errorEmailValidation: 'Ugyldig email',
        errorCPRValidation: 'Ugyldigt CPR-nummer',
        errorCVRValidation: 'Ugyldigt CVR-nummer',
        noContactSelected: 'Ingen kontaktperson valgt',
        noContact: 'Ingen kontaktperson',
        noRelatedCases: 'Ingen relaterede sager',
        customer: 'Kunde',
        createdAt: 'Oprettet',
        casesOnCreditor: 'Sager på kreditor',
        thatIsRelatedTo: 'som er tilknyttet kundenummer',
        casesRelatedToCustomerDescription: 'Sager som er matchet på email, CPR, CVR eller via eksterne kilder.',
        information: 'Information',
        casesOnCustomer: 'Sager på kunden',
        relatedCases: 'Relaterede sager',
        caseStatus: 'Status',
        relationType: 'Relation',
        creditor: 'Kreditor',
        case: 'Sag',
        parties: 'Parter',
        customerReferenceId: 'Referencenummer (eksempelvis et kunde-, klient- eller patientnummer)',
        private: 'Privatperson',
        company: 'Virksomhed',
        existingCustomer: 'Eksisterende kunde',
        backToCase: 'Tilbage til sag',
        referenceId: 'Referencenummer',
        alternativeContactReferenceId: 'Repræsentantens journalnummer',
        secondaryEntityDisabled: 'Inaktiveret',
        addSecondaryEmails: 'Tilføj en eller flere sekundære emails',
        note: 'Evt. note',
        addSecondaryEmail: 'Tilføj sekundær email',
        addSecondaryPhones: 'Tilføj en eller flere sekundære telefonnumre',
        addSecondaryPhone: 'Tilføj sekundært telefonnummer',
        enabled: 'Aktiv',
        save: 'Gem',
    },
    customerCaseRelationType: {
        [RelationType.CPR]: 'CPR',
        [RelationType.CVR]: 'CVR',
        [RelationType.Cosmo]: 'Ekstern',
        [RelationType.CustomerReferenceId]: 'Kunderef.',
        [RelationType.Email]: 'Email',
        [RelationType.NameAddress]: 'Navn/adr.',
    },
    debtors: {
        private: 'Privat',
        company: 'Erhverv',
        addAlternativeContact: 'Tilføj repræsentant',
        alternativeContact: 'Repræsentant',
        debtor: 'Debitor',
        ownsCompany: 'Ejer virksomhed',
        ownsCompanies: 'Ejer virksomheder',
        movedAbroad: 'Flyttet udenlands',
        rkiRegistrations: 'RKI-registreringer',
        companyStatus: 'Virksomhedsstatus',
        otherCasesOnDebtorTooltip: 'Debitor er associeret med flere sager',
        otherCasesOnDebtorPlural: 'Andre sager',
        otherCasesOnDebtor: 'Anden sag',
        movedTo: 'Flyttet til',
        debtors: 'Debitorer',
        aksFailed: 'AKS fejlede',
        cprStatus: 'CPR-status',
        status: {
            [PrivateStarCycle.Active]: 'Aktiv',
            [PrivateStarCycle.Dead]: 'Død',
            [PrivateStarCycle.Disappeared]: 'Forsvundet',
            [PrivateStarCycle.Homeless]: 'Hjemløs',
            [PrivateStarCycle.GoneAway]: 'Flyttet udenlands',
            [PrivateStarCycle.ForTaxReason]: 'Skattepersonnummer',
            [PrivateStarCycle.NotVerified]: 'Ikke verificeret',
            [CompanyStarCycle.Inactive]: 'Inaktiv',
            [CompanyStarCycle.OperationsCeased]: 'Ophørt',
            [CompanyStarCycle.ShelfCompany]: 'Skuffeselskab',
        },
        dissolvedStatus: {
            [DissolvedStatus.UnderLiquidation]: 'Trådt i likvidation',
            [DissolvedStatus.DissolvedAfterLiquidation]: 'Opløst efter likvidation',
            [DissolvedStatus.InvoluntaryDissolution]: 'Under tvangsopløsning',
            [DissolvedStatus.Dissolved]: 'Opløst',
        },
        dissolutionStatus: 'Opløsningsstatus',
        addressProtection: 'Beskyttet navn og adresse',
        addressProtectionShort: 'Beskyttet',
        addDebtor: 'Tilføj debitor',
        guardian: 'Værge',
    },
    emailValidations: {
        risk: 'Risiko',
        emailRisk: 'Emailrisiko',
        didYouMean: 'Mente du',
        isDisposableAddress: 'Engangsemail',
        isRoleAddress: 'Er en fælles-email',
        high: 'Høj',
        medium: 'Medium',
        low: 'lav',
        unknown: 'Ukendt',
        no_mx: 'Ingen MX opsætning',
        unknown_provider: 'Ukendt mailudbyder',
        high_risk_domain: 'Højrisikodomæne',
        subdomain_mailer: 'Subdomæne mailadresse',
        immature_domain: 'Domænet er nyoprettet',
        tld_risk: 'Domænet er registreret som højrisiko',
        mailbox_does_not_exist: 'Emailen findes ikke',
        mailbox_is_disposable_address: 'Emailen er en engangsemail',
        mailbox_is_role_address: 'Er en fælles-email',
        catch_all: 'Catch all',
        long_term_disposable: 'Længerevarende engangsemail',
    },
    phoneValidation: {
        mobile: 'Mobil',
        landline: 'Fastnet',
        landline_premium: 'Fastnet',
        landline_tollfree: 'Fastnet',
        virtual: 'Virtuel',
        unknown: 'Ukendt',
        pager: 'Pager',
        roaming: 'Roaming',
    },
    debtorInfo: {
        debtorInfo: 'Debitor info',
        debtorCreatedAt: 'Debitor oprettet d.',
        company: 'Virksomhed',
        male: 'Mand',
        female: 'Kvinde',
        private: 'Privat',
        activated: 'Aktiveret',
        subscribed: 'tilmeldt',
        failed: 'Fejlede',
        movedTo: 'Flyttet til',
        description: 'Beskrivelse',
        addDescription: 'Tilføj beskrivelse',
        name: 'Navn',
        email: 'Email',
        noEmailAddr: 'Ingen emailadresse',
        phone: 'Telefon',
        noAddr: 'Ingen adresse',
        address: 'Adresse',
        letterReturned: 'Brev kunne ikke leveres på adressen',
        cpr: 'CPR',
        cvr: 'CVR',
        addressProtection: 'Adresse- og navnebeskyttet',
        addressProtectionShort: 'Beskyttet',
        jurisdiction: 'Retskreds',
        noJurisdiction: 'Ingen retskreds',
        chooseJurisdiction: 'Vælg retskreds',
        status: {
            [PrivateStarCycle.Active]: 'Aktiv',
            [PrivateStarCycle.Dead]: 'Død',
            [PrivateStarCycle.Disappeared]: 'Forsvundet',
            [PrivateStarCycle.Homeless]: 'Hjemløs',
            [PrivateStarCycle.GoneAway]: 'Flyttet udenlands',
            [PrivateStarCycle.ForTaxReason]: 'Skattepersonnummer',
            [PrivateStarCycle.NotVerified]: 'Ikke verificeret',
            [CompanyStarCycle.Inactive]: 'Inaktiv',
            [CompanyStarCycle.OperationsCeased]: 'Ophørt',
            [CompanyStarCycle.ShelfCompany]: 'Skuffeselskab',
        },
        dissolvedStatus: {
            [DissolvedStatus.UnderLiquidation]: 'Trådt i likvidation',
            [DissolvedStatus.DissolvedAfterLiquidation]: 'Opløst efter likvidation',
            [DissolvedStatus.InvoluntaryDissolution]: 'Under tvangsopløsning',
            [DissolvedStatus.Dissolved]: 'Opløst',
        },
        dissolutionStatus: 'Opløsningsstatus',
        save: 'Gem',
        remove: 'Fjern',
        birthdate: 'Fødselsdato',
        noBirthdate: 'Ingen fødselsdato',
        yearsOld: 'år gammel',
        companyForm: 'Virksomhedsform',
        industry: 'Branche',
        employees: 'Ansatte',
        companyStatus: 'Virksomhedsstatus',
        website: 'Hjemmeside',
        dateOfFoundation: 'Stiftelsesdato',
        quantifyOfPUnits: 'Antal P-Enheder',
        powerToBind: 'Tegningsregel',
        adProtected: 'Reklamebeskyttet',
        cars: 'Biler',
        from: 'Fra',
        liabilities: 'Hæftelser',
        priority: 'Prioritet',
        interest: 'Rente',
        properties: 'Ejendomme',
        toilet: 'Toilet',
        roof: 'Tag',
        bath: 'Bad',
        built: 'Bygget',
        rkiRegis: 'RKI-registreringer',
        administrator: 'Administrator',
        disclosureDate: 'Videregivelsesdato',
        deleted: 'slettet',
        toBedeleted: 'slettes',
        companyRelations: 'Virksomhedsrelationer',
        roles: 'Roller',
        accountableParticipant: 'Fuldt ansvarlig deltager',
        director: 'Direktør',
        executiveBoard: 'Direktion',
        beneficialOwner: 'Reel ejer',
        founder: 'Stifter',
        owner: 'Ejer',
        stakeholder: 'Interessent',
        chairperson: 'Bestyrelsesformand',
        managingDirector: 'Adm. direktør',
        boardMember: 'Bestyrelsesmedlem',
        equityTier: 'Kapitalklasse',
        viceChairperson: 'Næstformand',
        rightToVote: 'Stemmeret',
        audit: 'Revision',
        specialOwnership: 'Særlige Ejerforhold',
        previous: 'Tidligere',
        noPreviousToShow: 'Ingen tidligere at vise',
        backTo: 'Tilbage til',
        casesOnThisDebtor: 'Sager vedrørende denne debitor',
        guardianName: 'Værge navn',
        guardianAddress: 'Værge adresse',
        guardianStartDate: 'Værge startdato',
    },
    debtorWebHome: {
        dear: 'Kære',
        representative: 'Vi har registreret at du er indtrådt som repræsentant for debitor.',
        you: 'Du',
        debtor: 'Debitor',
        owe: 'skylder',
        to: 'til',
        youCanDoThisHere: 'Her kan du betale, anmode om en afdragsordning og ændre dine kontaktoplysninger. Du er også velkommen til at sende os en besked, hvis du har spørgsmål.',
        yourInfo: 'Dine informationer',
        name: 'Navn',
        informName: 'Oplys navn',
        email: 'Email',
        informEmail: 'Oplys email',
        phone: 'Telefon',
        informPhone: 'Oplys telefonnummer',
        address: 'Adresse',
        cpr: 'CPR',
        cvr: 'CVR',
        informAddress: 'Oplys adresse',
        confirmation: 'Jeg godkender at mine informationer er korrekte.',
        updateButton: 'Opdater information',
        confirm: 'Bekræft',
        faq: 'Ofte stillede spørgsmål',
        contactUs: 'Kontakt os',
        contactUsText: 'Du er altid velkommen til at kontakte os pr. email, telefon eller vha. nedenstående felt.',
        yourMessage: 'Din besked',
        enterEmail: 'Indtast email for at kunne sende en besked',
        send: 'Send',
        logout: 'Log ud',
        privacyPolicy: 'Privatlivspolitik',
        businessTerms: 'Forretningsbetingelser',
        paymentMethods: 'Betalingsmetoder',
        payWithFI: 'Betal med FIK-nummer',
        paySafeWithFI: 'Betal sikkert med dit FIK-nummer fra din bank:',
        payWithIBAN: 'Betal med IBAN',
        paySafeWithIBAN: 'Betal sikkert via IBAN fra din bank:',
        payWithSWIFT: 'Betal med SWIFT',
        paySafeWithSWIFT: 'Betal sikkert via SWIFT fra din bank:',
        payWithBankTransfer: 'Lav en bankoverførsel',
        payWithBankTransferText: 'Lav en bankoverførsel til vores bankkonto ved hjælp af informationerne herunder:',
        registrationNumber: 'Reg.nr.',
        accountNumber: 'Kontonr.',
        payWithBankTransferInfo: 'Husk at henvis til j.nr.',
        or: 'Eller',
        iApprove: 'Jeg godkender',
        theBusinessTerms: 'forretningsbetingelserne',
        pleaseAcceptBusinessTerms: 'Du skal godkende forretningsbetingelserne, før du kan gå til betalingssiden.',
        payWithCardButton: 'Gennemfør betaling',
        createAPaymentPlan: 'Opret afdragsordning',
        fullPayment: 'Fuld betaling',
        partialPayment: 'Delvis betaling',
    },
    debtorWebPaymentPlans: {
        backToCase: 'Tilbage til sagen',
        paymentPlanOn: 'Afdragsordning på sag',
        selectPlan: 'Vælg afdragsordning',
        sign: 'Underskriv aftale',
        gatherInfo: 'Indtast informationer',
        paymentMethod: 'Vælg betalingsmetode',
        approval: 'Bekræftelse',
        info: 'Info',
        paymentPlan: 'Afdragsordning',
        firstPayment: 'Første afdrag',
        entry: 'afdrag',
        lastPayment: 'Sidste afdrag',
        signedDoc: 'Underskrevet dokument',
        needHelp: 'Brug for hjælp?',
        orPay: 'Eller betal hele gælden',
        pay: 'Betal hele gælden',
        months: 'Måneder',
        month: 'måned',
        total: 'Total tilbagebetaling',
        select: 'Vælg',
        noOptions: 'Vi kan desværre ikke indgå en afdragsordning.',
        signTextOne: 'For at indgå en afdragsordning med',
        signTextTwoAlternativeContact: 'skal debitor underskrive en aftale.',
        signTextTwoDebtor: 'skal du underskrive en aftale.',
        signTextThree: 'For at indgå afdragsordningen, har vi brug for nogle flere informationer.',
        agreement: 'Underskriv aftale',
        approvalText: 'Tillykke! Du har indgået en afdragsordning.',
        paymentMethodText: 'Vi passer godt på dine oplysninger og gør det nemt for dig at tilmelde automatisk betaling.',
        connectCard: 'Tilknyt betalingsmetode',
        automaticPaymentMethod: 'Automatisk betalingsmetode',
        deleteCardToChange: 'Du kan fjerne/ændre det valgte kort ved at klikke på fjern kort knappen.',
        deleteCard: 'Fjern kort',
        paymentPlanEntries: 'Afdrag',
        amount: 'Beløb',
        date: 'Dato',
        status: 'Status',
        statusCode: {
            [PaymentPlanEntryStatus.SETTLED]: 'Betalt',
            [PaymentPlanEntryStatus.CANCELED]: 'Misligholdt',
            [PaymentPlanEntryStatus.PENDING]: 'Afventer',
            [PaymentPlanEntryStatus.REMINDED]: 'Påmindet',
            [PaymentPlanEntryStatus.AWAITING]: 'Afventer',
            [PaymentPlanEntryStatus.OVERDUE]: 'Frist overskredet',
            [PaymentPlanEntryStatus.ERRORSETTLED]: 'Fejlslagen korttræk',
        },
    },
    paymentPlanEntryStatuses: {
        [PaymentPlanEntryStatus.SETTLED]: 'Betalt',
        [PaymentPlanEntryStatus.CANCELED]: 'Misligholdt',
        [PaymentPlanEntryStatus.PENDING]: 'Afventer',
        [PaymentPlanEntryStatus.REMINDED]: 'Påmindet',
        [PaymentPlanEntryStatus.AWAITING]: 'Afventer',
        [PaymentPlanEntryStatus.OVERDUE]: 'Frist overskredet',
        [PaymentPlanEntryStatus.ERRORSETTLED]: 'Fejlslagen korttræk',
    },
    chains: {
        nextStep: 'Næste skridt',
    },
    chainGroups: {
        dunningChain: 'Dunningworkflow',
        chain: 'Workflow',
        add: 'Tilføj',
        delete: 'Slet',
        configure: 'Konfigurer workflows for sagsgrupper',
        caseGroup: 'Sagsgruppe',
    },
    migration: {
        migrateData: 'Migrer data',
        modalHeader: 'Migrer data',
        uploadErrorMessage: 'Der skete en fejl, tjek at filen er korrekt og prøv igen',
    },
    creditorStateDescriptions: {
        [CreditorState.Lead]: 'Til kreditorer som er under opsætning, men endnu ikke har fået adgang til kreditorwebbet.',
        [CreditorState.SignedOn]: 'Til kreditorer som endnu ikke er kunder, men som gerne vil have en demo af kreditorwebbet.',
        [CreditorState.Active]: 'Til aktive kreditorer som uploader sager og har fuld adgang til kreditorwebbet.',
        [CreditorState.Ceased]: 'Til kreditorer som er opsagte, men som stadig skal kunne følge med i eksisterende sager.',
        [CreditorState.Cancelled]: 'Til kreditorer som er opsagte og som ikke længere skal have adgang til kreditorwebbet.',
    },
    creditors: {
        creditor: 'Kreditor',
        creditors: 'Kreditorer',
        creditorInfo: 'Kreditorinformation',
        allCreditors: 'Alle kreditorer',
        newCreditorInfo: 'Kreditorinformation',
        newCreditorEconomy: 'Økonomi',
        newCreditorChains: 'Workflows',
        newCreditorUsers: 'Brugere',
        newCreditorDone: 'Færdig',
        states: {
            [CreditorState.Active]: 'Aktiv',
            [CreditorState.Lead]: 'Lead',
            [CreditorState.SignedOn]: 'Registreret',
            [CreditorState.Cancelled]: 'Annulleret',
            [CreditorState.Ceased]: 'Ophørt',
        },
        downloadOverview: 'Download overblik',
        newCreditor: 'Ny kreditor',
        defaultBillingModelDescription: 'Vælg hvilken afregningsmodel nye sager skal oprettes i. Hver sag kan have hver sin afregningsmodel. Ved oprettelsen af en sag vil sagen blive tilknyttet standard afregningsmodellen.',
        tenantInheritedBillingModelDescription: 'Hvis ikke du vælger en afregningsmodel, vil nye sager blive oprettet med din tenant-standard',
        tenantInheritedDunningConnectorDescription: 'Hvis ikke du vælger en afregningsmodel, vil nye sager blive oprettet med din tenant-dunning-standard',
        chainsHeader: 'Valg af standardworkflows',
        chainsDescription: 'Vælg hvilket workflow nye sager skal oprettes i. Hver sag kan have hver sit workflow. Ved oprettelsen af en sag, vil sagen blive tilknyttet kreditorens standardworkflow. Du kan vælge et standardworkflow for både dunning-sager, men også for normale sager.',
        usersNewHeader: 'Opret adgang til kreditor',
        usersCreditorHeader: 'Vælg ansvarlige',
        setCreditorState: 'Skift kreditors stadie',
        next: 'Næste',
        previous: 'Forrige',
        cvr: 'CVR',
        company: 'Virksomhed',
        person: 'Person',
        vatRegistered: 'Momsregistreret',
        notVatRegistered: 'Ikke momsregistreret',
        acquisitionResponsible: 'Akkvisitionsansvarlig',
        selectAcquiRespon: 'Vælg akkvisitionsansvarlig',
        contact: 'Kontaktperson hos kreditor',
        selectContact: 'Vælg kontaktperson hos kreditor',
        caseworkerContact: 'Sagsbehandlerkontakt',
        selectCaseworkerContact: 'Vælg Sagsbehandlerkontakt',
        none: 'Ingen',
        createCreditor: 'Opret kreditor',
        reference: 'Kreditorreference (f.eks. et kundenummer fra dit ERP-system)',
        name: 'Navn',
        selectDefaultCollector: 'Vælg standard inddriver',
        status: 'Status',
        active: 'Aktiv',
        lead: 'Lead',
        selectClientContact: 'Vælg kreditorkontakt',
        isCompany: 'Kreditor er en virksomhed',
        create: 'Opret',
        createdAt: 'Oprettelsesdato',
        quantityCases: 'Antal sager',
        referenceId: 'Nr.',
        wincentAvgPrediction: 'Wincent gennemsnitlig score',
        selectDefaultChain: 'Vælg standardworkflow',
        defaultChain: 'Workflow',
        selectDefaultClientChain: 'Vælg standard dunningworkflow',
        defaultClientChain: 'Dunningworkflow',
        mandates: 'Mandater',
        mandatesPlaceholder: 'Tom',
        experianClientId: 'Experian klientnummer',
        updateExperianClientId: 'Opdater klientnummer',
        requestClientIdExperian: 'Anmod Experian om klientnummer',
        requestClientIdExperianSuccess: 'Experian er nu anmodet og vil automatisk indtaste klientnummeret.',
        erpLink: 'Link til kreditors ERP-system',
        updateErpLink: 'Opdater link',
        aksEnabled: 'AKS aktiveret',
        advokatindestaaelse: 'Advokatindeståelse til åben RKI',
        bankAccountDetails: 'Bankkontodetaljer',
        updateBankAccountDetails: 'Opdater konto',
        autoRKI: 'Auto-RKI',
        automaticDebtRegister: 'Overskriv automatisk registrering i RKI',
        useAutomaticDebtRegister: 'Vælg automatisk registrering i RKI på kreditorniveau',
        useAutoRKIOpen: 'Vælg Åben RKI på kreditorniveau',
        useAutoRKIIgnoreUnresolvedOppositions: 'Vælg ignorer uafklarede interaktioner (indsigelser) på kreditorniveau',
        selfCollection: 'Egeninkasso',
        useSelfCollectionOption: 'Vælg egeninkasso på kreditorniveau',
        outboundCall: 'Udgående opkald',
        useOutboundCallOption: 'Vælg udgående opkald på kreditorniveau',
        autoVerify: 'Automatisk godkendelse af sager',
        useAutoVerifyOption: 'Vælg automatisk godkendelse på kreditorniveau',
        paymentTerms: 'Kreditors betalingsbetingelser',
        paymentDays: 'Betalingsfrist',
        billingRecipients: 'Kreditors modtagere af afregninger',
        billingRecipientsDescription: 'Indtast flere emails på følgende måde',
        automaticExpireVouchers: 'Overskriv automatisk forældelse af posteringer',
        useAutomaticExpireVouchers: 'Vælg automatisk forældelse af posteringer på kreditorniveau',
        configurationOptions: 'Konfigurationer',
        experianConfig: 'Experian konfigurationer',
        foundationExpiration: 'Forældelse med fundament',
        normalExpiration: 'Forældelse uden fundament',
        interestExpiration: 'Rente forældelse',
        courtSubmitConfig: 'Konfiguration af automatisk retslig indlevering',
        debtorFAQ: 'Ofte stillede spørgsmål (vises i debitorweb)',
        faqHeader: 'Brug for hjælp til at oprette en kreditor?',
        faqText: 'Vi har skrevet en artikel, som kan hjælpe dig i gang med at oprette kreditorer.',
        newUserDisabled: 'Nye brugere kan ikke oprettes med nuværende kreditor status',
        cancelledError: 'Adgang annulleret',
        cancelledErrorMessage: 'Din adgang er annulleret. Kontakt os for mere information.',
        eInvoice: {
            eInvoice: 'E-faktura',
            companyId: 'Firma id',
            identification: 'Identifikationsnummer',
            addChildCompany: 'Tilføj som child company',
        },
    },
    collectorTypes: {
        [CollectorType.CREDITOR]: 'Kreditor',
        [CollectorType.TENANT]: 'Inddriver',
    },
    collectors: {
        collector: 'Inddriver',
        updateEntity: 'Gem',
        masterData: 'Stamdata',
        layout: 'Layout',
        websites: 'Websites',
        legal: 'Juridisk',
        paymentOptions: 'Betalingsmuligheder',
        communicationChannels: 'Kommunikationskanaler',
        namePlaceholder: 'Navn',
        centralRegisterIdPlaceholder: 'CVR-nummer',
        nicknamePlaceholder: 'Kaldenavn',
        addressPlaceholder: 'Adresse',
        logoFileIdPlaceholder: 'Logo',
        letterFrontLogoFileIdPlaceholder: 'Logo til forsiden af breve',
        websitePlaceholder: 'Virksomhedens website',
        clientWebBasePlaceholder: 'Kreditorweb-base',
        debtorWebBasePlaceholder: 'Debitorweb-base',
        titlePlaceholder: 'Virksomhedstitel',
        privacyPolicyPlaceholder: 'Link til privatlivspolitik',
        businessTermsPlaceholder: 'Link til forretningsbetingelser',
        emailPlaceholder: 'Email',
        replyToPlaceholder: 'Reply-to email',
        phonePlaceholder: 'Telefonnummer',
        paymentOptionsPlaceholder: 'Betalingsmuligheder',
        themePlaceholder: 'Tema',
        hideEmail: 'Skjul email',
    },
    paymentPlans: {
        cannotOfferPaymentPlan: 'Vi kan desværre ikke tilbyde dig en afdragsordning online. Kontakt venligst inddriver.',
        paymentPlansDisabled: 'Afdragsordninger er slået fra',
        paymentPlan: 'Afdragsordning',
        customFoundation: 'Skylderklæring til afdragsordninger',
        customFoundationDescription: 'Vælg hvilken skabelon der skal bruges som skylderklæring i debitorwebbet. Er ingen skabelon valgt, vil en standardskylderklæring blive brugt.',
        skipTo: 'Udskyd til',
        collapsedEntries: 'skjulte afdrag',
        deletePaymentPlan: 'Slet afdragsordning',
        progress: 'Trin',
        selectPaymentPlan: 'Vælg afdragsordning',
        signPaymentPlan: 'Underskriv afdragsordning',
        selectPaymentMethod: 'Vælg betalingsmetode',
        confirmation: 'Bekræftelse',
        createNewPaymentPlan: 'Opret ny afdragsordning',
        months: 'måneder',
        month: 'måned',
        totalPayment: 'I alt at betale',
        createCustomPlan: 'Opret tilpasset afdragsordning',
        createStandardPlan: 'Opret standardafdragsordning',
        byAmount: 'Ud fra beløb',
        byDuration: 'Ud fra antal afdrag',
        monthly: 'Månedligt',
        everyOtherMonth: 'To måneder',
        quarterly: 'Kvartalvist',
        everyOtherWeek: 'To uger',
        weekly: 'Ugentligt',
        rest: 'Restbetaling',
        generate: 'Generér',
        entries: 'Afdrag',
        entry: 'Afdrag',
        date: 'Dato',
        reminder: 'Påmindelse',
        lastChanceOfPayment: 'Sidste chance',
        addedInterests: 'Yderligere renter',
        cancelled: 'Misligholdt',
        amount: 'Beløb',
        confirmationCheckbox: 'Send bekræftelse når afdragsordningen er aktiveret',
        activate: 'Aktivér',
        cancel: 'Annullér',
        agreement: 'Aftaledokument',
        inputAmount: 'Indtast det ønskede beløb.',
        details: 'Detaljer',
        createPaymentPlan: 'Opret afdragsordning',
        activatePaymentPlanWithoutFoundation: 'Aktivér afdragsordning uden fundament.',
        errorCaseEnded: 'Kan ikke oprette afdragsordning: sagen er afsluttet',
        CREATED: 'Oprettet',
        ACTIVE: 'Aktiv',
        FINISHED: 'Afsluttet',
        CANCELED: 'Annulleret',
        DELETED: 'Slettet',
        errorInInput: 'Fejl i din indtastning',
        save: 'Gem',
        calculationFoundation: 'Beløb eller antal afdrag',
        calculationFoundationDescription: 'Vælg afdragsordningens beregningsgrundlag. Enten et beløb eller antallet af afdrag.',
        calculateByAmount: 'Beregn hvert afdrag ud fra et beløb',
        calculateByDuration: 'Beregn afdragene ud fra antallet af ønskede afdrag',
        startDate: 'Startdato',
        startDateDescription: 'Betalingsdatoen for første afdrag.',
        upfrontPayment: 'Førstegangsydelse',
        upfrontPaymentDescription: 'Ønskes der en førstegangsydelse for at vise betalingsvilje kan dette slås til her.',
        upfrontPaymentDate: 'Dato for førstegangsydelse',
        interval: 'Interval',
        intervalDescription: 'Vælg hvor langt der skal gå mellem hvert afdrag.',
        interestFree: 'Rentefri periode',
        interestFreeDescription: 'Ønskes en rentefri periode kan denne opsættes her.',
        interestFreeFrom: 'Fra',
        interestFreeTo: 'Til',
        moreSettings: 'Flere indstillinger',
    },
    RKI: {
        registration: 'RKI-registrering',
        createNewRegistration: 'Foretag ny indberetning',
        newRegistration: 'Ny RKI-registrering',
        chooseDebtor: 'Vælg debitor',
        amount: 'Beløb',
        withFoundation: 'Med fundament',
        chooseFoundationType: 'Vælg fundamentstype',
        dateFoundation: 'Dato for fundament',
        status: 'Status',
        remark: 'Bemærkning',
        deleteReason: 'Sletteårsag',
        deleteCode: 'Slettekode',
        foundationCode: {
            [FoundationCode.betalingspåkrav1påtegning]: 'Betalingspåkrav 1. påtegning',
            [FoundationCode.betalingspåkrav2påtegning]: 'Betalingspåkrav 2. påtegning',
            [FoundationCode.stævning]: 'Stævning',
            [FoundationCode.fogedsag]: 'Fogedsag',
            [FoundationCode.dom]: 'Dom',
            [FoundationCode.insolvens]: 'Insolvenserklæring i anden sag',
            [FoundationCode.konkurs]: 'Konkurs',
            [FoundationCode.tvangsakkord]: 'Tvangsakkord, indledt',
            [FoundationCode.retsforlig]: 'Retsforlig',
            [FoundationCode.fogedretsrekv]: 'Fogedretsrekv',
            [FoundationCode.offentliginberetning]: 'Offentlig inberetning',
            [FoundationCode.tvangsauktion]: 'Tvangsauktion-fordring opgjort',
            [FoundationCode.tvangsauktionudlæg]: 'Tvangsauktion - udlæg',
            [FoundationCode.gældssanering]: 'Gældssanering, indledt',
            [FoundationCode.skylderklæring]: 'Skylderklæring',
            [FoundationCode.forlig]: 'Frivilligt forlig',
            [FoundationCode.speciel]: 'Speciel',
        },
        state: {
            [RKIStates.REPORTED]: 'INDBERETTET',
            [RKIStates.ERROR]: 'FEJLET',
            [RKIStates.PUBLISHED]: 'PUBLISERET',
            [RKIStates.DELETED]: 'SLETTET',
            [RKIStates.CONCLUDED]: 'AFSLUTTET',
        },
        registry: {
            [RKIRegistries.OPEN]: 'ÅBEN',
            [RKIRegistries.CLOSED]: 'LUKKET',
        },
        latestWarningDate: 'Dato for sidste varsel',
        autoRKI: {
            errors: {
                [RKIRegistrationError.AlreadyRegistered]: 'Debitor er allerede registreret',
                [RKIRegistrationError.MissingWarning]: 'Mangler RKI varsel',
                [RKIRegistrationError.WrongCurrency]: 'Valuta er ikke DKK',
                [RKIRegistrationError.WarningLetterWasReturned]: 'RKI varsel (brev) blev returneret',
                [RKIRegistrationError.EmailWarningWasNeverDelivered]: 'RKI varsel (email) blev aldrig leveret',
                [RKIRegistrationError.WarningIsOlderThanOneYear]: 'RKI varsel er ældre end 1 år gammel',
                [RKIRegistrationError.FoundationCouldNotBeMapped]: 'Fundamentskode kunne ikke identificeres',
                [RKIRegistrationError.FoundationDateCouldNotFound]: 'Fundamentsdato kunne ikke findes',
                [RKIRegistrationError.UnresolvedOpposition]: 'Uafklaret om interaktion er indsigelse',
                [RKIRegistrationError.OppositionFound]: 'Indsigelse',
                [RKIRegistrationError.NoRegistryFound]: 'Opfylder ikke krav for at registrere i hverken åben eller lukket',
                [RKIRegistrationError.FoundationAmountCouldNotBeFound]: 'Beløb på fundament mangler',
                [RKIRegistrationError.FoundationAmountTooSmall]: 'Beløb på fundament er for småt til åben RKI',
                [RKIRegistrationError.NameTooLong]: 'RKI tillader maksimalt 60 tegn i navnet ved registrering. Hvis det eksempelvis er en enkeltmandsvirksomhed, kan "v/" fjernes og alt efter "/v".',
            },
        },
        infobox: {
            herebyRegister: 'registrerer hermed',
            open: 'Åbne',
            closed: 'Lukkede',
            inExperian: 'i Experians',
            debtorNotPaid: 'RKI-register, da debitor endnu ikke har betalt det forfaldne beløb af DKK',
            criteria: 'Sagen overholder følgende kriterier:',
            min18years: 'Debitor er min. 18 år',
            min3messages: 'Debitor har modtaget minimum 3 beskeder fra kreditor og/eller inddriver vedr. pågældende skyld',
            totalDebt: 'Total gæld inkl. renter og gebyrer min. DKK 1.000',
            hasFoundation: 'Har fundament',
            debtorWarning: 'Debitor er varslet for min. 15 dage siden og maks. 6 måneder siden',
            totalPrincipal: 'Total hovedstol min. DKK 200',
            noDemurral: 'Debitor har ikke gjort indsigelse',
            institutionsInfo: 'Forsikringsselskaber, penge – og realkreditinstitutter må ikke registrere debitorer i RKI uden at sagen er behandlet i civilretten eller fogedretten',
            incoming: 'Interaktioner markeret som indsigelser og uafklaret interaktioner',
            letterReturned: 'RKI varselsbrev returnet',
            specialCreditors: 'Forsikringsselskaber, penge – og realkreditinstitutter må ikke registrere debitorer i RKI uden at sagen er behandlet i civilretten eller fogedretten',
            closedRegister: 'Lukket RKI',
            openRegister: 'Åbne RKI',
            foundationType: 'Registrering med den korrekte fundamentstype',
            registerButton: 'Registrér i RKI',
            finePrint: {
                NB: 'OBS: Experians system kan være op til 10 minutter om at behandle rapporteringer og ændringer i RKI-registret. Udtages registreringen eller ændringen til manuel behandling, kan der gå op til flere hverdage.',
                letter: 'Debitor vil modtage en skrivelse fra Experian efter at registreringen er publiceret.',
                expiration: 'Registrering i lukkede udløber efter 2 år. Kan forlænges med op til 5 år såfremt der overgår til det åbne register. Registrering i åbne udløber efter 5 år fra fundamentsdato.',
                faultyData: 'Ved fejl med dataen kan RKI Data Team med fordel kontaktes på dataservicerki.faellespostkasse@experian.com',
                newClient: 'Ved klientoprettelse skal man rette kontakt til: klientoprettelse@experian.com',
            },
        },
    },
    financials: {
        debtExpiresWithinThreeMonths: 'Gæld forælder indenfor 3 måneder',
        debtExpired: 'Gæld forældet',
        principal: 'Hovedstol',
        interests: 'Renter',
        costs: 'Omkostninger',
        debt: 'Gæld',
        deposit: 'Indbetalt',
        balance: 'Balance',
        revenue: 'Omsætning',
        revenueBasedDepositOrder: 'Omsætningsmæssig betalingsrækkefølge',
        interestBasedDepositOrder: 'Rentemæssig betalingsrækkefølge',
        details: 'Detaljer',
        invoiceId: 'Fakturannummer',
        reminderFee: 'Rykkergebyr',
        overpayment: 'Overindbetaling',
        repayment: 'Tilbagebetaling',
        responsibleForRepayment: 'Ansavarlig for tilbagebetaling',
        sourceBankAccount: 'Fra bankkonto',
        registrationNumber: 'Registreringsnummer',
        accountNumber: 'Kontonummer',
        repaymentAmount: 'Beløb til tilbagebetaling',
        sendRepaymentRequest: 'Send anmodning om tilbagebetaling',
        currency: 'Valuta',
        imposedByCollector: 'Gæld pålagt af inddriver',
        imposedByCreditor: 'Gæld pålagt af kreditor',
    },
    navigation: {
        overview: 'Overblik',
        home: 'Hjem',
        cases: 'Sager',
        views: 'Visninger',
        transactions: 'Transaktioner',
        economy: 'Økonomi',
        economyCaseVouchers: 'Sagsposteringer',
        economyBookkeeping: 'Bogføring',
        economyImposedDebt: 'Pålagt gæld',
        economyDeposits: 'Betalinger',
        economySetup: 'Indstillinger',
        economyBilling: 'Afregning',
        economyPayment: 'Betalinger',
        economyPayouts: 'Udbetalinger',
        economyChartOfAccounts: 'Kontoplan',
        economyIrrecoverableDebt: 'Uerholdelig gæld',
        economyExpiredDebt: 'Forældet gæld',
        communication: 'Kanaler',
        content: 'Indhold',
        customerCare: 'Customer Care',
        economyUnknown: 'Uidentificérbare betalinger',
        bankAccounts: 'Konti',
        export: 'Eksportér',
        transactionLookup: 'Posteringsopslag',
        reports: 'Rapporter',
        creditors: 'Kreditorer',
        creditorEconomy: 'Økonomi',
        creditorInvoicing: 'Afregning',
        creditorCustomers: 'Kunder',
        creditorCases: 'Sager',
        creditorCollector: 'Inddriver',
        creditorIrrecoverableDebt: 'Uerholdelig gæld',
        creditorExpiredDebt: 'Forældet gæld',
        creditorEconomySetup: 'Opsætning',
        creditorSetup: 'Indstillinger',
        creditorWorkflows: 'Workflows',
        creditorUsers: 'Brugere',
        creditorIntegrations: 'Integrationer',
        journalizer: 'Journalisering',
        returnLetters: 'Returbreve',
        outbox: 'Udbakke',
        outboundCalls: 'Udgående opkald',
        import: 'Import',
        support: 'Hjælp',
        search: 'Søg efter sager...',
        settings: 'Indstillinger',
        settingsDesc: 'Indstillinger for kontoen',
        user: 'Min konto',
        userDesc: 'Dine indstillinger',
        homeOverview: 'Overblik',
        settingsGeneral: 'Generelt',
        settingsTemplates: 'Skabeloner',
        settingsDevelopers: 'Udviklere',
        settingsDevelopersDesc: 'Adgang til API m.m.',
        settingsChangelogs: 'Changelogs',
        settingsChangelogsDesc: 'Ændringer til platformen',
        settingsSwitchAccount: 'Skift konto',
        settingsSwitchAccountDesc: 'Skift mellem konti',
        settingsTenantBilling: 'Fakturaer',
        settingsTenantBillingDesc: 'Få overblik over fakturaer',
        settingsProperties: 'Attributter',
        settingsCaseVoucherTables: 'Sagsposteringstabeller',
        settingsCaseGroups: 'Sagsgrupper',
        settingsCaseConfig: 'Sagsopsætning',
        settingsWebhooks: 'Webhooks',
        settingsEmbed: 'Embeds',
        settingsAPI: 'API',
        settingsCollectors: 'Inddrivere',
        settingsIntegrateCalendar: 'Synkronisér opgaver med kalender',
        settingsEconomy: 'Økonomi',
        settingsPriceList: 'Prisliste',
        settingsBookkeeping: 'Bogføring',
        settingsBilling: 'Afregningsopsætning',
        settingsBankAccounts: 'Konti',
        settingsCaseVoucherTypes: 'Sagsposteringstyper',
        settingsBillingVoucherTypes: 'Afregningsposteringstyper',
        settingsUsers: 'Brugere',
        settingsTribunal: 'Domstolsmodul',
        settingsTeams: 'Teams',
        settingsTenant: 'Tenant',
        settingsUpdateTypes: 'Opgavetyper',
        settingsProcedures: 'Genveje',
        settingsApplications: 'Regelbaserede posteringer',
        settingsCaseMergeRules: 'Regler for sammenlægning',
        settingsPaymentPlansConfig: 'Opsætning af afdragsordninger',
        settingsJournalizerConfig: 'Journalisering',
        reportsExorts: 'Filudtræk',
        reportsPaymentPlans: 'Afdragsordninger',
        reportsSankey: 'Debbie flow-diagram',
        settingsWorkflows: 'Workflows',
        reportsPaymentDays: 'Betalingsdage-diagram',
        myAccount: 'Min konto',
        integrations: 'Integrationer',
    },
    timespanUnits: {
        [TimespanUnit.Years]: 'År',
        [TimespanUnit.Quarters]: 'Kvartaler',
        [TimespanUnit.Months]: 'Måneder',
        [TimespanUnit.Weeks]: 'Uger',
        [TimespanUnit.Days]: 'Dage',
        [TimespanUnit.Hours]: 'Timer',
        [TimespanUnit.Minutes]: 'Minutter',
        [TimespanUnit.Seconds]: 'Sekunder',
        [TimespanUnit.MS]: 'Millisekunder',
    },
    paymentPlansConfig: {
        description: 'Opsæt hvilke muligheder debitor skal have, når de skal oprette en afdragsordning.',
        minEntryAmountPlaceholder: 'Minimumsbeløb per afdrag',
        daysBetweenEntriesPlaceholder: 'Dage i mellem',
        durationPlaceholder: 'Antal måneder',
        addOption: 'Tilføj',
        save: 'Gem',
        override: 'Overskriv opsætning på kreditorniveau',
        disablePaymentPlans: 'Slå afdragsordninger fra så hverken debitorer eller sagsbehandlere kan oprette afdragsordninger.',
        requireCentralRegisterId: 'Kræv CPR/CVR-nummer før underskrift',
        activationDeadlineDays: 'Annullér ikke-aktiverede afdragsordninger efter antal dage',
    },
    referenceIdFinders: {
        referenceIdFinding: 'Referencenummersøgning',
        description: 'Journaliser emails og match indbetalinger baseret på referencenumre som kundenummer eller sagsposteringsreference (fakturanummer eksempelvis).',
        length: 'Antal cifre i referencenummer',
        min: 'Mindste mulige referencenummer',
        max: 'Største mulige referencenummer',
        createNew: 'Opret ny referencenummersøgning',
        add: 'Tilføj',
        caseVoucherReference: 'Sagsposteringsreference',
        caseVoucherReferenceDescription: 'Sagsposteringsreference (eksempelvis fakturanummer)',
        customerReference: 'Kundereference',
        customerReferenceDescription: 'Kundereference (eksempelvis patient-, klient- eller medlemsnummer)',
    },
    caseMergeRules: {
        description: 'Beslut om nye posteringer vedrørende en kunde skal tilføjes til eksisterende sager eller om der skal oprettes en ny sag.',
        preventMerge: 'Undgå sammenlægning af alle sager',
        caseStatusVerified: 'Sammenlæg med godkendte sager',
        adjustVariableCaseVouchers: 'Genberegn eventuelle inkassoomkostninger ved sammenlægning af sager',
        caseStatusPending: 'Sammenlæg med afventende sager',
        hasFoundation: 'Sammenlæg med sager med fundament',
        caseVoucherConstraints: 'Posteringstyper med dubletkontrol',
        caseVoucherConstraintsDescription: 'Vælg hvilke sagsposteringstyper der ikke må optræde på begge sager, hvis de er oprettet inden for det angivne antal dage. Det er de nyeste sagsposteringer som vil blive fjernet.',
        caseVoucherConstraintsAllDays: 'Fjern alle',
        caseVoucherConstraintsDays: 'Dage',
        addCaseVoucherConstraint: 'Tilføj dubletkontrol',
        addCaseVoucherConstraintSelectVoucherType: 'Vælg posteringstype',
        addCaseVoucherConstraintUniqueInDays: 'Unik i antal dage (efterlad tom, hvis alle skal fjernes)',
        addCaseVoucherConstraintAddButton: 'Tilføj',
        doesNotHaveUpdateTypeIds: 'Sammenlæg ikke med sager med en af følgende opgaver',
        doesHaveUpdateTypeIds: 'Sammenlæg kun med sager med en af følgende opgaver',
        hasActivePaymentPlan: 'Sammenlæg med sager med aktiv afdragsordning',
    },
    workflows: {
        workflows: 'Workflows',
        customWorkflows: 'Oprettede workflows',
        standardWorkflow: 'Standardworkflows',
        creditorStandardWorkflowDescription: 'Opsæt hvilket workflow nye sager skal oprettes i. Ændrer du workflowet her, vil det altså ikke ændre allerede oprettede sager.',
        creditorInteraction: 'til kreditor',
        removeVouchers: 'Fjern',
        rollbackTask: 'Rul tilbage',
        rolledback: 'Tilbagerullet',
        runTask: 'Ryk sag til denne opgave',
        sureYouWantToDeleteTask: 'Er du sikker på, at du vil slette opgaven?',
        addRequirement: 'Tilføj krav',
        searchUpdates: 'Søg',
        noUpdatesToShow: 'Ingen opgaver at vise',
        manualSelection: 'Manuelt valg',
        changeWorkflowOnCase: 'Skift workflow',
        nextTaskASAP: 'Næste opgave udføres hurtigst muligt',
        workflowWillStartWhenCaseIsVerified: 'Workflowet går i gang, når sagen er godkendt',
        caseIsPaused: 'Sagen er pauset. Næste opgave udføres, når sagen fortsættes.',
        pausedBecauseOfPaymentPlan: 'Næste opgave udføres, hvis afdragsordningen misligholdes.',
        priority: 'Prioritet',
        priorityDescription: 'Hvis ikke der ikke kan anbefales en vej at gå, vil prioriteten følges. 1 er højeste prioritet.',
        timing: 'Tidshorisont',
        requirements: 'Krav',
        amount: 'Beløb',
        imposedByCreditor: 'Pålagt af kreditor',
        text: 'Tekst',
        addTodo: 'Tilføj handling',
        selectTemplate: 'Vælg skabelon',
        includeVoucherAttachments: 'Vedhæft posteringsbilag (for eksempel fakturaer).',
        selectEmailPDFAttachment: 'Vælg brevskabelon som skal vedhæftes emailen',
        sendImmediatelyDeviateFromSettings: 'Skal omgående afsendelse afvige fra generelle indstillinger på din konto?',
        sendImmediately: 'Send med det samme',
        doNotSendImmediately: 'Send ikke med det samme',
        endCaseIfThereIsNoPrincipalLeft: 'Afslut sag hvis der ikke er nogen hovedstol tilbage',
        endCaseReason: 'Hvis sagen skal afsluttes, hvilken afslutningsårsag skal der så bruges?',
        selectCollector: 'Vælg inddriver',
        useCreditorCollector: 'Benyt kreditors identitet',
        creditorCollector: 'Kreditors identitet',
        setAsPrincipalReferenceCaseVoucher: 'Sæt som referencepostering af hovedstolen',
        setMaxTotalAmount: 'Sæt maks.beløb',
        maxTotalAmount: 'Maks.beløb',
        selectCaseGroup: 'Vælg sagsgruppe',
        addNewTemplate: 'Tilføj skabelonen',
        addNewTemplateSubheading: 'Opret en ny tom skabelon',
        timespan: 'Tidshorisont',
        timespanUnit: 'Tidsenhed',
        timespanUnitQuantity: 'Antal tidsenheder',
        timeOfDay: 'Tidspunkt på dagen',
        moreThan: 'Mere end',
        thresholdAmount: 'Beløb',
        caseGroup: 'Sagsgruppe',
        percentageSplitFrom: 'Procentsplit fra',
        percentageSplitTo: 'Procentsplit til',
        selectedCreditor: 'Kreditor',
        onlySelectedVoucherCategories: 'Kun udvalgte posteringskategorier',
        title: 'Titel',
        description: 'Beskrivelse',
        newWorkflow: 'Nyt workflow',
        createNewWorkflow: 'Opret workflow',
        updateWorkflow: 'Opdatér workflow',
        duplicateWorkflow: 'Duplikér workflow',
        deleteWorkflow: 'Slet workflow',
        deleteWorkflowConfirm: 'Er du sikker på, at du vil slette workflowet?',
        endedCasesPercentage: 'sager afsluttet',
        casesInTask: 'sager i status',
        task: 'Opgave',
        pause: 'Pause',
        pauseCase: 'Skal sagen pauses?',
        pauseUnlimited: 'Sæt på pause og afvent manuel håndtering',
        remindNow: 'Påmind nu',
        stats: 'Statistik',
        endedCases: 'Afsluttede sager',
        sum: 'Sum',
        totalCases: 'Totalt antal sager som har været i denne opgave',
        currentCases: 'Sager som lige nu er i statussen',
        incomingInteractionsStats: 'Indkommende interaktioner',
        paymentPlansCreatedStats: 'Afdragsordninger oprettet',
        satisfactionStats: 'Omdømme',
        alternativePaths: 'Alternative stier',
        alternativePath: 'Alternativ sti',
        addAlternativePath: 'Tilføj alternativ sti',
        source: 'Fra opgave id',
        mergeCaseTodoDescription: 'Sagen vil blive forsøgt sammenlagt med andre sager på kreditor baseret på sammenlægningsreglerne. Det er også muligt, at sammenlægge sagen med relaterede sager baseret på relationstyper valgt nedenunder.',
        mergeWithRelatedCasesOfType: 'Mulighed for sammenlægning med relaterede sager af type',
        applyCustomMergeRules: 'Tilpas sammenlægningsregler',
        settings: {
            workflowSettings: 'Workflow indstillinger',
            disableWorkflows: 'Slå workflows fra',
            disableWorkflowsWarning: 'Er du sikker på at du vil deaktivere ALLE workflows?',
            workflowsDisabled: 'Workflows er deaktiveret',
            limitExecutionInterval: 'Begræns tidsrummet hvor workflows må køre',
        },
    },
    timingTypes: {
        [TimingType.Timespan]: 'Tidsrum',
        [TimingType.TimespanFromDueDate]: 'Tidsrum fra seneste forfaldsdato',
    },
    updatesEditor: {
        update: 'Opgave',
        information: 'Information',
        informationDescription: 'Workflows som opgaven er tilføjet til.',
        standardSettings: 'Generelt',
        standardSettingsDescription: 'Generelle indstillinger for en opgave.',
        label: 'Label',
        save: 'Gem',
        updateTypeGroup: 'Opgavegruppe',
        selectUpdateTypeGroup: 'Vælg opgavegruppe',
        important: 'Vigtig',
        importantPlaceholder: 'Denne opgave er vigtig og skal fremhæves på sagen',
        pausing: 'Pausende',
        pausingPlaceholder: 'Denne opgave skal pause sagen',
        selectable: 'Valgbar',
        selectablePlaceholder: 'Denne opgave kan vælges på en sag',
        procedure: 'Procedure',
        procedureDescription: 'Proceduren som denne opgave skal eksekvere. Hvis slået til, vil proceduren eksekveres, hvis opgaven sættes i et workflow.',
        procedureOn: 'Skal der ske en automatisk handling?',
        procedurePlaceholder: 'Slå automatisk handling til',
        onCaseExit: 'Ved sagsafslutning',
        onCaseExitDescription: 'Afsluttes en sag som har denne status, kan du indstille, at sagen skal pause i en selvvalgt status.',
        onCaseExitContinueUpdates: 'Skal opgaver af denne type automatisk fortsættes når en sag afsluttes?',
        continueOnCaseExit: 'Fortsæt ved sagsafslutning',
        onCaseExitPauseWith: 'Ved sagsafslutning sæt sagen i følgende status',
        selectUpdateType: 'Opgavetype',
        roles: 'Roller',
        rolesDescription: 'Vælg her hvilken rolle som er ansvarlig for at løse opgaven.',
        responsibleRole: 'Ansvarlig rolle',
        hiddenForCreditors: 'Skjult for kreditorer',
        hiddenForCreditorsPlaceholder: 'Skal denne opgave være skjult for kreditorer',
        introduction: 'Introduktion',
        introductionDescription: 'Introduktion til opgaven med tekst og evt. et billede. Det er en fordel, hvis kreditor er ansvarlig, at lave en god introduktion.',
        introductionHeaderImage: 'Hero-billede til introduktionen',
        introductionHeaderImageDropText: 'Træk og slip et billede her',
        deleteButton: 'Slet opgavetype',
        deleteWarning: 'Du sletter både typen, men også alle opgaver af typen. Vil du fortsætte?',
    },
    workflowTodoTypes: {
        [TodoType.AddVoucher]: 'Tilføj postering',
        [TodoType.AddBillingVoucher]: 'Tilføj afregningspostering (honorar)',
        [TodoType.RemoveVoucher]: 'Fjern postering',
        [TodoType.CreateInteraction]: 'Send interaktion',
        [TodoType.CreateCreditorInteraction]: 'Send interaktion til kreditor',
        [TodoType.SetCollector]: 'Skift inddriver',
        [TodoType.SetCaseGroup]: 'Skift sagsgruppe',
        [TodoType.MoveToTenant]: 'Overlevér til inddriver fra kreditor',
        [TodoType.ChangeCaseStatus]: 'Skift sagsstatus',
        [TodoType.OutboundCall]: 'Udgående opkald',
        [TodoType.SetCaseTag]: 'Tilføj tag på sag',
        [TodoType.DebtRegister]: 'Registrér i gældsregister',
        [TodoType.DebtRegisterSkip]: 'Klar til registrering i gældsregister?',
        [TodoType.SubmitToCourt]: 'Indlever betalingspåkrav',
        [TodoType.ReadyToSubmitToCourt]: 'Klar til indlevering af betalingspåkrav?',
        [TodoType.ConnectToDebtCollector]: 'Overdrag til en connect partner',
        [TodoType.ReturnToConnectSource]: 'Returnér sagen til connect partner',
        [TodoType.SwitchWorkflow]: 'Skift workflow',
        [TodoType.SwitchBackToPreviousWorkflow]: 'Skift tilbage til forrige workflow',
        [TodoType.MergeCase]: 'Sammenlæg sag hvis muligt',
        [TodoType.Bespoke]: 'Tilpasset handling',
        [TodoType.CreateProperties]: 'Opret attributter',
        [TodoType.SetResponsible]: 'Sæt ansvarlig på sag',
        [TodoType.MarkExpired]: 'Marker sagsposteringer som forældede',
    },
    workflowPathWarnings: {
        [PathWarning.ReadyForEboksRequirementRecommended]: 'Kravet "Klar til e-Boks" anbefales',
        [PathWarning.ValidEmailRequirementRecommended]: 'Kravet "Har gyldig email" anbefales',
        [PathWarning.ValidAddressRequirementRecommended]: 'Kravet "Har gyldig adresse" anbefales',
    },
    workflowRequirementTypes: {
        [RequirementType.DoesNotHaveUpdate]: 'Mangler en specifik opgave på sagen',
        [RequirementType.HasUpdate]: 'Har en specifik opgave på sagen',
        [RequirementType.HasNoValidAddress]: 'Har ugyldig adresse',
        [RequirementType.HasValidCentralRegisterId]: 'Har gyldigt cvr-/cpr-nr.',
        [RequirementType.HasNoValidCentralRegisterId]: 'Har ugyldigt cvr-/cpr-nr.',
        [RequirementType.HasValidAddress]: 'Har gyldig adresse',
        [RequirementType.HasValidEmail]: 'Har gyldig email',
        [RequirementType.HasNoValidEmail]: 'Har ugyldig email',
        [RequirementType.IsCompany]: 'Er en virksomhed',
        [RequirementType.HasEAN]: 'Har gyldigt EAN-nummer',
        [RequirementType.ReadyForEboks]: 'Klar til e-Boks',
        [RequirementType.HasValidPhone]: 'Har gyldigt telefonnummer',
        [RequirementType.HasNoValidPhone]: 'Har ugyldigt telefonnummer',
        [RequirementType.IsPrivate]: 'Er en privatperson',
        [RequirementType.AmountThreshold]: 'Beløbsgrænse',
        [RequirementType.CaseGroup]: 'Er en del af sagsgruppe',
        [RequirementType.PercentageSplit]: 'Procentdel sager',
        [RequirementType.HasFoundation]: 'Har fundament',
        [RequirementType.DoesNotHaveFoundation]: 'Har ikke fundament',
        [RequirementType.SpecificCreditor]: 'Specifik kreditor',
        [RequirementType.CustomerHasTag]: 'Kunde har tag',
        [RequirementType.HasIncomingInteractions]: 'Har indkomne interaktioner',
    },
    embeds: {
        embeds: 'Embed',
        embedTitle: 'Titel',
        embedURL: "URL'en som skal kaldes",
        embedPlacement: 'Placering',
        embedToken: 'Valideringstoken',
        embedCreatedAt: 'Oprettelsesdato',
        embedHeight: 'Højde på området i px',
        addEmbedArea: 'Tilføj embed-område',
        noAreasYet: 'Ingen embed-områder endnu',
        couldNotLoad: 'Kunne ikke indlæses',
        caseworkerNavMenuItemCategory: 'Eksterne',
        creditorNavMenuItemCategory: 'Eksterne',
    },
    embedPlacements: {
        [EmbedPlacement.CaseworkerWebCreditorPage]: 'Debbie Caseworker Web: Kreditorsiden øverst til højre',
        [EmbedPlacement.CaseworkerWebCasePage]: 'Debbie Caseworker Web: Sagssiden under økonomipanelet',
        [EmbedPlacement.CaseworkerWebMenuItem]: 'Debbie Caseworker Web: Fuld side med link i menuen til venstre',
        [EmbedPlacement.CreditorWebCasePage]: 'Debbie Creditor Web: Sagssiden under økonomipanelet',
        [EmbedPlacement.CreditorWebFrontPage]: 'Debbie Creditor Web: Forsiden i højre side',
        [EmbedPlacement.CreditorWebMenuItem]: 'Debbie Creditor Web: Fuld side med link i menuen til venstre',
    },
    webhookSettings: {
        noWebhooksYet: 'Endnu ingen webhooks',
    },
    userOverrideSettings: {
        label: 'Debitoroverskrivninger',
        description: 'Du kan bruge debitoroverskrivninger til automatisk at ændre oplysninger for kunder, der passer til bestemte kriterier. Når en kunde, der opfylder disse kriterier, bliver opdateret, vil de valgte felter automatisk blive erstattet med de indstillinger, du har lavet.',
        whenMatching: 'Når en debitor matcher',
        overrideFields: 'Overskriv felter',
    },
    apiSettings: {
        keys: 'API-nøgler',
        noKeysYet: 'Der er endnu ikke udstedt nogen API-nøgler',
        newKeyButton: 'Opret API-nøgle',
        newKey: 'Ny API-nøgle',
        newKeyCreatedInfo: 'Det var det! Husk at opbevar din API-nøgle et sikkert sted. Notér nedenstående nøgle - det her er første og sidste gang, du kommer til at kunne få den fra Debbie.',
        closeModal: 'Forstået',
        keyName: 'Navn på din API-nøgle',
        createNewKey: 'Opret API-nøgle',
    },
    updateTypeSettings: {
        label: 'Label',
        responsibleRole: 'Ansvarlig rolle',
        isImportant: 'Vigtig',
        tenantSpecific: 'Tenant-specifik',
        isTenantSpecific: 'Er tenant-specifik',
        referenceType: 'Referencetype',
        onCaseExit: 'Ved sagsluk sæt i status',
        isPausing: 'Pauser sagen',
        hiddenForRoles: 'Skjul for rolle',
        knowledgeBaseLink: 'Knowledge base',
    },
    overview: {
        todoList: 'Todo-liste',
        noDescription: 'Ingen beskrivelse',
        noPauseStatus: 'Ingen pause status',
        settlementTime: 'Afviklingstid i måneder',
        instalmentAgreement: 'Afdragsordninger',
        statistics: 'Statistik',
        averageIntro: 'Det tager i gennemsnit',
        averageOutro: 'dage for en sag at blive afviklet.',
        quantityCases: 'Antal sager',
        quantifyCustomers: 'Antal kunder',
        statusDistribution: 'Statusfordeling',
        chartStatuses: {
            Godkendt: 'Godkendt',
            'Afventer Godkendelse': 'Afventer Godkendelse',
            Afsluttet: 'Afsluttet',
            Annuleret: 'Annulleret',
            Afslutningsårsag: 'Afslutningsårsag',
        },
    },
    endReason: {
        [SystemEndReason.ErrorCreditor]: 'Fejl fra kreditors side',
        [SystemEndReason.ErrorUs]: 'Fejloprettelse',
        [SystemEndReason.Expiration]: 'Sagen er forældet',
        [SystemEndReason.Departed]: 'Debitor er udrejst',
        [SystemEndReason.Unidentified]: 'Debitor kan ikke valideres',
        [SystemEndReason.AddressUnknown]: 'Adresse på debitor ukendt',
        [SystemEndReason.Paid]: 'Debitor har betalt hele gælden',
        [SystemEndReason.Transferred]: 'Sagen er overdraget',
        [SystemEndReason.Dead]: 'Debitor er afgået ved døden',
        [SystemEndReason.Objection]: 'Lukket pga. indsigelse',
        [SystemEndReason.Withdrawn]: 'Kreditor har tilbagekaldt sagen',
        [SystemEndReason.OfferFromUs]: 'Betalt efter akkordtilbud fra os',
        [SystemEndReason.OfferFromDebtor]: 'Betalt efter akkordtilbud fra debitor',
        [SystemEndReason.DebtRelief]: 'Debitor har opnået gældssanering',
        [SystemEndReason.Bankruptcy]: 'Debitor er gået konkurs',
        [SystemEndReason.ForcedDissolved]: 'Debitor er tvangsopløst',
        [SystemEndReason.ConflictOfInterest]: 'Interessekonflikt med debitor og os',
        [SystemEndReason.NegativePayoff]: 'Negativ payoff for kreditor',
        [SystemEndReason.Overpayment]: 'Debitor har betalt for meget',
        [SystemEndReason.Minor]: 'Debitor er umyndig',
        [SystemEndReason.Irrecoverable]: 'Sagen er uerholdelig',
        [SystemEndReason.PartiallyPaid]: 'Delvist betalt',
        [SystemEndReason.CreditorUnresponsive]: 'Uden svar fra kreditor',
        [SystemEndReason.Merged]: 'Sagen er lagt sammen med en anden',
        [SystemEndReason.FireAndForget]: 'Fire & forget',
        [SystemEndReason.SmallCaseNotWanted]: 'Småsag ej ønsket',
        [SystemEndReason.NoDebt]: 'Ingen gæld på sagen',
        [SystemEndReason.Deleted]: 'Slettet',
        [SystemEndReason.NoCourt]: 'Sagen er igennem udenretlig forløb',
        [SystemEndReason.Other]: 'Anden årsag',
    },
    courtSubmitErrors: {
        [SubmitToCourtError.IsNotWarned]: 'Sagen er ikke varslet',
        [SubmitToCourtError.CurrencyNotDKK]: 'Valutaen er ikke DKK',
        [SubmitToCourtError.WarningWasReturned]: 'Varslet er ikke leveret',
        [SubmitToCourtError.AlreadyHasFoundation]: 'Der er allerede et fundament registreret på sagen',
        [SubmitToCourtError.MoreThanOneDebtor]: 'Der er mere end en debitor på sagen, og derfor kan sagen ikke indleveres autmoatisk',
        [SubmitToCourtError.HasAlternativeContact]: 'Sagen har en repræsentant registreret, og derfor kan sagen ikke indleveres autmoatisk',
        [SubmitToCourtError.EconomyContactMissing]: 'Der mangler en ansvarlig for håndtering af udbetalingsrekvisition',
        [SubmitToCourtError.CreditorNameMissing]: 'Kreditors navn mangler',
        [SubmitToCourtError.CreditorAddressMissing]: 'Kreditor har ingen adresse',
        [SubmitToCourtError.CompanyFullResponsibleParticipantMissing]: 'Fuldt ansvarlig deltager kunne ikke findes',
        [SubmitToCourtError.CompanyDirectorNameMissing]: 'Direktørens navn kunne ikke findes',
        [SubmitToCourtError.CompanyDirectorAddressMissing]: 'Direktørens adresse kunne ikke findes',
        [SubmitToCourtError.JurisdictionMissing]: 'Kunne ikke finde værneting',
        [SubmitToCourtError.EconomicalSubmitThreshold]: 'Sagens udestående er under kreditors grænseværdi for indlevering af betalingspåkrav',
        [SubmitToCourtError.SagsfremstillingMissing]: 'Mangler sagsfremstilling på kreditorniveau',
        [SubmitToCourtError.CaseHasExceededMaxDebtRegistrationsThreshold]: 'Antal RKI-registreringer på sagen overstiger kreditors grænseværdi for indlevering af betalingspåkrav',
        [SubmitToCourtError.AlreadyInCourt]: 'Allerede indleveret til foged- eller civilretten',
        [SubmitToCourtError.AddressNotInDK]: 'Debitors adresse er ikke dansk',
        [SubmitToCourtError.DebtorMovedAbroad]: 'Debitor er udrejst',
        [SubmitToCourtError.CaseHasDeposits]: 'Sagen har indbetalinger og er derfor udtaget til manuel behandling',
        [SubmitToCourtError.DebtorBankrupt]: 'Debitors virksomhed er inaktiv',
        [SubmitToCourtError.DebtorCompanyCeased]: 'Debitor er ophørt',
        [SubmitToCourtError.DebtorDead]: 'Debitor er død',
        [SubmitToCourtError.DebtorHomeless]: 'Debitor er hjemløs',
        [SubmitToCourtError.ExcessiveReminderFeeImposed]: 'Der er pålagt for mange rykkergebyrer',
        [SubmitToCourtError.ExcessiveCollectionFeeImposed]: 'Der er pålagt for meget i inkassogebyr',
        [SubmitToCourtError.ExcessiveCollectionCostImposed]: 'Inkassoomkostningerne afviger fra det beregnede beløb',
        [SubmitToCourtError.ExcessivePrincipal]: 'Hovedstolen overstiger beløbsgrænsen på DKK 100.000,00',
    },
    templateTags: {
        [TemplateTag.BPKWarning]: 'Betalingspåkravsvarsel',
        [TemplateTag.RKIWarning]: 'RKI varsel',
    },
    templates: {
        allTemplates: 'Alle skabeloner',
        customTemplates: 'Oprettede skabeloner',
        standardTemplates: 'Standardskabeloner',
        confirmDelete: 'Er du sikker på at du vil slette denne skabelon?',
        delete: 'Slet',
        updateTypesUsingThisTemplate: 'Opgavetyper som bruger denne skabelon',
        newTemplate: 'Ny skabelon',
        selectType: 'Vælg type',
        letter: 'Brev',
        name: 'Navn',
        create: 'Opret',
        quantityTemplates: 'Antal skabeloner',
        singleOwner: 'Vælg en enkelt ejer',
        standard: 'Standard',
        alternativeContact: 'Repræsentant',
        saveDraft: 'Gem udkast',
        saveAndPublish: 'Gem og publicér',
        preview: 'Forhåndsvisning',
        versions: 'Versioner',
        publish: 'Publicér',
        copy: 'Kopier skabelon',
        copyOtherTemplate: 'Kopier eksisterende skabelon',
        settings: 'Indstillinger',
        lastChangedOn: 'Sidst ændret',
        by: 'af',
        WIP: 'Igangværende arbejde',
        versionPublished: 'Denne version er udgivet',
        selectTestCase: 'Vælg test-sag',
        collector: 'Inddriver',
        ifCollectorSelected: 'Hvis dette er valgt vises denne skabelon kun med sager hvor valgte inddriver er tilknyttet',
        selectCollector: 'Vælg inddriver',
        creditor: 'Kreditor',
        ifCreditorSelected: 'Hvis dette er valgt, vises denne skabelon kun med sager, hvor valgte kreditor er tilknyttet.',
        selectCreditor: 'Vælg kreditor',
        letterTheme: 'Brevets tema',
        ifThemeSelected: 'Brevets tema definerer designet af skabelonen.',
        selectTheme: 'Vælg skabelontema',
        fileName: 'Filnavn',
        state: 'Tilstand',
        type: 'Type',
        savedAt: 'Gemt',
        firstName: 'Fornavn',
        lastName: 'Efternavn',
        view: 'Se',
        confirmDeleteItem: 'Er du sikker på at du vil slette denne entitet?',
        confirmPublish: 'Ændringerne er ikke gemt. Du er ved at udgive den senest gemte version of denne skabelon. Er du sikker?',
        validations: {
            missing: 'Mangler',
            invalidOrder: 'Ugyldig rækkefølge',
            inSubject: 'i emne',
            inBody: 'i brødtekst',
        },
        addTag: 'Tilføj tag',
        selectTag: 'Vælg tag',
    },
    templateTypes: {
        [TemplateType.AUTOCALL]: 'Autokald',
        [TemplateType.EBOKS]: 'e-Boks',
        [TemplateType.EMAIL]: 'E-mail',
        [TemplateType.LETTER]: 'Brev',
        [TemplateType.SMS]: 'SMS',
    },
    integrations: {
        chooseCreditor: 'Vælg kreditor for integrationer',
        active: 'Aktiv',
        activeIntegrations: 'Aktive integrationer',
        available: 'Integrationer tilgængelige for kreditor',
        unavailable: 'Integrationer utilgængelige for kreditor',
        isAvailable: 'Giv kreditor adgang til forbinde eller deaktivere integrationen',
        connect: 'Forbind',
        deactivate: 'Sæt på pause',
        reactivate: 'Genaktiver',
        integrationOptions: 'integrationsmuligheder',
        importAllText: 'Importer fakturaer før forfald',
        updateCustomers: 'Opdater kundedata når det ændres i e-conomic',
        cutoffDateText: 'Cutoff dato (Importer kun fakturaer efter denne dato, hvis ikke sat, bliver alle importeret)',
        runsOut: '',
        turnsDue: '',
        invoiceDate: 'Antal dage efter fakturadato posteringerne skal overføres',
        dueDate: 'Antal dage efter forfaldsdato posteringerne skal overføres',
        notChangable: 'Mulighederne kan ikke ændres senere',
        all: 'Alle',
        recommended: 'Anbefalede',
        essential: 'Vigtige',
        additionalCustomers: 'yderligere kunder',
    },
    eConomicTypeName: {
        creditNote: 'Kredit nota',
        invoice: 'Faktura',
        payment: 'Betaling',
        reminder: 'Påmindelse',
    },
    integrationMapper: {
        voucherNumber: 'Voucher nummer',
        invoiceNumber: 'Fakturanummer',
        amountLeftToMap: 'Beløb tilbage at kortlægge',
        totalAmount: 'Posteringsbeløb',
        noMoreEntries: 'Der er ikke flere poster til kortlægning',
        selectEntries: 'Vælg en postering for at starte kortlægning',
        customerId: 'Kunde id',
        map: 'Kortlæg beløb',
        notAvailable: 'E-conomic mapping er ikke tilgængeligt, kontakt Debbie support for hjælp med mapping',
        selectedEntryLabel: 'Valgte postering',
        potentialMatches: 'Potentielle matches',
    },
    createdBy: {
        createdBy: 'Oprettet af',
        goToImport: 'Gå til import',
    },
    createdByType: {
        [PerformedByType.Connect]: 'connect',
        [PerformedByType.Import]: 'import',
        [PerformedByType.Integration]: 'integration',
        [PerformedByType.Key]: 'API nøgle',
        [PerformedByType.User]: 'bruger',
        [PerformedByType.Workflow]: 'workflow',
        [PerformedByType.Trigger]: 'trigger',
        [PerformedByType.VoucherApplication]: 'regelbaserede posteringer',
        [PerformedByType.BulkAction]: 'massehandling',
        [PerformedByType.UpdateTypeOnCaseEnd]: 'opgavetype ifm. sagsafslutning',
    },
    journalizer: {
        update: 'Opdatér',
        deleteInteraction: 'Slet interaktion',
        unknownEntityInteraction: 'Anmod om j.nr.',
        recentlyJournalized: 'NYLIGT JOURNALISERET',
        unmap: 'FJERN TILKNYTNING',
        suggested: 'FORESLÅET',
        noInteractions: 'Der er i øjeblikket ingen interaktioner',
        searchCreditors: 'Søg efter kreditorer...',
        journalizeOnCase: 'Journaliser på sag',
        journalizeOnCreditor: 'Journaliser på kreditor',
    },
    returnLetter: {
        unknownAtAddress: 'Ubekendt på adressen',
        addressNotAdequate: 'Adressen er utilstrækkelig/upræcis',
        nameNotVisible: 'Modtagerens navn står ikke på postkassen',
        recipientMoved: 'Modtageren er flyttet, og den nye adresse er ukendt, eller flytteservice er udløbet',
        recipientNoExist: 'Modtageren findes ikke',
        letterCantBeDelivered: 'Forsendelsen kan ikke afleveres',
        cantFindStreet: 'Gadenavn/husnummer findes ikke',
        mailboxIssue: 'Postkassen er fyldt/mangler/er i stykker',
        emptyPlace: 'Boligen er ubeboet/tomt hus/lejlighed',
        noHouseOrConstruction: 'Der er intet hus, eller det er et byggeri under opførelse',
        otherIssues: 'Der er ikke ryddet sne, en bidsk hund eller andet, der forhindrer adgang',
        deliveryRejected: 'Modtagelse nægtet',
        recipientRejectsLetter: 'Modtageren nægter at tage imod forsendelsen',
    },
    returnLetterReasons: {
        [ReturnReason.DENIED]: 'Modtagelse nægtet',
        [ReturnReason.NOTDELIVERABLE]: 'Kan ikke afleveres ',
        [ReturnReason.UNKNOWNRECIPIENT]: 'Ubekendt på adressen',
    },
    outbox: {
        verifyInteraction: 'Afsend',
        editTemplate: 'Redigér skabelon',
        deleteInteraction: 'Slet interaktion',
        rollbackChain: 'Tilbagerul',
        goToCase: 'Gå til sag',
        envelope: 'Kuvert',
        nextLetterSending: 'Næste brevafsending er planlagt til',
        filters: 'Filtre',
        includeInteractionsPaused: 'Inkludér interaktioner fra pausede sager',
        filterOnInteractionType: 'Filtrér på typer af interaktioner',
        filterOnCreditor: 'Filtrér på kreditor',
        filterOnTemplate: 'Filtrér på skabelon',
        autoSendModalHeader: 'Opsæt automatisk afsendelse',
        autoSendDescription: 'Angiv hvor mange manuelle afsendelser der skal foretages fra udbakken af hver skabelonversion, før beskeder bliver afsendt automatisk. Hvis du sætter værdien til 0, bliver alle beskeder sendt automatisk uden behov for godkendelse. Dette giver fleksibilitet til både fuld automatisering og manuel kontrol – afhængigt af dine behov.',
        configureAutoSend: 'Opsæt automatisk afsendelse',
        autoSendOn: 'Når {{autoSendQuantity}} beskeder af denne skabelonversion er afsendt, vil alle fremtidige automatisk blive afsendt.',
    },
    inputs: {
        creditorSelect: 'Vælg kreditor',
        from: 'Fra',
        to: 'Til',
        phoneNumber: 'Telefonnummer',
        phoneLocale: 'Landekode',
        searchForCompany: 'Søg efter virksomhed',
        search: 'Søg',
        noResults: 'Ingen resultater',
        searchAddress: 'Søg efter adresse',
        manual: 'Manuel',
        address: 'Adresse',
        noAddress: 'Indtast adresse',
        co: 'C/O',
        zipcode: 'Postnummer',
        city: 'By',
        country: 'Land',
        done: 'Færdig',
        removeAddress: 'Fjern adresse',
        remove: 'Slet',
        save: 'Gem',
        saved: 'Gemt',
        dropToUpload: 'Slip fil for at uploade',
        uploadFailed: 'Upload fejlede',
        overrideDefault: 'Overskriv standardindstilling',
        overrideTenantSetting: 'Overskriv tenant-indstilling',
    },
    paymentOptions: {
        addNew: 'Tilføj ny betalingsmulighed',
        currencies: 'Valutaer',
        bankName: 'Bankens navn',
        registrationNumber: 'Registreringsnummer',
        accountNumber: 'Kontonummer',
        fi: 'FIK-kreditornummer',
        fikSyntax: 'Brug hovedstolsposteringens referencenummer som id i stedet for sagsnummer',
        iban: 'IBAN kreditornummer',
        swift: 'SWIFT kreditornummer',
        reepayPrivateKey: 'Frisbii privat API-nøgle',
        farpayPrivateKey: 'Farpay privat API-nøgle',
        dankort: 'Dankort',
        visa: 'Visa',
        mastercard: 'Mastercard',
        currencySpecific: 'Kun til udvalgte valutaer',
        mobilepay: 'MobilePay',
        swish: 'Swish',
        vipps: 'Vipps',
        betalingsservice: 'Betalingsservice',
        leverandorservice: 'Leverandørservice',
        isActive: 'Aktiv betalingsgateway',
        confirmChangeOfPaymentGateway: 'Er du sikker på at du vil ændre din betalingsgateway?',
        mobilePeopleHmac: 'MobilePeople HMAC nøgle',
        mobilePeopleClientRef: 'MobilePeople klient reference',
        url: 'Link til betalingsgateway',
        titleToDebtor: 'Debitorweb titel',
        descriptionToDebtor: 'Debitorweb beskrivelse',
        hideOnDebtorweb: 'Skjul på debitorweb',
    },
    paymentOptionTypes: {
        [PaymentOptionType.BANKTRANSFER]: 'Bankoverførsel',
        [PaymentOptionType.FI]: 'FIK-linje',
        [PaymentOptionType.IBAN]: 'IBAN',
        [PaymentOptionType.SWIFT]: 'SWIFT',
        [PaymentOptionType.REEPAY]: 'Frisbii Betalingsgateway',
        [PaymentOptionType.FARPAY]: 'Farpay Betalingsgateway',
        [PaymentOptionType.MOBILE_PEOPLE]: 'MobilePeople betalingsgateway',
        [PaymentOptionType.LINK_TO_OWN_PAYMENT]: 'Link til egen betalingsgateway',
    },
    todoPanel: {
        searchTodos: 'Søg',
    },
    support: {
        imgsrc: 'https://storage.googleapis.com/debbie-public-files/help-ad-da.svg',
        readMore: 'Læs mere',
    },
    sites: {
        caseworkerWeb: 'Caseworkerweb',
        clientWeb: 'Kreditorweb',
        detiorWeb: 'Debitorweb',
    },
    home: {
        welcome: 'Velkommen',
        todos: 'Opgaver',
        caseworkerTodo: 'Opgaver til sagsbehandlere',
        todoPlaceholder: 'Ingen opgaver at vise',
        clientTodo: 'Opgaver til kreditorer',
        clientTodoPlaceholder: 'Intet at vise',
        noResponsibleTodo: 'Opgaver uden ansvarlig',
        noResponsibleTodoPlaceholder: 'Intet at vise',
        pendingCases: 'Nye sager',
        pendingCasesPlaceholder: 'Ingen nye sager',
        pendingDunningCases: 'Nye dunning-sager',
        pendingDunningCasesPlaceholder: 'Nye nye dunning-sager',
        topCases: 'Top 150 sager med størst gæld',
        topCasesPlaceholder: 'Ingen sager at vise',
        unassigned: 'Ikke tildelt',
        today: 'I dag',
        yesterday: 'I går',
        thisMonth: 'Denne måned',
        lastMonth: 'Sidste måned',
        deposits: 'Indbetalinger',
        depositsSmall: 'indbetalinger',
        depositsToClient: 'Indbetalinger til kreditor',
        depositsToCollector: 'Indbetalinger til inddriver',
        depositCount: 'Antal indbetalinger',
        paymentPlans: 'Afdragsordninger',
        totalPlans: 'Afdragsordninger i alt',
        totalActivePlans: 'Aktive afdragsordninger',
        totalSettledAmount: 'Indbetalt i alt',
        settledAmountLastMonth: 'Indbetalt sidste måned',
        settledAmountThisMonth: 'Indbetalt denne måned',
        plannedAmountNextMonth: 'Forventet næste måned',
        cases: 'Sager',
        interactions: 'Interaktioner',
        foundations: 'Fundamenter',
        totalFoundations: 'Fundamenter i alt',
    },
    autoCall: {
        called: 'Ringede til',
        from: 'fra',
        with: 'med',
        withVoice: 's stemme',
        call: 'Ring',
        addAction: 'Tilføj handling',
        selectAction: 'Vælg handling',
    },
    autoCallEvents: {
        started: 'Startet',
        ringing: 'Ringer op',
        answered: 'Besvaret',
        completed: 'Afsluttet',
        inbound: 'Indgående',
        busy: 'Optaget',
        timeout: 'Ikke besvaret',
        rejected: 'Afvist',
        machine: 'Telefonsvarer',
    },
    interactionTypes: {
        [InteractionType.AutoCall]: 'Autokald',
        [InteractionType.ClientNote]: 'Kreditorbesked',
        [InteractionType.DebtorNote]: 'Debitorbesked',
        [InteractionType.Eboks]: 'e-Boks',
        [InteractionType.Kivra]: 'Kivra',
        [InteractionType.Digipost]: 'Digipost',
        [InteractionType.Email]: 'Email',
        [InteractionType.Letter]: 'Brev',
        [InteractionType.Note]: 'Note',
        [InteractionType.Other]: 'Andre',
        [InteractionType.Personal]: 'Personlig henvendelse',
        [InteractionType.Phone]: 'Opkald',
        [InteractionType.SMS]: 'SMS',
        [InteractionType.EInvoice]: 'E-faktura',
    },
    interactions: {
        metadata: 'Metadata',
        removingPhoneNumberOnSubmit: 'Ved registrering af opkald fjernes nummeret fra debitor',
        events: 'Handlinger',
        sendLetter: 'Send brev',
        addTemplate: 'Tilføj fra skabelon',
        sendEBoks: 'Send besked',
        from: 'Fra',
        to: 'Til',
        subject: 'Emne',
        sent: 'Sendt',
        selectTemplate: 'Vælg skabelon',
        contact: 'Kontaktperson',
        preview: 'Forhåndsvisning',
        mention: 'Flettefelt',
        explanation: 'Forklaring',
        example: 'Eksempel',
        message: 'Besked',
        addDebtorDocuments: 'Tilføj debitordokumenter',
        addIntent: 'Tilføj hensigt',
        sendEmail: 'Send email',
        reply: 'Svar',
        replyingTo: 'Svarer på',
        thread: 'Se tråd',
        emailThread: 'Email tråd',
        note: 'Note',
        addNote: 'Tilføj note',
        sendNoteToDebtor: 'Send besked til debitor',
        sendNoteToClient: 'Send besked til kreditor',
        addFiles: 'Tilføj filer',
        remindingDescription: 'Påmidelse',
        remindingDate: 'Påmindelsesdato',
        setReminder: 'Sæt påmindelse',
        download: 'Hent PDF',
        phoneNumber: 'Telefonnummer',
        phoneNotes: 'Note',
        registerPhoneCall: 'Registrér opkald',
        sendSMS: 'Send SMS',
        unlikelyToReceive: 'Tidligere interaktioner gennem denne kanal fejlede',
        other: 'Anden',
        debtorInteraction: 'Besked',
        newInteractions: 'Nye interaktioner',
        areYouSureProcedure: 'Er du sikker på at du vil udføre denne genvej?',
        procedures: 'Genveje',
        reminder: 'Påmindelse',
        OUTGOING: 'Udgående',
        INCOMING: 'Indgående',
        UNMAPPED: 'Ujournaliseret',
        MAPPED: 'Journaliseret',
        HANDLED: 'Behandlet',
        DELETED: 'Slettet',
        PENDING: 'Afventer',
        CANCELLED: 'Annulleret',
        SENT: 'Afsendt',
        QUEUED: 'I kø',
        delete: 'Slet',
        verify: 'Afsend',
        transacted: 'Afsendt',
        journalizedAt: 'Journaliseret den',
        at: 'den',
        rollback: 'Tilbagerul',
        unmap: 'Afjournalisér',
        editTemplate: 'Redigér skabelon',
        envelope: 'Kuvert',
        readMore: 'Læs mere',
        readLess: 'Læs mindre',
        clicked: 'Klikket',
        complained: 'Markeret som spam',
        delivered: 'Modtaget',
        failed: 'Fejlet',
        opened: 'Åbnet',
        unsubscribed: 'Afmeldt',
        downloadFailed: 'Download fejlede',
        downloadSuccessful: 'Forhåndsvisning af PDF er downloadet',
        opposition: 'Indsigelse',
        notOpposition: 'Ikke-indsigelse',
        optionalNote: 'Eventuel note',
        visibilityCheckText: 'Synlig for kreditor',
        hideFromClient: 'Skjul for kreditor',
        hiddenFromClient: 'Skjult for kreditor',
        showToClient: 'Vis til kreditor',
        printPDF: 'Print/download PDF',
        clone: 'Kopier til anden sag',
        cloned: 'Interaktion kopieret',
        eInvoiceEvents: {
            created: 'Oprettet',
            transmissionStarted: 'Forsendelse startet',
            transmissionCompleted: 'Forsendelse fuldført',
            sent: 'Afsendt',
            received: 'Modtaget',
            endpointNotFound: 'Fejl',
            error: 'Fejl',
        },
    },
    outboundPhone: {
        noCasesLeft: 'Ingen sager at vise',
        priority: 'Prioritet',
        nextCase: 'Næste sag',
    },
    outgoingPhoneCallTags: {
        [PhoneOutgoingTag.FullPayment]: 'Fuld betaling',
        [PhoneOutgoingTag.IncorrectNumber]: 'Nummeret findes ikke',
        [PhoneOutgoingTag.NoAnswer]: 'Intet svar',
        [PhoneOutgoingTag.WrongNumber]: 'Forkert nummer',
        [PhoneOutgoingTag.Opposition]: 'Indsigelse',
        [PhoneOutgoingTag.Other]: 'Anden årsag',
        [PhoneOutgoingTag.OtherAgreement]: 'Anden aftale',
        [PhoneOutgoingTag.PaymentPlan]: 'Afdragsordning',
    },
    incomingPhoneCallTags: {
        [PhoneIncomingTag.FullPayment]: 'Fuld betaling',
        [PhoneIncomingTag.Opposition]: 'Indsigelse',
        [PhoneIncomingTag.Other]: 'Anden årsag',
        [PhoneIncomingTag.OtherAgreement]: 'Anden aftale',
        [PhoneIncomingTag.PaymentPlan]: 'Afdragsordning',
        [PhoneIncomingTag.Billing]: 'Afregning',
        [PhoneIncomingTag.Terms]: 'Aftaleforhold',
        [PhoneIncomingTag.Caseworking]: 'Sagsbehandling',
    },
    procedures: {
        procedure: 'Genvej',
        customProcedures: 'Oprettede genveje',
        standardProcedures: 'Standardgenveje',
        deleteProcedure: 'Slet genvej',
        confirmDeleteProcedure: 'Er du sikker på, at du vil slette denne genvej?',
        general: 'Generelt',
        generalDescription: 'Generelle indstillinger for genvejen.',
        showOnCase: 'Vis på sag',
        save: 'Gem',
        selectedProcedure: 'Genveje',
        createProcedure: 'Opret genvej',
        title: 'Titel',
        description: 'Beskrivelse',
        triggers: 'Triggers',
        defaultToSystemStandard: 'Hvis ingen genvej valgt:',
        associatedWithCollector: 'Vis kun på sager med følgende inddriver',
        selectCollector: 'Vælg inddriver',
        associatedWithCreditor: 'Vis kun på sager med følgende kreditor',
        selectCreditor: 'Vælg kreditor',
        tasks: 'Opgavetyper',
        tasksDescription: 'Opgaver som kan udføres.',
        automaticTask: 'Automatisk handling',
        selectUpdate: 'Vælg opgave',
        add: 'Tilføj',
        economyProcedureTriggers: 'Betalinger',
        paymentPlansProcedureTriggers: 'Afdragsordninger',
        debtExpiredProcedureTriggers: 'Forældelse',
        CosmoProcedureTriggers: 'Debitor-events',
        otherProcedureTriggers: 'Andre',
    },
    triggers: {
        [SystemProcedure.CreditorEndedCase]: 'Når kreditor afslutter en sag gennem API',
        [SystemProcedure.EndCase]: 'Ved fuld betaling',
        [SystemProcedure.Overpayment]: 'Ved overindbetaling',
        [SystemProcedure.RemainderReminder]: 'Ved delbetaling',
        [SystemProcedure.EndCaseAccord]: 'Ved akkord sagsafslutning',
        [SystemProcedure.PrincipalPayment]: 'Ved delbetaling svarende til hovedstolen',
        [SystemProcedure.PaymentOnCourtCase]: 'Ved betaling på sag i retten',
        [SystemProcedure.Update]: 'Ved sagsopdatering',
        [SystemProcedure.InteractionSentToDebtor]: 'Ved afsendelse af manuel interaktion til debitor',
        [SystemProcedure.PaymentPlanInitial]: 'Ved aktivering af afdragsordning',
        [SystemProcedure.PaymentPlanDocumentSigned]: 'Ved underskrift af skylderklæring i forbindelse med indgåelse af en afdragsordning',
        [SystemProcedure.PaymentPlanReminder]: 'Ved påmindelse om afdrag',
        [SystemProcedure.PaymentPlanPayment]: 'Ved betaling af afdrag',
        [SystemProcedure.PaymentPlanAutoPaymentFailure]: 'Ved fejlslagen træk fra kort ifm. betaling af afdrag',
        [SystemProcedure.PaymentPlanBSLSSubmitFailed]: 'Ved fejlslagen indsendelse af afdrag til betalingsservice',
        [SystemProcedure.PaymentPlanBSLSRejected]: 'Ved afvist afdrag via betalingsservice',
        [SystemProcedure.PaymentPlanBSLSAgreementCancelled]: 'Ved annuleret betalingsserviceaftale',
        [SystemProcedure.PaymentPlanDeadline]: 'Ved deadline for betaling af afdrag',
        [SystemProcedure.PaymentPlanCanceled]: 'Ved misligholdelse af afdragsordning',
        [SystemProcedure.PaymentPlanTwoHourActivationReminder]: 'To timer efter, at der er valgt en afdragsordning, som aldrig er blevet aktiveret',
        [SystemProcedure.PaymentPlanOneDayActivationReminder]: 'En dag efter, at der er valgt en afdragsordning, som aldrig er blevet aktiveret',
        [SystemProcedure.PaymentPlanThreeDayActivationReminder]: 'Tre dage efter, at der er valgt en afdragsordning, som aldrig er blevet aktiveret',
        [SystemProcedure.CancelUnactivatedPaymentPlansAfterActivationDeadline]: 'Annuller afdragsordninger, som ikke er aktiveret efter deadline',
        [SystemProcedure.PaymentPlanCreationByCaseworker]: 'Når en sagsbehandler opretter en afdragsordning',
        [SystemProcedure.BankAccountDetailsApprovalRefund]: 'Bekræftelse på indtastning af kontooplysninger for udbetaling tilgodehavende',
        [SystemProcedure.DebtExpired]: 'Når en postering forældes',
        [SystemProcedure.DebtExpiresWithinThreeMonths]: 'Når der er tre måneder til, at en postering forældes',
        [SystemProcedure.DebtExpiresWithinThreeMonthsWithFoundation]: 'Når der er tre måneder til, at en postering forældes på sager med fundament',
        [SystemProcedure.DebtorCanBeRegisteredInDebtRegister]: 'Når debitor kan registreres i et åbent gældsregister, men dette endnu ikke er sket',
        [SystemProcedure.DebtorIsUnderage]: 'Når debitor registreres som umyndig',
        [SystemProcedure.Address]: 'Når debitors adresse opdateres',
        [SystemProcedure.Active]: 'Når debitor registreres aktiv',
        [SystemProcedure.Dead]: 'Når debitor går bort',
        [SystemProcedure.Disappeared]: 'Når debitor registreres forsvundet',
        [SystemProcedure.MovedAbroad]: 'Når debitor rejser ud af landet',
        [SystemProcedure.Homeless]: 'Når debitor registreres som hjemløs',
        [SystemProcedure.CompanyActive]: 'Når virksomheder registreres aktive',
        [SystemProcedure.Inactive]: 'Når en virksomhed registreres inaktiv',
        [SystemProcedure.OperationsCeased]: 'Når virksomheders drift ophører',
        [SystemProcedure.AddressProtection]: 'Når adresse- eller navnebeskyttelsesstatus ændres',
        [SystemProcedure.NewRKIRegristration]: 'Når en ny ekstern RKI-registrering tilføjes',
        [SystemProcedure.DeletedRKIRegistration]: 'Når en ekstern RKI-registrering slettes',
        [SystemProcedure.DeletedRKIRegistrationWillingnessToPay]: 'Når en ekstern RKI-registrering slettes med indikation på betalingsvilje',
        [SystemProcedure.GuardianStatus]: 'Når værge-status ændres',
        [SystemProcedure.DissolutionStatus]: 'Når en virksomhed går i opløsning',
        [SystemProcedure.AKSFailed]: 'Hvis AKS-tilmelding fejler',
        [SystemProcedure.BOBEHANDLING]: 'Når der skal bobehandles',
    },
    procedureTitles: {
        [SystemProcedureId.CreditorEndedCase]: 'Kreditor afslutter en sag',
        [SystemProcedureId.EndCase]: 'Sag fuldt betalt',
        [SystemProcedureId.Overpayment]: 'Overindbetaling',
        [SystemProcedureId.RemainderReminder]: 'Sag delvist betalt',
        [SystemProcedureId.EndCaseAccord]: 'Akkord betaling',
        [SystemProcedureId.PrincipalPayment]: 'Sag delvist betalt',
        [SystemProcedureId.PaymentOnCourtCase]: 'Betaling på sag i retten',
        [SystemProcedureId.Update]: 'Sag opdateret',
        [SystemProcedureId.PaymentPlanInitial]: 'Aktivering af afdragsordning',
        [SystemProcedureId.PaymentPlanReminder]: 'Påmindelse om afdrag',
        [SystemProcedureId.PaymentPlanPayment]: 'Betaling af afdrag',
        [SystemProcedureId.PaymentPlanAutoPaymentFailure]: 'Fejlslagen træk fra kort ifm. betaling af afdrag',
        [SystemProcedureId.PaymentPlanBSLSSubmitFailed]: 'Fejlslagen indsendelse af afdrag til BS/LS',
        [SystemProcedureId.PaymentPlanBSLSRejected]: 'Afvisning af afdrag via BS/LS',
        [SystemProcedureId.PaymentPlanBSLSAgreementCancelled]: 'BS/LS-aftale annulleret',
        [SystemProcedureId.PaymentPlanDeadline]: 'Deadline for afdrag',
        [SystemProcedureId.PaymentPlanCanceled]: 'Afdragsordning afsluttet',
        [SystemProcedureId.PaymentPlanTwoHourActivationReminder]: 'To timers aktiveringspåmindelse af afdragsordning',
        [SystemProcedureId.PaymentPlanOneDayActivationReminder]: 'En dags aktiveringspåmindelse af afdragsordning',
        [SystemProcedureId.PaymentPlanThreeDayActivationReminder]: 'Tre dages aktiveringspåmindelse af afdragsordning',
        [SystemProcedureId.PaymentPlanCreationByCaseworker]: 'Manuel afdragsoprettelelsestilbud',
        [SystemProcedureId.DebtExpired]: 'Gæld forældet',
        [SystemProcedureId.DebtExpiresWithinThreeMonths]: 'Gælden forældes indenfor 3 måneder',
        [SystemProcedureId.DebtExpiresWithinThreeMonthsWithFoundation]: 'Gælden forældes indenfor 3 måneder med fundament',
        [SystemProcedureId.DebtorCanBeRegisteredInDebtRegister]: 'Når debitor kan registreres i et åbent gældsregister, men dette endnu ikke er sket',
        [SystemProcedureId.DebtorIsUnderage]: 'Debitor er umyndig',
        [SystemProcedureId.Address]: 'Adresse',
        [SystemProcedureId.Active]: 'Aktiv',
        [SystemProcedureId.Dead]: 'Død',
        [SystemProcedureId.Disappeared]: 'Forsvundet',
        [SystemProcedureId.MovedAbroad]: 'Udrejst',
        [SystemProcedureId.Homeless]: 'Hjemløs',
        [SystemProcedureId.CompanyActive]: 'Virksomhed aktiv',
        [SystemProcedureId.Inactive]: 'Inaktiv',
        [SystemProcedureId.OperationsCeased]: 'Driftophør',
        [SystemProcedureId.AddressProtection]: 'Adresse- eller navnebeskyttelsesstatus',
        [SystemProcedureId.NewRKIRegristration]: 'Ny ekstern RKI-registrering',
        [SystemProcedureId.DeletedRKIRegistration]: 'Ekstern RKI-registrering slettet',
        [SystemProcedureId.DeletedRKIRegistrationWillingnessToPay]: 'Ekstern RKI-registrering slettet med indikation på betalingsvilje',
        [SystemProcedureId.GuardianStatus]: 'Værge-status',
        [SystemProcedureId.DissolutionStatus]: 'Virksomhedsopløsning',
        [SystemProcedureId.AKSFailed]: 'AKS-tilmelding fejlet',
        [SystemProcedureId.BOBEHANDLING]: 'Bobehandles',
    },
    procedureDescriptions: {
        [SystemProcedureId.CreditorEndedCase]: 'Kreditor afslutter en sag gennem API',
        [SystemProcedureId.EndCase]: 'Luk sagen og giv kontaktperson besked',
        [SystemProcedureId.Overpayment]: 'Der er betalt mere end der er opkrævet',
        [SystemProcedureId.RemainderReminder]: 'Sag delvist betalt. Giv kontaktperson besked',
        [SystemProcedureId.PrincipalPayment]: 'Sag delvist betalt. Giv kontaktperson besked',
        [SystemProcedureId.PaymentOnCourtCase]: 'Betaling på sag i retten. Giv retten besked',
        [SystemProcedureId.EndCaseAccord]: 'Afslut sag med akkord betaling',
        [SystemProcedureId.Update]: 'Sagens krav er opdateret',
        [SystemProcedureId.PaymentPlanInitial]: 'Send bekræftelse ved nyoprettet ordning',
        [SystemProcedureId.PaymentPlanReminder]: 'Send påmindelse inden betalingsfrist',
        [SystemProcedureId.PaymentPlanPayment]: 'Når en afdragsordning bliver afregnet korrekt',
        [SystemProcedureId.PaymentPlanAutoPaymentFailure]: 'Når en afdragsordning afregning fejler',
        [SystemProcedureId.PaymentPlanBSLSSubmitFailed]: 'Når en afdragsordning med BS eller LS fejler at planlægge en betaling',
        [SystemProcedureId.PaymentPlanBSLSRejected]: 'Når en afdragsordning med BS eller LS får afvist en betaling efter den første i måneden',
        [SystemProcedureId.PaymentPlanBSLSAgreementCancelled]: 'Når en afdragsordning med BS eller LS får annulleret en betalingsserviceaftale',
        [SystemProcedureId.PaymentPlanDeadline]: 'Når en afdragsordning ikke er betalt før frist',
        [SystemProcedureId.PaymentPlanCanceled]: 'Når en afdragsordning ikke er betalt efter at være givet en ekstra chance',
        [SystemProcedureId.PaymentPlanTwoHourActivationReminder]: 'Når en oprettet afdragsordning ikke er aktiveret efter to timer',
        [SystemProcedureId.PaymentPlanOneDayActivationReminder]: 'Når en oprettet afdragsordning ikke er aktiveret efter en dag',
        [SystemProcedureId.PaymentPlanThreeDayActivationReminder]: 'Når en oprettet afdragsordning ikke er aktiveret efter tre dage',
        [SystemProcedureId.PaymentPlanCreationByCaseworker]: 'Send tilbud for manuelt oprettet afdragsordning af en sagsbehandler',
        [SystemProcedureId.DebtExpired]: 'Gælden er forældet',
        [SystemProcedureId.DebtExpiresWithinThreeMonths]: 'Gælden forældes indenfor 3 måneder',
        [SystemProcedureId.DebtExpiresWithinThreeMonthsWithFoundation]: 'Gæld med fundament forældes indenfor 3 måneder',
        [SystemProcedureId.DebtorCanBeRegisteredInDebtRegister]: 'Når debitor kan registreres i et åbent gældsregister, men dette endnu ikke er sket',
        [SystemProcedureId.DebtorIsUnderage]: 'Debitor er umyndig',
        [SystemProcedureId.Address]: 'Når debitors adresse opdateres',
        [SystemProcedureId.Active]: 'Når debitor registreres aktiv',
        [SystemProcedureId.Dead]: 'Når debitor går bort',
        [SystemProcedureId.Disappeared]: 'Når debitor registreres forsvundet',
        [SystemProcedureId.MovedAbroad]: 'Når debitor rejser ud af landet',
        [SystemProcedureId.Homeless]: 'Når debitor registreres som hjemløs',
        [SystemProcedureId.CompanyActive]: 'Når virksomheder registreres aktive',
        [SystemProcedureId.Inactive]: 'Når en virksomhed registreres inaktiv',
        [SystemProcedureId.OperationsCeased]: 'Når virksomheders drift ophører',
        [SystemProcedureId.AddressProtection]: 'Når adresse- eller navnebeskyttelsesstatus ændres',
        [SystemProcedureId.NewRKIRegristration]: 'Når en ny ekstern RKI-registrering tilføjes',
        [SystemProcedureId.DeletedRKIRegistration]: 'Når en ekstern RKI-registrering slettes',
        [SystemProcedureId.DeletedRKIRegistrationWillingnessToPay]: 'Når en ekstern RKI-registrering slettes med indikation på betalingsvilje',
        [SystemProcedureId.GuardianStatus]: 'Når værge-status ændres',
        [SystemProcedureId.DissolutionStatus]: 'Når en virksomhed går i opløsning',
        [SystemProcedureId.AKSFailed]: 'Hvis AKS-tilmelding fejler',
        [SystemProcedureId.BOBEHANDLING]: 'Når der skal bobehandles',
    },
    panels: {
        filters: 'Filtre',
        selectAll: 'Vælg alt',
        totalDebt: 'Gæld i alt',
        clickToQueueText: 'Klik for at sætte de valgte sager i kø',
        queue: 'Gå til kø',
    },
    misc: {
        notChosen: 'Ikke valgt',
        copiedToClipboard: 'Kopieret til udklipsholder!',
        cosmoActivated: 'Aktiveret',
        searchForAccount: 'Søg efter bruger',
        create: 'Opret',
        createdAt: 'Oprettet',
        createdBy: 'Oprettet af',
        updatedAt: 'Opdateret',
        updatedBy: 'Opdateret af',
        approve: 'Godkend',
        cancel: 'Annuller',
        okay: 'Okay',
        submit: 'Indsend',
        save: 'Gem',
        saved: 'Gemt',
        edit: 'Rediger',
        update: 'Opdater',
        errorCreating: 'Fejl under oprettelse af',
        errorUpdating: 'Fejl under opdatering af',
        errorDeleting: 'Fejl under sletning af',
        errorPerforming: 'Fejl under udførsel i forbindelse med',
        language: 'Sprog',
        chooseFile: 'Vælg fil',
        yes: 'Ja',
        no: 'Nej',
        all: 'Alle',
        add: 'Tilføj',
        enabled: 'Aktiveret',
        search: 'Søg',
        contactSupport: 'Kontakt vores support',
        error: 'Fejl',
        errorOccured: 'Der er opstået en fejl',
        days: 'Dage',
        date: 'Dato',
        loadingError: 'Kunne ikke loade dataen',
        export: 'Eksportér',
        exported: 'Eksporteret',
        goToCase: 'Gå til sag',
        after: 'efter',
        skip: 'Spring over',
        value: 'Værdi',
        delete: 'Slet',
        apply: 'Anvend',
        unnamed: 'Ikke navngivet',
        learnMore: 'Lær mere',
        ascending: 'Stigende',
        descending: 'Faldende',
        id: 'Id',
        type: 'Type',
        text: 'Tekst',
        state: 'Status',
        limitReached: 'Maks grænse opnået',
    },
    table: {
        next: 'Næste',
        previous: 'Forrige',
        first: 'Første',
        last: 'Sidste',
        showing: 'Viser',
        outOf: 'ud af',
        loadMore: 'Load flere',
        from: 'Fra',
        to: 'Til',
        search: 'Søg',
        noData: 'Ingen data',
    },
    history: {
        history: 'Historik',
        searchHistory: 'Søg i historik',
        filterHistory: 'Filtrér historik',
        filterEconomy: 'Økonomi',
        filterBilling: 'Afregning',
        filterUpdates: 'Opdateringer',
        filterInteractions: 'Interaktioner',
        filterDebts: 'Gæld',
        filterDebtorTransactions: 'Transaktioner',
        filterNotifications: 'Notifikationer',
        filterCaseStatus: 'Sagsstatus',
        filterNotes: 'Noter',
        caseCreated: 'Sag oprettet',
        creditorDisbursement: 'Kreditorudlæg',
        creditorVat: 'Kreditormoms',
        creditorFee: 'Kreditorhonorar',
        deposit: 'Afregning af indbetaling',
    },
    connect: {
        fromConnectPartner: 'Kommer fra en connect partner',
        connection: 'Forbindelse',
        product: 'Produkt',
        updates: 'Opdateringer',
        mappedCases: 'Forbundne sager',
        updatedBy: 'Opdateret af ',
        partner: 'connect partner',
        us: 'denne tenant',
        thirdParty: 'en tredjepart',
        sendsToConn: 'Forbindelse sender sager til',
        sendsFromConn: 'Forbindelse modtager sager fra',
        histItemHeader: 'Connect -',
        histItemExported: 'Sendt til partner',
        histItemRetracted: 'Tilbagetrukket',
        histItemCompleted: 'Opgave afsluttet',
        histItemDataUpdated: 'Data opdateret',
        completedWithReason: 'Afsluttet med årsag',
        createdDocuments: 'Oprettede dokumenter',
        createdSatisfaction: 'Oprettet andmeldelse',
        goToConnection: 'Gå til forbindelse',
        goToCreditorWeb: 'Gå til kreditor web',
        goToProduct: 'Gå til produkt',
        goToCreditor: 'Gå til modtagende kreditor',
        goToCase: 'Gå til sag',
        creditorWebLinkError: 'Der skete en fejl da vi prøvede at finde linket til kreditor web',
        case: 'Sag',
        state: 'Status',
        exportedDate: 'Afsendelsesdato',
        completedDate: 'Afslutningsdato',
        connectStateCompleted: 'Afsluttet',
        connectStateInProgress: 'I gang',
    },
    connectConnectionUpdate: {
        [ConnectConnectionStatus.Active]: 'Aktiv',
        [ConnectConnectionStatus.Paused]: 'Sat på pause',
        [ConnectConnectionStatus.Disabled]: 'Deaktiveret',
    },
    connectCaseMappingUpdate: {
        [ConnectCaseMappingStatus.Exported]: 'Afsendt',
        [ConnectCaseMappingStatus.Retracted]: 'Tilbagekaldt',
        [ConnectCaseMappingStatus.Completed]: 'Afsluttet',
        [ConnectCaseMappingStatus.DataUpdated]: 'Data opdateret',
    },
    connectRetractionReason: {
        [RetractionReason.Collected]: 'Gæld indrevet',
        [RetractionReason.ConnectionDisabled]: 'Connect forbindelse deaktiveret',
        [RetractionReason.Rollback]: 'Rullet tilbage',
        [RetractionReason.Other]: 'Anden årsag',
    },
    product: {
        productHandles: 'Produktet udbyder',
    },
    productService: {
        [ProductService.Collection]: 'inddrivelse',
        [ProductService.CourtHandling]: 'retshåndtering',
    },
    documents: {
        documents: 'Dokumenter',
        noDocuments: 'Ingen dokumenter',
        deleteDocument: 'Slet dokument',
        saveDocument: 'Gem dokument',
        autoRKIAddFoundation: 'Auto-RKI er slået til og vil forsøge at flytte RKI registreringen til det åbne register efter tilføjelse af dette fundament',
        autoRKIUpdateFoundation: 'Auto-RKI er slået til og vil forsøge at flytte RKI registreringen til det åbne register efter opdateringen af dette fundament',
        file: 'File',
        signedFile: 'Underskrevet fil',
        createdBy: 'Oprettet af',
        docId: 'Doc ID',
        type: 'Type',
        signingLink: 'Link til underskrift',
        generateSigningLink: 'Generér link til underskrift',
        createdAt: 'Oprettet',
        date: 'Dato',
        signedAt: 'Dato for signering',
        addDocument: 'Tilføj dokument',
        fromFile: 'Fra fil',
        fromTemplate: 'Fra skabelon',
        selectCourt: 'Retskreds',
        documentSignedCheckbox: 'Er dokumentet signeret?',
        visibleForDebtor: 'Tilgængeligt for debitor',
        uploadDocument: 'Overfør dokument',
        createDocument: 'Opret dokument',
        preview: 'Forhåndsvisning',
        sendToCourt: 'Send direkte til retten',
        paidCourtFee: 'Samlet indbetalt afgift',
        createDate: 'Oprettelsesdato',
        interestDates: 'Rentedatoer',
        interestAmount: 'Renter',
        totalAmount: 'Beløb i alt',
        amount: 'Beløb',
        note: 'Note',
        procesinterest: 'Procesrente',
        interestFromSubmitOfBPK: 'Renter fra indlevering af betalingspåkrav',
        caseinterest: 'Sagsrenteprocent',
        preventForkyndt: 'Ønsker du betalingspåkravet forkyndt, hvis skyldner har afgivet insolvenserklæring i fogedretten, eller er under rekonstruktion, konkurs eller gældssanering og derfor er beskyttet mod udlæg?',
        preventAutDistress: 'Ønsker du, at fogedretten automatisk skal iværksætte udlæg, hvis skyldner ikke kommer med indsigelser (protester) mod dit krav?',
        preventAutCivilCourt: 'Ønsker du, at retssag automatisk skal indledes i civilretten på grundlag af betalingspåkravet, hvis skyldner kommer med indsigelser (protester) mod dit krav?',
        selectBPKWarningDate: 'Rykkerbrev er sendt den',
        selectType: 'Vælg dokumenttype',
        sureYouWantToDelete: 'Er du sikker på at du vil slette',
        sureYouWantToSave: 'Er du sikker på at du vil gemme ændringerne?',
        documentSigned: 'Dokument signeret',
        generateLinkForSigning: 'Generér link til digital signatur',
        addCourtDisbursementToClientBilling: 'Tilføj udlæg til kreditorafregning',
        addCourtFeeToClientBilling: 'Tilføj honorar til kreditorafregning',
        addCourtFeeToCase: 'Tilføj omkostning til sagen',
        sendInfoAboutRequisitionToRes: 'Send information om udbetalingsrekvisition til ansvarlig',
        responsible: 'Ansvarlig',
        isFoundation: 'Er fundament',
        [DocumentTypes.COURT]: 'Retsligt',
        [DocumentTypes.FOUNDATION]: 'Fundament',
        [DocumentTypes.OTHER]: 'Anden',
    },
    documentTypes: {
        [DocumentTypes.COURT]: 'Retsligt',
        [DocumentTypes.FOUNDATION]: 'Fundament',
        [DocumentTypes.OTHER]: 'Anden',
        [DocumentTypes.SKYLDERKLAERING]: 'Skylderklæring',
        [DocumentTypes.COURTOPGJORTOGFREMLAGT]: 'Opgjort og fremlagt i fogedretten',
        [DocumentTypes.FORLIG]: 'Forlig',
        [DocumentTypes.DOM]: 'Dom',
        [DocumentTypes.GAELDSBREV]: 'Gældsbrev',
    },
    files: {
        fileName: 'Filnavn',
        downloadFailed: 'Download fejlede',
    },
    updates: {
        pauseNow: 'Pause nu',
        continueCase: 'Fortsæt opgave',
        continueCaseRemove: 'Fjern',
        setRemindedAt: 'Angiv påmindelsesdato',
        remindDate: 'Påmind den',
        remindNow: 'Påmind nu',
        pauseUntilReminding: 'Pause d.',
        pauseContinueAt: 'Fortsæt d.',
        dateSelectorTooltip: 'Vælg den dato pausen skal træde i kraft',
        updateWillBeShownIn: 'Pauses om',
        paused: 'Pauset',
        reminded: 'påmindet',
        pausedAndReminded: 'Pauses og påmindes om',
        pausedUntil: 'Pauset indtil om',
        pausedAndRemindedPast: 'Pauset og påmindet for',
        ago: 'siden',
        pausedPast: 'Pauset for',
        andReminded: 'og påmindes om',
        andRemindedPast: 'og påmindet for',
        expedientAKSActivated: 'Experian AKS aktiveret',
        chooseMoreThanTwoBulkActions: 'Vælg venligst to eller flere for at lave en massebehandling.',
        bulkActions: 'Massebehandling',
        selectAll: 'Vælg alle',
    },
    integrateCalendar: {
        selectedUpdateTypes: 'Valgte sagstatusser',
        selectUpdateTypes: 'Vælg opgaver',
        selectUpdateTypesDescription: 'Din kalender opdateres kun med de opgaver, du vælger nedenfor. Systemet synkroniserer opgaver med påmindelser fra op til en måned tilbage og fremad.',
        orCopyLinkByClickingHere: 'Eller klik her for at kopiere det rå kalenderabbonnementslink',
        noSelectedYet: 'Ingen valgt endnu.',
        connectTo: 'Synkronisér med',
    },
    auth: {
        account: 'Konto',
        logout: 'Log ud',
    },
    rightNav: {
        creditors: 'Kreditorer',
    },
    login: {
        email: 'Emailadresse',
        password: 'Kodeord',
        login: 'Log ind',
        twoFactorExplainer: 'Vi har sendt en to-faktor-kode til din mail, som skal indtastes herunder for at logge ind.',
        twoFactorPlaceholder: 'Kode',
    },
    onboarding: {
        welcome: 'Velkommen',
        passwordCreatorExplainer: 'For at opsætte din konto, skal du vælge et kodeord.',
    },
    users: {
        userSettings: 'Brugerindstillinger',
        userCreated: 'Bruger oprettet',
        userUpdated: 'Bruger opdateret',
        updateFailed: 'Opdatering af bruger fejlede',
        createUser: 'Invitér bruger',
        inviteUser: 'Invitér bruger',
        name: 'Navn',
        role: 'Rolle',
        firstName: 'Fornavn',
        lastName: 'Efternavn',
        email: 'Email',
        phone: 'Telefon',
        username: 'Brugernavn',
        password: 'Password',
        users: 'Brugere',
        noUsers: 'Ingen brugere',
        newUser: 'Ny bruger',
        search: 'Søg brugere',
        passwordConfirmation: 'Bekræft password',
        creditors: 'Kreditorer',
        tenants: 'Tenants',
        todoNotifications: 'Modtag en email når der er usete todos eller notifikationer',
        selectCreditors: 'Vælg kreditorer',
        selectTenants: 'Vælg tenants',
        selectRole: 'Vælg rolle',
        selectUser: 'Vælg bruger',
        passwordTooShort: 'Password er for kort',
        passwordsDontMatch: 'Passwords er ikke ens',
        sendInvite: 'Send email invitation',
        sureYouWantToDeleteUser: 'Er du sikker på at du vil slette denne bruger permanent?',
        deleteUser: 'Slet bruger',
        deleteUserPermanently: 'Slet bruger permanent',
        changeRole: 'Skift brugers rolle',
        changeRoleNotAdmin: 'Ændring af roller kan udføres af en administrator',
        cantChangeClientRole: 'Kreditores rolle kan ikke ændres',
    },
    rolesDescription: {
        [PermissionLevels.admin]: 'Denne rolle er til virksomhedens administrator/superbruger, som har adgang til alle funktioner, samt kan konfigurere alle tilgængelige indstillinger.',
        [PermissionLevels.caseworker]: 'Denne rolle er til medarbejderen, der skal have adgang til alle nødvendige funktioner på sagsniveau. Der er desuden adgang til alt på kreditorniveau, og under indstillinger har rollen adgang til skabeloner.',
    },
    teams: {
        team: 'Team',
        user: 'Bruger',
        namePlaceholder: 'Team navn',
        saveName: 'Gem',
        searchNewTeamMember: 'Søg efter bruger som skal tilføjes til teamet',
        createTeam: 'Opret team',
        assignedTasks: 'Ansvarlige for opgaver',
        catchAll: 'Catch all',
        responsibleForUpdateTypes: 'Ansvarlige for opgaver',
        addUpdateType: 'Tilføj opgavetype',
        selectTeam: 'Team',
        selectUser: 'Bruger',
        responsibleForCase: 'Ansvarlig for sag',
    },
    invite: {
        subject: 'Invitation til at få adgang',
        body: `Hej \${firstName},

Du er blevet inviteret til at bruge \${platform}. For at logge ind, skal du trykke på følgende link.
\${url}?nu_token=\${token}`,
        html: `<p>Hej \${firstName},</p><p>Du er blevet inviteret til at bruge \${platform}. For at logge ind, skal du trykke på følgende link.</p>`,
        linkText: 'Log ind',
        creditorWeb: 'kreditorwebbet fra',
    },
    roles: {
        'super-admin': 'Super admin',
        admin: 'Administrator',
        caseworker: 'Sagsbehandler',
        client: 'Kreditor',
        debtor: 'Debitor',
        'alternative-contact': 'Repræsentant',
        unauthorized: 'Uautoriseret',
    },
    mentionsConditional: {
        if: 'Hvis',
        endIf: 'Slut hvis',
    },
    mentions: {
        [TemplateMention.GENERIC_EMAIL_SUBJECT]: 'Generisk emnefelt',
        [TemplateMention.FINANCIALS_PRICIPAL]: 'Hovedstol',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_FEES]: 'Inkassogebyr',
        [TemplateMention.FINANCIALS_ADMINISTRATION_COSTS]: 'Administrationsomkostninger',
        [TemplateMention.FINANCIALS_COMPENSATION_FEES]: 'Kompensationsgebyrer',
        [TemplateMention.FINANCIALS_INTERESTS]: 'Renter',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_COSTS]: 'Inkassoomkostninger',
        [TemplateMention.PRINCIPAL_REFERENECE_IDS]: 'Hovedstolens referencenumre',
        [TemplateMention.CURRENCY]: 'Valuta',
        [TemplateMention.PAYMENT_PLAN_FIRST_AMOUNT]: 'Afdragsordning første beløb',
        [TemplateMention.PAYMENT_PLAN_FIRST_DEADLINE]: 'Afdragsordning første deadline',
        [TemplateMention.PAYMENT_PLAN_FIRST_DATE]: 'Afdragsordning første dato',
        [TemplateMention.PAYMENT_PLAN_LAST_AMOUNT]: 'Afdragsordning sidste beløb',
        [TemplateMention.PAYMENT_PLAN_LAST_DEADLINE]: 'Afdragsordning sidste deadline',
        [TemplateMention.PAYMENT_PLAN_LAST_DATE]: 'Afdragsordning sidste dato',
        [TemplateMention.PAYMENT_PLAN_ENTRY_AMOUNT]: 'Afdragsordning beløb pr. afdrag',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DEADLINE]: 'Afdragsordning deadline for afdrag',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DATE]: 'Afdragsordning dato for afdrag',
        [TemplateMention.PAYMENT_PLAN_CREATION_DATE]: 'Afdragsordning oprettet dato',
        [TemplateMention.PAYMENT_PLAN_LENGTH_IN_DAYS]: 'Afdragsordningens længde i dage',
        [TemplateMention.PAYMENT_PLAN_YEARLY_COSTS]: 'ÅOP',
        [TemplateMention.PAYMENT_PLAN_HAS_YEARLY_INTEREST]: 'Hvis sag har renter p.a.',
        [TemplateMention.PAYMENT_PLAN_MIN_ENTRY_AMOUNT]: 'Afdragsordning min. afdrag',
        [TemplateMention.PAYMENT_PLAN_MAX_ENTRY_AMOUNT]: 'Afdragsordning maks. afdrag',
        [TemplateMention.TOTAL_DEBT]: 'Total gæld',
        [TemplateMention.OVERPAYMENT]: 'Tilgodehavende',
        [TemplateMention.ACCORD_TEN_PERCENT]: 'Akkord: 10 %',
        [TemplateMention.ACCORD_TWENTY_PERCENT]: 'Akkord: 20 %',
        [TemplateMention.ACCORD_THIRTY_PERCENT]: 'Akkord: 30 %',
        [TemplateMention.ACCORD_FORTY_PERCENT]: 'Akkord: 40 %',
        [TemplateMention.ACCORD_FIFTY_PERCENT]: 'Akkord: 50 %',
        [TemplateMention.ACCORD_SIXTY_PERCENT]: 'Akkord: 60 %',
        [TemplateMention.ACCORD_SEVENTY_PERCENT]: 'Akkord: 70 %',
        [TemplateMention.ACCORD_EIGHTY_PERCENT]: 'Akkord: 80 %',
        [TemplateMention.ACCORD_NINETY_PERCENT]: 'Akkord: 90 %',
        [TemplateMention.IF_IS_COMPANY]: 'Hvis sagen er erhverv',
        [TemplateMention.IF_CASE_HAS_REMINDER_FEES]: 'Hvis sagen har rykkergebyrer',
        [TemplateMention.IF_CASE_HAS_COLLECTION_FEES]: 'Hvis sagen har inkassogebyrer',
        [TemplateMention.IF_CASE_HAS_COLLECTION_COSTS]: 'Hvis sagen har inkassoomkostninger',
        [TemplateMention.IF_CASE_HAS_COMPENSATION_COSTS]: 'Hvis sagen har kompensationsomkostninger',
        [TemplateMention.IF_CASE_HAS_PROCESSRENTE]: 'Hvis sagen har procesrente',
        [TemplateMention.IF_CASE_HAS_FIXED_INTEREST]: 'Hvis sagen har fast rente',
        [TemplateMention.IF_CASE_HAS_YEARLT_INTEREST]: 'Hvis sagen har årlig rente i procent',
        [TemplateMention.IF_CASE_HAS_DEPOSIT]: 'Hvis sagen har indbetaling',
        [TemplateMention.DOCUMENTATION]: 'Dokumentation',
        [TemplateMention.DATE]: 'Dato',
        [TemplateMention.DATE_IN_THREE_DAYS]: 'Dato om 3 dage',
        [TemplateMention.DATE_IN_SIX_DAYS]: 'Dato om 6 dage',
        [TemplateMention.DATE_IN_TEN_DAYS]: 'Dato om 10 dage',
        [TemplateMention.DATE_IN_ELEVEN_DAYS]: 'Dato om 11 dage',
        [TemplateMention.DATE_IN_TWELVE_DAYS]: 'Dato om 12 dage',
        [TemplateMention.DATE_IN_FOURTEEN_DAYS]: 'Dato om 14 dage',
        [TemplateMention.DATE_IN_SEVENTEEN_DAYS]: 'Dato om 17 dage',
        [TemplateMention.DATE_IN_THIRTY_DAYS]: 'Dato om 30 dage',
        [TemplateMention.DEPOSIT]: 'Indbetalt',
        [TemplateMention.DEPOSITS_TO_CREDITOR]: 'Indbetalt til kreditor',
        [TemplateMention.DEPOSITS_TO_COLLECTOR]: 'Indbetalt til inddriver',
        [TemplateMention.PRINCIPALS_WITH_INTEREST]: 'Hovedstole med renter',
        [TemplateMention.CONTACT_NAME]: 'Kontaktpersons navn',
        [TemplateMention.DEBTOR_NAME]: 'Debitornavn',
        [TemplateMention.DEBTOR_FIRST_NAME]: 'Debitorfornavn',
        [TemplateMention.CONTACT_ADDRESS]: 'Kontaktpersons adresse',
        [TemplateMention.CONTACT_COADDRESS]: 'Kontaktpersons c/o',
        [TemplateMention.CONTACT_ZIPCODE]: 'Kontaktpersons postnummer',
        [TemplateMention.CONTACT_CITY]: 'Kontaktpersons by',
        [TemplateMention.CONTACT_COUNTRY]: 'Kontaktpersons land',
        [TemplateMention.DEBTOR_ADDRESS]: 'Debitors vej',
        [TemplateMention.DEBTOR_COADDRESS]: 'Debitors c/o',
        [TemplateMention.DEBTOR_ZIPCODE]: 'Debitors postnummer',
        [TemplateMention.DEBTOR_CITY]: 'Debitors by',
        [TemplateMention.DEBTOR_COUNTRY]: 'Debitors land',
        [TemplateMention.DEBTOR_EMAIL]: 'Debitors email',
        [TemplateMention.DEBTOR_PHONE]: 'Debitors telefonnummer',
        [TemplateMention.LAST_PAYMENT_DATE]: 'Dato for seneste betaling',
        [TemplateMention.LAST_PAYMENT_AMOUNT]: 'Beløb af seneste betaling',
        [TemplateMention.DEBTOR_SEQ_ID]: 'Debitor Sek ID',
        [TemplateMention.DEBTOR_CVR_AND_OR_CPR]: 'Debitor CVR og/eller CPR',
        [TemplateMention.CREDITOR_NAME]: 'Kreditornavn',
        [TemplateMention.CASE_ID]: 'Sags-id',
        [TemplateMention.CASE_REFERENCE_ID]: 'Sagsreferencenummer',
        [TemplateMention.CREDITOR_ADDRESS]: 'Kreditors adresse',
        [TemplateMention.CREDITOR_IF_IS_COMPANY]: 'Hvis kreditor er en virksomhed',
        [TemplateMention.USER_NAME]: 'Brugerens navn',
        [TemplateMention.USER_FIRST_NAME]: 'Brugerens fornavn',
        [TemplateMention.IF_USER]: 'Hvis brugeren er tilgængelig',
        [TemplateMention.IF_COLLECTOR_ALLOWS_BANK_TRANSFERS]: 'Hvis inddriver tillader bankoverførsler',
        [TemplateMention.IF_COLLECTOR_ALLOWS_FI_PAYMENTS]: 'Hvis inddriver tillader FIK-betalinger',
        [TemplateMention.REMINDER_FEES]: 'Rykkergebyrer',
        [TemplateMention.COLLECTOR_PAYMENT_OPTIONS]: 'Betalingsmuligheder',
        [TemplateMention.COLLECTOR_ACCOUNT_NUMBER]: 'Inddrivers kontonr.',
        [TemplateMention.COLLECTOR_REGISTER_NUMBER]: 'Inddrivers reg.nr.',
        [TemplateMention.COLLECTOR_PHONE]: 'Inddrivers telefonnummer',
        [TemplateMention.COLLECTOR_COURT_PHONE]: 'Inddrivers retstelefonnummer',
        [TemplateMention.COLLECTOR_EMAIL]: 'Inddrivers email',
        [TemplateMention.COLLECTOR_NICKNAME]: 'Inddrivers kaldenavn',
        [TemplateMention.COLLECTOR_NAME]: 'Inddrivers navn',
        [TemplateMention.COLLECTOR_ADDRESS_ADDRESS]: 'Inddrivers adresse',
        [TemplateMention.COLLECTOR_ADDRESS_CITY]: 'Inddrivers by',
        [TemplateMention.COLLECTOR_ADDRESS_ZIP]: 'Inddrivers postnummer',
        [TemplateMention.COLLECTOR_CVR]: 'Inddrivers CVR',
        [TemplateMention.CREDITOR_ZIPCODE]: 'Kreditors postnummer',
        [TemplateMention.CREDITOR_CITY]: 'Kreditors by',
        [TemplateMention.CREDITOR_COMPANY_IDENTIFIER]: 'Kreditors CVR',
        [TemplateMention.PAYMENT_ID]: 'Betalings-ID',
        [TemplateMention.JOURNAL_NUMBER]: 'Journalnummer',
        [TemplateMention.CIVIL_COURT_NAME]: 'Civilrettens navn',
        [TemplateMention.CIVIL_COURT_ADDRESS]: 'Civilrettens adresse',
        [TemplateMention.CIVIL_COURT_CITY]: 'Civilrettens by',
        [TemplateMention.CIVIL_COURT_ZIP]: 'Civilrettens postnummer',
        [TemplateMention.CIVIL_COURT_EMAIL]: 'Civilrettens email',
        [TemplateMention.CIVIL_COURT_PHONE]: 'Civilrettens telefonnummer',
        [TemplateMention.CIVIL_COURT_EAN]: 'Civilrettens EAN',
        [TemplateMention.CIVIL_REG_NO]: 'Civilrettens reg.nr',
        [TemplateMention.CIVIL_ACCOUNT_NO]: 'Civilrettens kontonr.',
        [TemplateMention.PAYMENT_PLAN_HTML]: 'Afdragsordning oversigt over afdrag',
        [TemplateMention.CONTACT_ADDRESS_INLINE]: 'Konktaktpersons adresse inline',
        [TemplateMention.CONTACT_ADDRESS_FORMATTED]: 'Konktaktpersons adresse formateret',
        [TemplateMention.ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Repræsentantens journalnummer',
        [TemplateMention.HAS_ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Hvis repræsentant har journalnummer',
        [TemplateMention.DEBTOR_ADDRESS_INLINE]: 'Debitors adresse inline',
        [TemplateMention.DEBTOR_ADDRESS_FORMATTED]: 'Debitors adresse formateret',
        [TemplateMention.DEBT_TABLE]: 'Gældsoversigt',
        [TemplateMention.DEBT_SPECIFICATION]: 'Specifikation af gæld',
        [TemplateMention.DEBT_OVERVIEW]: 'Kategoriseret gældsoverblik',
        [TemplateMention.SIGN_FIELDS]: 'Underskriftsfelter',
        [TemplateMention.BPK]: 'Betalingspåkrav',
        [TemplateMention.GL_BPK]: 'GL Betalingspåkrav',
        [TemplateMention.PAGE_BREAK]: 'Sideskift',
        [TemplateMention.PAYMENT_LINK]: 'Link betaling',
        [TemplateMention.DEBTOR_WEB_LINK]: 'Link debitorweb',
        [TemplateMention.DEBTOR_WEB_LONG_LINK]: 'Langt link debitorweb',
        [TemplateMention.PAYMENT_PLAN_LINK]: 'Link afdragsordning',
        [TemplateMention.OVERPAYMENT_LINK]: 'Link udbetaling',
        [TemplateMention.OVERPAYMENT_LINK_QR_CODE]: 'Link til udbetaling QR-kode',
        [TemplateMention.OVERPAYMENT_LINK_A_TAG]: 'Link til udbetaling',
        [TemplateMention.PAYMENT_PLAN_ENTRIES_TAG]: 'Afdragsordning betalinger',
        [TemplateMention.SATISFACTION_BUTTONS]: 'Tilfredshedsundersøgelsesknapper',
        [TemplateMention.PAYMENT_LINK_A_TAG]: 'Link til betaling',
        [TemplateMention.PAYMENT_PLAN_LINK_A_TAG]: 'Link til afdragsordning',
        [TemplateMention.DEBTOR_WEB_LINK_A_TAG]: 'Link til debitorweb',
        [TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG]: 'Link til debitorweb med langt link',
        [TemplateMention.DEBTOR_WEB_LINK_QR_CODE]: 'Link til debitorweb QR-kode',
        [TemplateMention.PAYMENT_PLAN_LINK_QR_CODE]: 'Link til afdragsordning QR-kode',
        [TemplateMention.PAYMENT_LINK_QR_CODE]: 'Link til betaling QR-kode',
        [TemplateMention.CONDITIONAL_ELSE]: 'Ellers',
        [TemplateMention.CONDITIONAL_END_IF]: 'Slut hvis',
        [TemplateMention.BANK_CREDITOR_NUMBER]: '',
        [TemplateMention.SIGNATURE_TIRANA]: '',
        [TemplateMention.SIGNATURE_MICHAEL_BRANDT]: '',
        [TemplateMention.RKI_WARNING]: 'RKI varsel',
        [TemplateMention.FOUNDATION_TYPE]: 'Fundamentstype',
        [TemplateMention.FOUNDATION_DATE]: 'Fundamentsdato',
        [TemplateMention.LATEST_TRIBUNAL_REFERENCE]: 'Nyeste FS-nummer',
    },
    mentionsExplanation: {
        [TemplateMention.GENERIC_EMAIL_SUBJECT]: 'Tekst til emnefeltet på email',
        [TemplateMention.FINANCIALS_PRICIPAL]: 'Sagens samlede hovedstol',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_FEES]: 'Sagens samlede inkassogebyr',
        [TemplateMention.FINANCIALS_ADMINISTRATION_COSTS]: 'Sagens samlede administrationsomkostninger',
        [TemplateMention.FINANCIALS_COMPENSATION_FEES]: 'Sagens samlede kompensationsomkostninger',
        [TemplateMention.FINANCIALS_INTERESTS]: 'Sagens samlede renter',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_COSTS]: 'Sagens samlede inkassoomkostninger',
        [TemplateMention.PRINCIPAL_REFERENECE_IDS]: 'Hovedstolens referencenumre',
        [TemplateMention.CURRENCY]: 'Valuta for sagens økonomi',
        [TemplateMention.PAYMENT_PLAN_FIRST_AMOUNT]: 'Beløbet på første afdrag',
        [TemplateMention.PAYMENT_PLAN_FIRST_DEADLINE]: 'Forfaldsdato for første afdrag',
        [TemplateMention.PAYMENT_PLAN_FIRST_DATE]: 'Dato for første afdrag',
        [TemplateMention.PAYMENT_PLAN_LAST_AMOUNT]: 'Beløbet på sidste afdrag',
        [TemplateMention.PAYMENT_PLAN_LAST_DEADLINE]: 'Forfaldsdato for sidste afdrag',
        [TemplateMention.PAYMENT_PLAN_LAST_DATE]: 'Dato for sidste afdrag',
        [TemplateMention.PAYMENT_PLAN_ENTRY_AMOUNT]: 'Beløbet på seneste afdrag',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DEADLINE]: 'Forfaldsdato for seneste afdrag',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DATE]: 'Dato for seneste afdrag',
        [TemplateMention.PAYMENT_PLAN_CREATION_DATE]: 'Oprettelsesdato for afdragsordningen',
        [TemplateMention.PAYMENT_PLAN_LENGTH_IN_DAYS]: 'Afdragsordningens længde i dage',
        [TemplateMention.PAYMENT_PLAN_YEARLY_COSTS]: 'ÅOP opgørelse for adragsordningen',
        [TemplateMention.PAYMENT_PLAN_HAS_YEARLY_INTEREST]: 'Hvis sag har renter p.a.',
        [TemplateMention.PAYMENT_PLAN_MIN_ENTRY_AMOUNT]: 'Afdragsordning min. afdrag per måned',
        [TemplateMention.PAYMENT_PLAN_MAX_ENTRY_AMOUNT]: 'Afdragsordning maks. afdrag per måned',
        [TemplateMention.TOTAL_DEBT]: 'Beløbet på den totale gæld',
        [TemplateMention.OVERPAYMENT]: 'Beløbet af tilgodehavende',
        [TemplateMention.ACCORD_TEN_PERCENT]: 'Beløbet på den totale gæld fratrukket 10%',
        [TemplateMention.ACCORD_TWENTY_PERCENT]: 'Beløbet på den totale gæld fratrukket 20 %',
        [TemplateMention.ACCORD_THIRTY_PERCENT]: 'Beløbet på den totale gæld fratrukket 30 %',
        [TemplateMention.ACCORD_FORTY_PERCENT]: 'Beløbet på den totale gæld fratrukket 40 %',
        [TemplateMention.ACCORD_FIFTY_PERCENT]: 'Beløbet på den totale gæld fratrukket 50 %',
        [TemplateMention.ACCORD_SIXTY_PERCENT]: 'Beløbet på den totale gæld fratrukket 60 %',
        [TemplateMention.ACCORD_SEVENTY_PERCENT]: 'Beløbet på den totale gæld fratrukket 70 %',
        [TemplateMention.ACCORD_EIGHTY_PERCENT]: 'Beløbet på den totale gæld fratrukket 80 %',
        [TemplateMention.ACCORD_NINETY_PERCENT]: 'Beløbet på den totale gæld fratrukket 90 %',
        [TemplateMention.IF_IS_COMPANY]: 'Hvis sagen er erhverv',
        [TemplateMention.IF_CASE_HAS_REMINDER_FEES]: 'Hvis sagen har rykkergebyrer',
        [TemplateMention.IF_CASE_HAS_COLLECTION_FEES]: 'Hvis sagen har inkassogebyrer',
        [TemplateMention.IF_CASE_HAS_COLLECTION_COSTS]: 'Hvis sagen har inkassoomkostninger',
        [TemplateMention.IF_CASE_HAS_COMPENSATION_COSTS]: 'Hvis sagen har kompensationsomkostninger',
        [TemplateMention.IF_CASE_HAS_PROCESSRENTE]: 'Hvis sagen har procesrente',
        [TemplateMention.IF_CASE_HAS_FIXED_INTEREST]: 'Hvis sagen har fast rente',
        [TemplateMention.IF_CASE_HAS_YEARLT_INTEREST]: 'Hvis sagen har årlig rente i procent',
        [TemplateMention.IF_CASE_HAS_DEPOSIT]: 'Hvis sagen har indbetaling',
        [TemplateMention.DOCUMENTATION]: 'Dokumentation',
        [TemplateMention.DATE]: 'Dags dato',
        [TemplateMention.DATE_IN_THREE_DAYS]: 'Dato om 3 dage',
        [TemplateMention.DATE_IN_SIX_DAYS]: 'Dato om 6 dage',
        [TemplateMention.DATE_IN_TEN_DAYS]: 'Dato om 10 dage',
        [TemplateMention.DATE_IN_ELEVEN_DAYS]: 'Dato om 11 dage',
        [TemplateMention.DATE_IN_TWELVE_DAYS]: 'Dato om 12 dage',
        [TemplateMention.DATE_IN_FOURTEEN_DAYS]: 'Dato om 14 dage',
        [TemplateMention.DATE_IN_SEVENTEEN_DAYS]: 'Dato om 17 dage',
        [TemplateMention.DATE_IN_THIRTY_DAYS]: 'Dato om 30 dage',
        [TemplateMention.DEPOSIT]: 'Beløbet der er indbetalt',
        [TemplateMention.DEPOSITS_TO_CREDITOR]: 'Beløbet indbetalt til kreditor',
        [TemplateMention.DEPOSITS_TO_COLLECTOR]: 'Beløbet indbetalt til inddriver',
        [TemplateMention.PRINCIPALS_WITH_INTEREST]: 'Liste over alle posteringer med kategorien hovedstol og de renter der er pålagt dem fra hvilken dato',
        [TemplateMention.CONTACT_NAME]: 'Kontaktpersons navn',
        [TemplateMention.DEBTOR_NAME]: 'Debitornavn',
        [TemplateMention.DEBTOR_FIRST_NAME]: 'Debitorfornavn',
        [TemplateMention.CONTACT_ADDRESS]: 'Kontaktpersons adresse',
        [TemplateMention.CONTACT_COADDRESS]: 'Kontaktpersons c/o',
        [TemplateMention.CONTACT_ZIPCODE]: 'Kontaktpersons postnummer',
        [TemplateMention.CONTACT_CITY]: 'Kontaktpersons by',
        [TemplateMention.CONTACT_COUNTRY]: 'Kontaktpersons land',
        [TemplateMention.DEBTOR_ADDRESS]: 'Debitors vej',
        [TemplateMention.DEBTOR_COADDRESS]: 'Debitors c/o',
        [TemplateMention.DEBTOR_ZIPCODE]: 'Debitors postnummer',
        [TemplateMention.DEBTOR_CITY]: 'Debitors by',
        [TemplateMention.DEBTOR_COUNTRY]: 'Debitors land',
        [TemplateMention.DEBTOR_EMAIL]: 'Debitors email',
        [TemplateMention.DEBTOR_PHONE]: 'Debitors telefonnummer',
        [TemplateMention.LAST_PAYMENT_DATE]: 'Dato for seneste indbetaling',
        [TemplateMention.LAST_PAYMENT_AMOUNT]: 'Beløb af seneste indbetaling',
        [TemplateMention.DEBTOR_SEQ_ID]: 'Debitors ID',
        [TemplateMention.DEBTOR_CVR_AND_OR_CPR]: 'Debitors CVR og/eller CPR',
        [TemplateMention.CREDITOR_NAME]: 'Kreditornavn',
        [TemplateMention.CASE_ID]: 'Sags-id',
        [TemplateMention.CASE_REFERENCE_ID]: 'Sagsreferencenummer',
        [TemplateMention.REMINDER_FEES]: 'Sagens samlede rykkergebyr',
        [TemplateMention.CREDITOR_ADDRESS]: 'Kreditors adresse',
        [TemplateMention.USER_NAME]: 'Debbie-brugerens navn',
        [TemplateMention.USER_FIRST_NAME]: 'Debbie-brugerens fornavn',
        [TemplateMention.IF_USER]: 'Hvis Debbie-brugeren er tilgængelig',
        [TemplateMention.CREDITOR_IF_IS_COMPANY]: 'Hvis kreditor er en virksomhed',
        [TemplateMention.IF_COLLECTOR_ALLOWS_BANK_TRANSFERS]: 'Hvis inddriver tillader bankoverførsler',
        [TemplateMention.IF_COLLECTOR_ALLOWS_FI_PAYMENTS]: 'Hvis inddriver tillader FIK-betalinger',
        [TemplateMention.COLLECTOR_PAYMENT_OPTIONS]: 'Betalingsmuligheder',
        [TemplateMention.COLLECTOR_ACCOUNT_NUMBER]: 'Inddrivers kontonr.',
        [TemplateMention.COLLECTOR_REGISTER_NUMBER]: 'Inddrivers reg.nr.',
        [TemplateMention.COLLECTOR_PHONE]: 'Inddrivers telefonnummer',
        [TemplateMention.COLLECTOR_COURT_PHONE]: 'Inddrivers retstelefonnummer',
        [TemplateMention.COLLECTOR_EMAIL]: 'Inddrivers email',
        [TemplateMention.COLLECTOR_NICKNAME]: 'Inddrivers kaldenavn',
        [TemplateMention.COLLECTOR_NAME]: 'Inddrivers navn',
        [TemplateMention.COLLECTOR_ADDRESS_ADDRESS]: 'Inddrivers adresse',
        [TemplateMention.COLLECTOR_ADDRESS_CITY]: 'Inddrivers by',
        [TemplateMention.COLLECTOR_ADDRESS_ZIP]: 'Inddrivers postnummer',
        [TemplateMention.COLLECTOR_CVR]: 'Inddrivers CVR',
        [TemplateMention.CREDITOR_ZIPCODE]: 'Kreditors postnummer',
        [TemplateMention.CREDITOR_CITY]: 'Kreditors by',
        [TemplateMention.CREDITOR_COMPANY_IDENTIFIER]: 'Kreditors CVR',
        [TemplateMention.PAYMENT_ID]: 'Betalings-ID / FIK nummer',
        [TemplateMention.JOURNAL_NUMBER]: 'Journalnummer',
        [TemplateMention.CIVIL_COURT_NAME]: 'Civilrettens navn',
        [TemplateMention.CIVIL_COURT_ADDRESS]: 'Civilrettens adresse',
        [TemplateMention.CIVIL_COURT_CITY]: 'Civilrettens by',
        [TemplateMention.CIVIL_COURT_ZIP]: 'Civilrettens postnummer',
        [TemplateMention.CIVIL_COURT_EMAIL]: 'Civilrettens email',
        [TemplateMention.CIVIL_COURT_PHONE]: 'Civilrettens telefonnummer',
        [TemplateMention.CIVIL_COURT_EAN]: 'Civilrettens EAN',
        [TemplateMention.CIVIL_REG_NO]: 'Civilrettens reg.nr',
        [TemplateMention.CIVIL_ACCOUNT_NO]: 'Civilrettens kontonr.',
        [TemplateMention.PAYMENT_PLAN_HTML]: 'Oversigt over afrdag',
        [TemplateMention.CONTACT_ADDRESS_INLINE]: 'Konktaktpersons fulde adresse på én linje',
        [TemplateMention.CONTACT_ADDRESS_FORMATTED]: 'Konktaktpersons fulde adresse på flere linjer',
        [TemplateMention.ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Repræsentantens journalnummer',
        [TemplateMention.HAS_ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Hvis repræsentant har journalnummer',
        [TemplateMention.DEBTOR_ADDRESS_INLINE]: 'Debitors fulde adresse på én linje',
        [TemplateMention.DEBTOR_ADDRESS_FORMATTED]: 'Debitors fulde adresse på flere linjer',
        [TemplateMention.DEBT_TABLE]: 'Tabel over gældsoversigt',
        [TemplateMention.DEBT_SPECIFICATION]: 'Specifikation af hver faktura',
        [TemplateMention.DEBT_OVERVIEW]: 'Kategoriseret gældsoverblik',
        [TemplateMention.SIGN_FIELDS]: 'Underskriftsfelter',
        [TemplateMention.BPK]: 'PDF for betalingspåkrav',
        [TemplateMention.GL_BPK]: 'PDF for GL Betalingspåkrav',
        [TemplateMention.PAGE_BREAK]: 'Sideskift',
        [TemplateMention.PAYMENT_LINK]: 'Link til at betale hele gælden',
        [TemplateMention.DEBTOR_WEB_LINK]: 'Link til debitor web',
        [TemplateMention.DEBTOR_WEB_LONG_LINK]: 'Link til debitor web med langt link',
        [TemplateMention.PAYMENT_PLAN_LINK]: 'Link til at underskrive afdragsordning',
        [TemplateMention.OVERPAYMENT_LINK]: 'Link udbetaling',
        [TemplateMention.OVERPAYMENT_LINK_QR_CODE]: 'Link til udbetaling QR-kode',
        [TemplateMention.OVERPAYMENT_LINK_A_TAG]: 'Link til udbetaling',
        [TemplateMention.PAYMENT_LINK_A_TAG]: 'Link til at betale hele gælden',
        [TemplateMention.PAYMENT_PLAN_ENTRIES_TAG]: 'Tabel over alle adrag, dato og status',
        [TemplateMention.SATISFACTION_BUTTONS]: 'Tilfredshedsundersøgelsesknapper',
        [TemplateMention.PAYMENT_PLAN_LINK_A_TAG]: 'Link til at underskrive afdragsordning',
        [TemplateMention.DEBTOR_WEB_LINK_A_TAG]: 'Link til debitorweb',
        [TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG]: 'Link til debitor web med langt link',
        [TemplateMention.DEBTOR_WEB_LINK_QR_CODE]: 'Link til debitorweb (QR-kode)',
        [TemplateMention.PAYMENT_PLAN_LINK_QR_CODE]: 'Link til afdragsordning (QR-kode)',
        [TemplateMention.PAYMENT_LINK_QR_CODE]: 'Link til betaling (QR-kode)',
        [TemplateMention.CONDITIONAL_ELSE]: 'Ellers',
        [TemplateMention.CONDITIONAL_END_IF]: 'Slut hvis',
        [TemplateMention.BANK_CREDITOR_NUMBER]: '',
        [TemplateMention.SIGNATURE_TIRANA]: '',
        [TemplateMention.SIGNATURE_MICHAEL_BRANDT]: '',
        [TemplateMention.RKI_WARNING]: 'RKI varsel',
        [TemplateMention.FOUNDATION_TYPE]: 'Fundamentstype',
        [TemplateMention.FOUNDATION_DATE]: 'Fundamentsdato',
        [TemplateMention.LATEST_TRIBUNAL_REFERENCE]: 'Nyeste FS-nummer',
    },
    mentionsExample: {
        [TemplateMention.GENERIC_EMAIL_SUBJECT]: 'Vedrørende din gæld til Testkreditor ApS [j.nr.: 171001-171533]',
        [TemplateMention.FINANCIALS_PRICIPAL]: '8.570,14 ',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_FEES]: '100,00',
        [TemplateMention.FINANCIALS_ADMINISTRATION_COSTS]: '175,00',
        [TemplateMention.FINANCIALS_COMPENSATION_FEES]: '310,00',
        [TemplateMention.FINANCIALS_INTERESTS]: '26,70 ',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_COSTS]: '700,00',
        [TemplateMention.PRINCIPAL_REFERENECE_IDS]: '123, 124 og 125',
        [TemplateMention.CURRENCY]: 'DKK',
        [TemplateMention.PAYMENT_PLAN_FIRST_AMOUNT]: '200,00',
        [TemplateMention.PAYMENT_PLAN_FIRST_DEADLINE]: '20. oktober 2021',
        [TemplateMention.PAYMENT_PLAN_FIRST_DATE]: '15. oktober 2021',
        [TemplateMention.PAYMENT_PLAN_LAST_AMOUNT]: '170,14',
        [TemplateMention.PAYMENT_PLAN_LAST_DEADLINE]: '20. august 2024',
        [TemplateMention.PAYMENT_PLAN_LAST_DATE]: '15. august 2024',
        [TemplateMention.PAYMENT_PLAN_ENTRY_AMOUNT]: '200,00',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DEADLINE]: '20. november 2021',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DATE]: '15. november 20211',
        [TemplateMention.PAYMENT_PLAN_CREATION_DATE]: '17. september 2021',
        [TemplateMention.PAYMENT_PLAN_LENGTH_IN_DAYS]: '1035',
        [TemplateMention.PAYMENT_PLAN_YEARLY_COSTS]: '* 1. års ÅOP: 1,33',
        [TemplateMention.PAYMENT_PLAN_HAS_YEARLY_INTEREST]: 'Hvis sag har renter p.a.',
        [TemplateMention.PAYMENT_PLAN_MIN_ENTRY_AMOUNT]: '55,00',
        [TemplateMention.PAYMENT_PLAN_MAX_ENTRY_AMOUNT]: '550,00',
        [TemplateMention.TOTAL_DEBT]: '6.770,14',
        [TemplateMention.OVERPAYMENT]: '123,23',
        [TemplateMention.ACCORD_TEN_PERCENT]: '6.093,13',
        [TemplateMention.ACCORD_TWENTY_PERCENT]: '5.416,11',
        [TemplateMention.ACCORD_THIRTY_PERCENT]: '4.739,10',
        [TemplateMention.ACCORD_FORTY_PERCENT]: '4.062,08',
        [TemplateMention.ACCORD_FIFTY_PERCENT]: '3.385,07',
        [TemplateMention.ACCORD_SIXTY_PERCENT]: '2.708,06',
        [TemplateMention.ACCORD_SEVENTY_PERCENT]: '2.031,04',
        [TemplateMention.ACCORD_EIGHTY_PERCENT]: '1.354,03',
        [TemplateMention.ACCORD_NINETY_PERCENT]: '677,01',
        [TemplateMention.IF_IS_COMPANY]: 'Logik hvis sagen er en virksomhed',
        [TemplateMention.IF_CASE_HAS_REMINDER_FEES]: 'Logik hvis sagen har rykkergebyrer',
        [TemplateMention.IF_CASE_HAS_COLLECTION_FEES]: 'Logik hvis sagen har inkassogebyr',
        [TemplateMention.IF_CASE_HAS_COLLECTION_COSTS]: 'Logik hvis sagen har inkassoomkostninger',
        [TemplateMention.IF_CASE_HAS_COMPENSATION_COSTS]: 'Logik hvis sagen har kompensationsomkostninger',
        [TemplateMention.IF_CASE_HAS_PROCESSRENTE]: 'Logik hvis sagen har procesrente',
        [TemplateMention.IF_CASE_HAS_FIXED_INTEREST]: 'Logik hvis sagen har fast rente',
        [TemplateMention.IF_CASE_HAS_YEARLT_INTEREST]: 'Logik hvis sagen har årlig rente',
        [TemplateMention.IF_CASE_HAS_DEPOSIT]: 'Logik hvis sagen har indbetaling',
        [TemplateMention.DOCUMENTATION]: 'Dokumentation',
        [TemplateMention.DATE]: '23. november 2021',
        [TemplateMention.DATE_IN_THREE_DAYS]: '26. november 2021',
        [TemplateMention.DATE_IN_SIX_DAYS]: '29. november 2021',
        [TemplateMention.DATE_IN_TEN_DAYS]: '3. december 2021',
        [TemplateMention.DATE_IN_ELEVEN_DAYS]: '4. december 2021',
        [TemplateMention.DATE_IN_TWELVE_DAYS]: '5. december 2021',
        [TemplateMention.DATE_IN_FOURTEEN_DAYS]: '7. december 2021',
        [TemplateMention.DATE_IN_SEVENTEEN_DAYS]: '10. december 2021',
        [TemplateMention.DATE_IN_THIRTY_DAYS]: '23. december 2021',
        [TemplateMention.DEPOSIT]: '400,00',
        [TemplateMention.DEPOSITS_TO_CREDITOR]: '200,00',
        [TemplateMention.DEPOSITS_TO_COLLECTOR]: '200,00',
        [TemplateMention.PRINCIPALS_WITH_INTEREST]: '31-01-2024 Faktura nr. 1234, kr. 300,00. Procesrente fra 20-02-2023, opgjort til kr. 1,31',
        [TemplateMention.CONTACT_NAME]: 'Debbie Contactsen',
        [TemplateMention.DEBTOR_NAME]: 'Debbie Debtorsen',
        [TemplateMention.DEBTOR_FIRST_NAME]: 'Debbie',
        [TemplateMention.CONTACT_ADDRESS]: 'Applebys Pl. 7',
        [TemplateMention.CONTACT_COADDRESS]: 'Emil Brandt',
        [TemplateMention.CONTACT_ZIPCODE]: '1411',
        [TemplateMention.CONTACT_CITY]: 'Copenhagen',
        [TemplateMention.CONTACT_COUNTRY]: 'Denmark',
        [TemplateMention.DEBTOR_ADDRESS]: 'Applebys Pl. 7',
        [TemplateMention.DEBTOR_COADDRESS]: 'Emil Brandt',
        [TemplateMention.DEBTOR_ZIPCODE]: '1411',
        [TemplateMention.DEBTOR_CITY]: 'Copenhagen',
        [TemplateMention.DEBTOR_COUNTRY]: 'Denmark',
        [TemplateMention.DEBTOR_EMAIL]: 'debitor@example.com',
        [TemplateMention.DEBTOR_PHONE]: '88888888',
        [TemplateMention.LAST_PAYMENT_DATE]: '12. oktober 2021',
        [TemplateMention.LAST_PAYMENT_AMOUNT]: '200,00',
        [TemplateMention.DEBTOR_SEQ_ID]: '111111',
        [TemplateMention.DEBTOR_CVR_AND_OR_CPR]: '12345678',
        [TemplateMention.CREDITOR_NAME]: 'Testkreditor A/S',
        [TemplateMention.CASE_ID]: '12345678',
        [TemplateMention.CASE_REFERENCE_ID]: '123456789',
        [TemplateMention.CREDITOR_ADDRESS]: 'Applebys Pl. 7',
        [TemplateMention.REMINDER_FEES]: '300,00',
        [TemplateMention.COLLECTOR_PAYMENT_OPTIONS]: 'Betalingsmuligheder',
        [TemplateMention.COLLECTOR_ACCOUNT_NUMBER]: '12345678',
        [TemplateMention.COLLECTOR_REGISTER_NUMBER]: '1234',
        [TemplateMention.COLLECTOR_PHONE]: '11223344',
        [TemplateMention.COLLECTOR_COURT_PHONE]: '11223345',
        [TemplateMention.COLLECTOR_EMAIL]: 'collector@debbie.dk',
        [TemplateMention.COLLECTOR_NICKNAME]: 'Testcollector',
        [TemplateMention.COLLECTOR_NAME]: 'Testcollector A/S',
        [TemplateMention.COLLECTOR_ADDRESS_ADDRESS]: 'Applebys Pl. 7',
        [TemplateMention.COLLECTOR_ADDRESS_CITY]: 'Copenhagen',
        [TemplateMention.COLLECTOR_ADDRESS_ZIP]: '1411',
        [TemplateMention.COLLECTOR_CVR]: '88776655',
        [TemplateMention.CREDITOR_ZIPCODE]: '1411',
        [TemplateMention.CREDITOR_CITY]: 'Copenhagen',
        [TemplateMention.CREDITOR_COMPANY_IDENTIFIER]: '66554433',
        [TemplateMention.CREDITOR_IF_IS_COMPANY]: 'Logik hvis kreditor er en virksomhed',
        [TemplateMention.USER_NAME]: 'Peter Petersen',
        [TemplateMention.USER_FIRST_NAME]: 'Peter',
        [TemplateMention.IF_USER]: 'Logik hvis brugeren er tilgængelig',
        [TemplateMention.IF_COLLECTOR_ALLOWS_BANK_TRANSFERS]: 'Logik hvis inddriver tillader bankoverførsler',
        [TemplateMention.IF_COLLECTOR_ALLOWS_FI_PAYMENTS]: 'Logik hvis inddriver tillader FIK-betalinger',
        [TemplateMention.PAYMENT_ID]: '+71<000000001111111 + 12345678<',
        [TemplateMention.JOURNAL_NUMBER]: '12345678-111111',
        [TemplateMention.CIVIL_COURT_NAME]: 'Københavns Byret',
        [TemplateMention.CIVIL_COURT_ADDRESS]: 'Hestemøllestræde 6',
        [TemplateMention.CIVIL_COURT_CITY]: 'København K',
        [TemplateMention.CIVIL_COURT_ZIP]: '1464',
        [TemplateMention.CIVIL_COURT_EMAIL]: 'foged.kbh@domstol.dk',
        [TemplateMention.CIVIL_COURT_PHONE]: '99687000',
        [TemplateMention.CIVIL_COURT_EAN]: '5798000161252',
        [TemplateMention.CIVIL_REG_NO]: '0216',
        [TemplateMention.CIVIL_ACCOUNT_NO]: '4069134793',
        [TemplateMention.PAYMENT_PLAN_HTML]: '* 1. Indbetaling på DKK 200,00 inden 15. oktober 2021',
        [TemplateMention.CONTACT_ADDRESS_INLINE]: 'Applebys Plads 7, 1411 København K',
        [TemplateMention.CONTACT_ADDRESS_FORMATTED]: 'Applebys Plads 7,\n 1411 København K',
        [TemplateMention.ALTERNATIVE_CONTACT_REFERENCE_ID]: '123-123',
        [TemplateMention.HAS_ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Logik hvis repræsentant har journalnummer',
        [TemplateMention.DEBTOR_ADDRESS_INLINE]: 'Applebys Plads 7, 1411 København K',
        [TemplateMention.DEBTOR_ADDRESS_FORMATTED]: 'Applebys Plads 7,\n 1411 København K',
        [TemplateMention.DEBT_TABLE]: 'Type|Dato|Valuta|Beløb',
        [TemplateMention.DEBT_SPECIFICATION]: 'Faktura|Dato|Forfaldsdato|Beløb',
        [TemplateMention.DEBT_OVERVIEW]: 'Kategoriseret Type|Dato|Beløb',
        [TemplateMention.SIGN_FIELDS]: 'Dato\n_______________________\nUnderskrift',
        [TemplateMention.BPK]: 'PDF',
        [TemplateMention.GL_BPK]: 'PDF',
        [TemplateMention.PAGE_BREAK]: 'Sideskift',
        [TemplateMention.PAYMENT_LINK]: 'debtorweb.dk/r/fuldegæld',
        [TemplateMention.DEBTOR_WEB_LINK]: 'debtorweb.dk',
        [TemplateMention.DEBTOR_WEB_LONG_LINK]: 'debtorweb.dk',
        [TemplateMention.PAYMENT_PLAN_LINK]: 'debtorweb.dk/r/afdragsordning',
        [TemplateMention.OVERPAYMENT_LINK]: 'debtorweb.dk/r/udbetaling',
        [TemplateMention.OVERPAYMENT_LINK_QR_CODE]: 'QR-kode',
        [TemplateMention.OVERPAYMENT_LINK_A_TAG]: 'debtorweb.dk/r/udbetaling',
        [TemplateMention.PAYMENT_LINK_A_TAG]: 'debtorweb.dk/r/fuldegæld',
        [TemplateMention.PAYMENT_PLAN_ENTRIES_TAG]: 'Beløb | Dato | Status',
        [TemplateMention.SATISFACTION_BUTTONS]: '(:D) (:|) (:C)',
        [TemplateMention.PAYMENT_PLAN_LINK_A_TAG]: 'debtorweb.dk/r/afdragsordning',
        [TemplateMention.DEBTOR_WEB_LINK_A_TAG]: 'debtorweb.sk',
        [TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG]: 'debtorweb.dk',
        [TemplateMention.DEBTOR_WEB_LINK_QR_CODE]: 'QR-kode',
        [TemplateMention.PAYMENT_PLAN_LINK_QR_CODE]: 'QR-kode',
        [TemplateMention.PAYMENT_LINK_QR_CODE]: 'QR-kode',
        [TemplateMention.CONDITIONAL_ELSE]: 'Ellers',
        [TemplateMention.CONDITIONAL_END_IF]: 'Slut hvis',
        [TemplateMention.BANK_CREDITOR_NUMBER]: 'N/A',
        [TemplateMention.SIGNATURE_TIRANA]: 'N/A',
        [TemplateMention.SIGNATURE_MICHAEL_BRANDT]: 'N/A',
        [TemplateMention.RKI_WARNING]: 'PDF',
        [TemplateMention.FOUNDATION_TYPE]: 'Dom',
        [TemplateMention.FOUNDATION_DATE]: '23. november 2021',
        [TemplateMention.LATEST_TRIBUNAL_REFERENCE]: 'FS 11-1111/1111',
    },
    import: {
        importedData: 'Importeret data',
        downloadInvoiceExampleHeader: 'Fakturakrav',
        downloadInvoiceExampleText: 'Download import-ark med eksempler på fakturakrav.',
        downloadFinancialExampleHeader: 'Bankfordringer',
        downloadFinancialExampleText: 'Download import-ark med eksempler på bankfordringer.',
        downloadAcontoExampleHeader: 'Acontofakturering',
        downloadAcontoExampleText: 'Download import-ark med eksempler på acontofakturering.',
        downloadMigrationExampleHeader: 'Migrering',
        downloadMigrationExampleText: 'Download migrerings-ark med eksempler på indhold.',
        download: 'Download eksempel',
        import: 'Import',
        backToImports: 'Tilbage til import',
        newImport: 'Ny import',
        noImports: 'Endnu ingen importeringer at vise',
        casesCreated: 'Sager oprettet',
        casesUpdated: 'Sager opdateret',
        companyStatuses: 'Virksomhedsstatusser',
        noStatus: 'Ingen status',
        caseUpdates: 'Sagsopdateringer',
        migration: 'Migrering',
        [ImportState.CANCELED]: 'Annulleret',
        [ImportState.CREATED]: 'Oprettet',
        [ImportState.DELETED]: 'Slettet',
        [ImportState.IMPORTED]: 'Importeret',
        [ImportState.IMPORTING]: 'Importerer',
        [ImportState.SHEETADDED]: 'Excelark tilføjet',
        create: 'Opret',
        uploadFile: 'Tilføj excelark',
        uploadedAppendicies: 'Tilføjede bilag',
        mapColumns: 'Map kolonner',
        imported: 'Importeret',
        dropFileHereOr: 'Træk og slip en fil her eller',
        dropAnotherFileHereOr: 'Træk og slip en tilrettet fil her eller',
        uploadFileBtn: 'upload her',
        deleteImport: 'Slet import',
        importFinished: 'Import færdig',
        dropAppendixHereOr: 'Træk og slip et bilag her eller',
        uploadImport: 'Upload import-ark',
        uploadAppendix: 'Upload bilag',
        appendixUploaded: 'Bilag uploadet',
        withRKIRegistrations: 'med RKI-registreringer',
        endAll: 'Afslut alle',
        approveAll: 'Godkend alle sager',
        createdCases: 'oprettede sager.',
        startedEnding: 'Påbegyndt at afslutte alle',
        cases: 'sager.',
        found: 'Fandt',
        rows: 'rækker',
        and: 'og',
        debtors: 'debitorer',
        allCasesFinallySettled: 'Alle sager er endeligt opgjorte',
        allCasesTerminated: 'Alle kundeforhold er ophørte',
        chain: 'Workflow',
        billingModel: 'Afregningsmodel',
        tenantStandard: 'Kontostandard',
        creditorStandard: 'Kreditorstandard',
        systemStandard: 'Systemstandard',
        importCases: 'Importér',
        more: 'flere.',
        showMore: 'Vis flere',
        youWillreceiveAnEmailWhenItIsDone: 'Du vil modtage en email når importen er færdig',
        importHasStarted: 'Importen er i gang',
        see: 'Se',
        seeMore: 'Se mere',
        here: 'her',
        file: 'filens',
        asWell: 'eller læs mere i vores',
        notMappedColumns: 'Følgende kolonner blev ikke mappet',
        errors: 'fejl',
        error: 'Fejl',
        row: 'Række',
        column: 'Kolonne',
        columnNotFound: 'Kolonne ikke fundet',
        noErrorsFound: 'Ingen fejl fundet',
        rowsHeader: 'Rækker',
        columnsHeader: 'Kolonner',
        failedRows: 'Fejlet rækker',
        failedImportRows: 'Fejlede import-rækker',
        referenceId: 'Sagsreferencenummer',
        creditorReferenceId: 'Kreditorreferencenummer',
        isCompany: 'Er virksomhed',
        caseCreatedAt: 'Sagsoprettelsesdato',
        caseStatus: 'Sagsstatus',
        endReason: 'Afslutningsårsag',
        caseGroup: 'Sagsgruppe',
        migratedId: 'Migreret journalnummer',
        name: 'Navn',
        birthdate: 'Fødselsdato',
        cpr: 'CPR',
        cvr: 'CVR',
        email: 'Email',
        phone: 'Telefonnr.',
        lang: 'Sprog',
        address: 'Adresse',
        coAddress: 'C/O-Adresse',
        zipcode: 'Postnummer',
        city: 'By',
        country: 'Land',
        fiPaymentIdRaw: 'FIK-betalingslinje',
        caseTags: 'Economy tags',
        economyBillingModelId: 'Afregningsmodel',
        debtReferenceId: 'Fakturanummer',
        fileName: 'Filnavn',
        issueDate: 'Dato',
        dueDate: 'Forfald',
        expirationFromDate: 'Forældelses startdato',
        currency: 'Valuta',
        debtDescription: 'Beskrivelse af postering',
        principal: 'Hovedstol',
        controlFee: 'Kontrolafgift',
        loan: 'Gældsbrev',
        settlement: 'Frivilligt forlig',
        fixedInterest: 'Fast rente',
        udtraeksgebyr: 'Udtræksgebyr',
        administrationCost: 'Administrationsgebyr',
        onAccount: 'Acontobeløb',
        finalSettlement: 'Opgørelse',
        deposit: 'Indbetaling',
        reminderFee: 'Rykkergebyrer',
        reminderFeeCollector: 'Rykkergebyrer fra inddriver',
        refund: 'Refusion',
        compensationCost: 'Kompensationsgebyrer',
        collectionCost: 'Inkassoomkostninger',
        collectionFee: 'Inkassogebyrer',
        writFee: 'Stævningsgebyr',
        writSalary: 'Stævningssalær',
        policePresentationFee: 'Politifremstillingsgebyr',
        fogedRekvisitionsFee: 'Fogedrekvisitionsgebyr',
        bailifsSalary: 'Sagsomkostninger',
        bailifsFee: 'Betalingspåkravsgebyr',
        creditNote: 'Kreditnota',
        interestStartDate: 'Rentestartdato',
        interestRate: 'Rente',
        finalStatement: 'Endeligt opgjort',
        customerTerminated: 'Kundeforhold ophørt',
        rkiWarnedAt: 'RKI varslingsdato',
        bpkWarnedAt: 'BPK varslingsdato',
        errorWarning: 'Dit excel-ark indeholder fejl, der forhindrer importen',
        faqHeader: 'Brug for hjælp til at importere sager?',
        faqText: 'Vi har i vores hjælp-sektion skrevet en artikel om vores import-modul. Her finder du blandt andet forklaringer på typiske fejl og meget mere.',
        newCase: 'Ny sag',
    },
    updateTypesSettings: {
        addUpdateType: 'Opret opgavetype',
        title: 'Opgavens titel',
        editUpdateType: 'Redigér opgavetype',
        createNewUpdateType: 'Opret opgavetype',
        customUpdateTypes: 'Oprettede opgavetyper',
        standardUpdateTypes: 'Standardopgavetyper',
    },
    updateTypes: {
        ['b3a86e9e-37ce-42d4-9c57-4906b298d218']: 'Til rykkerforløb',
        ['2850ea55-e7e4-4d77-aa81-1b60fcdc1d46']: 'Stævning',
        ['46ad9f0c-3e23-4d6d-bcf1-3c0846c78a9a']: 'Betalingspåkrav',
        ['7f272584-75a9-4deb-ae0a-9876c061cc70']: 'Fogedrekvisition',
        [UpdateType.CreditorEndedCase]: 'Kreditor har afsluttet sagen',
        [UpdateType.AKSStatus]: 'AKS-status',
        [UpdateType.AKSFailed]: 'AKS-tilmelding mislykket',
        [UpdateType.EXITREQUEST]: 'Afslutningsanmodning fra kreditor',
        [UpdateType.CASESTATUSMOVE]: 'Sagsstatus ændret',
        [UpdateType.SOP]: 'Endeligt opgjort',
        [UpdateType.UPDATE]: 'Opdatering',
        [UpdateType.NOCONTACTINFORMATION]: 'Manglende kontaktinformation',
        [UpdateType.DEPOSIT]: 'Indbetaling',
        [UpdateType.NEWDEBT]: 'Ny gæld',
        [UpdateType.NEWINTERACTION]: 'Ny e-mail journaliseret',
        [UpdateType.eBoksFailed]: 'e-Boks-besked kunne ikke leveres',
        [UpdateType.TECHNICALINVESTIGATION]: 'Undersøges af en tekniker',
        [UpdateType.TERMINATIONREQUEST]: 'Anmodning om afbrydelse sendt til kreditor',
        [UpdateType.PENDINGTERMINATION]: 'Afventer afbrydelse af sagsbehandler',
        [UpdateType.CANCELTERMINATION]: 'Annullering af afbrydelse',
        [UpdateType.CASECONTINUED]: 'Sag fortsat',
        [UpdateType.POSTPONECASEWORKING]: 'Udskyd sagsbehandling',
        [UpdateType.RETURNLETTER]: 'Brev returneret',
        [UpdateType.BOBEHANDLING]: 'Bobehandle',
        [UpdateType.BOBEHANDLET]: 'Bobehandlet',
        [UpdateType.NotSureCourtSubmit]: 'Betalingspåkrav: Afventer manuel håndtering',
        [UpdateType.YesCourtSubmit]: 'Betalingspåkrav: Klar til automatisk indlevering',
        [UpdateType.NoCourtSubmit]: 'Betalingspåkrav: Ikke udtaget til indlevering',
        [UpdateType.AWAITINGSTAEVNING]: 'Afventer stævning',
        [UpdateType.AFDRAGSORDNINGER]: 'Afdragsordninger',
        [UpdateType.ApprovedByCreditor]: 'Godkendt af kreditor',
        [UpdateType.ApprovedByDatahub]: 'Godkendt af DataHub',
        [UpdateType.CancelApprovedByDatahub]: 'Annullering godkendt af DataHub',
        [UpdateType.REMOVEFROMRKI]: 'Fjern fra RKI',
        [UpdateType.AUTOREMOVEFROMRKI]: 'Automatisk sletning af RKI-registrering',
        [UpdateType.CancelRejectedByDatahub]: 'Annullering afvist af DataHub',
        [UpdateType.CancelRequestedBecauseOfPaymentToCreditor]: 'Annullering anmodet, grundet betaling til kreditor',
        [UpdateType.RejectedByCreditor]: 'Afvist af kreditor',
        [UpdateType.RejectedByDatahub]: 'Afvist af DataHub',
        [UpdateType.PAYMENTPLANINITIAL]: 'Ny afdragsordning oprettet',
        [UpdateType.NEWCLIENTINTERACTION]: 'Ny kreditorinteraktion',
        [UpdateType.NEWDEBTORINTERACTION]: 'Ny debitorinteraktion',
        [UpdateType.DEBTORPERSONALDATAREQUEST]: 'Anmodning om opdatering af debitorinformation',
        [UpdateType.AWAITINGCLIENTANSWER]: 'Afventer svar fra kreditor',
        [UpdateType.DEFAULTEDPAYMENTPLAN]: 'Misligholdt afdragsordning',
        [UpdateType.OVERPAYPAYMENTPLAN]: 'Overbetalt afdragsordning',
        [UpdateType.RKIApprovalRequest]: 'RKI: Anmodning til sagsbehandler',
        [UpdateType.RKIApproved]: 'RKI: Godkendt til registrering',
        [UpdateType.RKIDenied]: 'RKI: Registrering afvist',
        [UpdateType.RKIREGISTRATION]: 'Håndtér registrering i RKI',
        [UpdateType.DOCSIGNED]: 'Dokument underskrevet',
        [UpdateType.COSMOSUBSCRIBED]: 'Tilmeldt Cosmo',
        [UpdateType.COSMOUNSUBSCRIBED]: 'Afmeldt Cosmo',
        [UpdateType.AWAITINGFOGEDREKVISITION]: 'Afventer fogedrekvisition',
        [UpdateType.ISINFOGEDRETTEN]: 'Er i fogedretten',
        [UpdateType.ISINCIVILCOURT]: 'Er i civilretten',
        [UpdateType.PAYMENTONCASEINCOURT]: 'Betaling på sag i retten',
        [UpdateType.RECEIVEDCOURTFOUNDATION]: 'Modtaget Dom',
        [UpdateType.POLITIFREMSTILLING]: 'Politifremstilling',
        [UpdateType.DECIDECOURT]: 'Vurdér eventuelle retslige skridt',
        [UpdateType.RKISTATUS]: 'RKI-status',
        [UpdateType.AWAITINGPOWERTERMINATION]: 'Afventer strømluk',
        [UpdateType.RKIAPPROVEDBYCLIENT]: 'RKI godkendt af kreditor',
        [UpdateType.REQUESTCLIENTRKI]: 'Anmodning om godkendelse af at RKI-betingelserne er opfyldt',
        [UpdateType.TERMINATEDCUSTOMER]: 'Opsagt kunde',
        [UpdateType.FOGEDREVISITIONCLIENTREQUEST]: 'Anmodning om fogedrekvisition til kreditor',
        [UpdateType.TICKETRESOLVED]: 'Ticket løst',
        [UpdateType.MIGRATIONNOTE]: 'Migration Note',
        [UpdateType.TILJURIDISKBEHANDLING]: 'Til juridisk behandling',
        [UpdateType.COURTEVENTS]: 'Retsfrister',
        [UpdateType.AFTEROFFICEHOURS]: 'Behandles efter telefontid',
        [UpdateType.AWAITINGPAYMENTAFTERCONCILIATION]: 'Afventer betaling ifm. forlig',
        [UpdateType.PHONEMEETING]: 'Indkaldt til fogedmøde',
        [UpdateType.INSOLVENS]: 'Insolvens',
        [UpdateType.DEBTEXPIRESWITHINTHREEMONTHS]: 'Gæld forælder indenfor 3 måneder',
        [UpdateType.DEBTEXPIRED]: 'Gæld forældet',
        [UpdateType.EMAILFAILED]: 'Email fejlet permanent',
        [UpdateType.AWAITINGCIVILCOURT]: 'Afventer civilretten',
        [UpdateType.AWAITINGFINALSTATEMENT]: 'Afventer endelig opgørelse',
        [UpdateType.MIGRATEDJOURNALNUMBER]: 'Migreret journalnummer',
        [UpdateType.RKIREGISTRATIONOPEN]: 'RKI-registrering (Åben)',
        [UpdateType.RKIREGISTRATIONCLOSED]: 'RKI-registrering (Lukket)',
        [UpdateType.AUTORKIREGISTRATIONOPEN]: 'Auto-RKI registrering (Åben)',
        [UpdateType.AUTORKIREGISTRATIONCLOSED]: 'Auto-RKI registrering (Lukket)',
        [UpdateType.RKIWARNED]: 'RKI-varslet',
        [UpdateType.STAEVNINGREQUSTCLIENT]: 'Kreditor, skal debitor stævnes?',
        [UpdateType.UDLAEG]: 'Udlæg',
        [UpdateType.UDLAEGCIVIL]: 'Udlæg',
        [UpdateType.NEWCOURTINTERACTION]: 'Ny e-mail fra retten',
        [UpdateType.REMINDER]: 'Påmindelse',
        [UpdateType.OUTBOUNDCALL]: 'Udgående opkald',
        [UpdateType.UDLAEGAFLYSES]: 'Udlæg skal aflyses',
        [UpdateType.OPPOSITION]: 'Indsigelse',
        [UpdateType.NOTOPPOSITION]: 'Ikke-indsigelse',
        [UpdateType.FSNUMMER]: 'FS-nummer',
        [UpdateType.OVERDRAGESTILINKASSOPARTNER]: 'Skal overdrages til ekstern inkassopartner',
        [UpdateType.AKSUpdateName]: 'AKS Opdateret: Navn',
        [UpdateType.AKSUpdateAddress]: 'AKS Opdateret: Adresse',
        [UpdateType.AKSUpdateStatus]: 'AKS Opdateret: Status',
        [UpdateType.AKSUpdateProtection]: 'AKS Opdateret: Navn/Adresse-beskyttelse',
        [UpdateType.AKSUpdateNewRKI]: 'AKS Opdateret: Ny RKI-registrering',
        [UpdateType.AKSUpdateDeletedRKI]: 'AKS Opdateret: Fjernet RKI-registrering',
        [UpdateType.AKSUpdateCreditWarning]: 'AKS Opdateret: Kreditadvarsel',
        [UpdateType.AKSUpdateAdvertisementPreference]: 'AKS Opdateret: Reklamepreference',
        [UpdateType.AKSUpdateGuardianStatus]: 'AKS Opdateret: Værge Status',
        [UpdateType.AKSUpdateRKI]: 'AKS Opdateret: RKI-bemærkning',
        [UpdateType.COURTREMINDER]: 'Retslig påmindelse',
        [UpdateType.DEPARTED]: 'Udrejst',
        [UpdateType.DECIDECONTINUE]: 'Vurder om sagen skal fortsættes',
        [UpdateType.Dead]: 'Debitor er død',
        [UpdateType.MovedAbroad]: 'Debitor er udrejst',
        [UpdateType.Disappeared]: 'Debitor er forsvundet',
        [UpdateType.Homeless]: 'Debitor er nu hjemløs',
        [UpdateType.Inactive]: 'Virksomheden er nu inaktiv',
        [UpdateType.OperationsCeased]: 'Virksomheden er ophørt',
        [UpdateType.GuardianStatus]: 'Værge-status opdateret',
        [UpdateType.DeletedRKIRegistration]: 'RKI-registrering fra anden kreditor slettet',
        [UpdateType.DeletedRKIRegistrationWillingnessToPay]: 'RKI-registrering fra anden kreditor slettet - indikation på betalingsvilje',
        [UpdateType.NewRKIRegristration]: 'Ny RKI-registrering fra anden kreditor',
        [UpdateType.Address]: 'Adresse opdateret',
        [UpdateType.AddressProtection]: 'Navne/Adresse-beskyttelse',
        [UpdateType.RKIRemark]: 'RKI-bemærkning opdateret',
        [UpdateType.Active]: 'Debitor er nu aktiv',
        [UpdateType.CompanyActive]: 'Virksomheden er nu aktiv',
        [UpdateType.DissolutionStatus]: 'Opløsningsstatus',
        [UpdateType.PAYMENTPLANCANCLED]: 'Afdragsordning annulleret',
        [UpdateType.INTERNALREMARK]: 'Intern bemærkning',
        [UpdateType.MOVETOOPENRKI]: 'Flyt til åben RKI',
        [UpdateType.DebtorIsUnderage]: 'Debitor er under 18 år',
        [UpdateType.SentToConnectPartner]: 'Sendt til connect partner',
        [UpdateType.ReturnedToConnectPartner]: 'Returneret til connect partner',
        [UpdateType.DebtorCanBeRegisteredInDebtRegister]: 'Debitor kan registreres i det åbne RKI-register',
        [UpdateType.PAYMENTREVOKED]: 'Betaling tilbagetrukket',
        [UpdateType.CaseMergedFrom]: 'En sag blev sammenlagt med denne',
        [UpdateType.CaseMergedTo]: 'Sagen blev sammenlagt med',
    },
    updateTypesClient: {
        [UpdateType.AWAITINGCLIENTANSWER]: 'Ny besked fra inddriver',
        ['21cfbb48-a135-4ef2-af83-d6b87bfe5f63']: 'Er betingelser for at vi kan registrere i RKI opyldt?',
        ['71ea44ac-9b03-48b8-9bea-54354e1fa74d']: 'Ønskes sagen i retten?',
        ['9036d745-349c-40a0-b54e-ca5d718962d0']: 'Ønskes en fogedrekvisition udarbejdet?',
    },
    caseFilter: {
        moreFilters: 'Filtre',
        advancedFilters: 'Avancerede filtre',
        casesSelected: 'valgte sager',
        aggregationSum: 'Sum',
        orderCaseOverview: 'Bestil sagsoverblik',
        creditorsGroup: 'Kreditorer',
        contactsGroup: 'Kontaktpersoner',
        maxRkiRegistrations: 'Maks. RKI-registreringer',
        maxRkiRegistrationsSub: 'Vælg antallet af RKI-registreringer debitor maksimalt skal have.',
        maxRkiRegistrationsBadge: 'RKI maks.',
        minRkiRegistrations: 'Min. RKI-registreringer',
        minRkiRegistrationsSub: 'Vælg antallet af RKI-registreringer debitor minimum skal have.',
        minRkiRegistrationsBadge: 'RKI min.',
        rkiRegisteredByCollector: 'Er RKI-registreret af inddriver',
        isRegisteredByCollector: 'Er registreret',
        isNotRegisteredByCollector: 'Er ikke registreret',
        contactHasEmail: 'Kontaktperson har en email',
        contactHasEmailBadge: 'Har email',
        contactHasPhone: 'Konktaktperson har et telefonnummer',
        contactHasPhoneBadge: 'Har telefonnummer',
        contactHasAddress: 'Kontaktperson har en adresse',
        contactHasAddressBadge: 'Har adresse',
        contactPersonIs: 'Kontaktperson er',
        debtor: 'Debitor',
        debtorBadge: 'Debitor er kontaktperson',
        alternativeContact: 'Repræsentant',
        alternativeContactBadge: 'Repræsentant er kontaktperson',
        company: 'Virksomhed',
        companyBadge: 'Er virksomhed',
        person: 'Privatperson',
        personBadge: 'Er privatperson',
        paymentMethod: 'Betalingsmetode',
        hasCard: 'Har betalingskort',
        doNotHaveCard: 'Har ikke betalingskort',
        companyStatus: 'Virksomhedsstatus',
        selectCompanyStatus: 'Vælg virksomhedsstatus',
        court: 'Retskreds',
        courtBadge: 'Retskreds valgt',
        selectCourt: 'Vælg retskreds',
        companyBranch: 'Branche for virksomhed',
        selectCompanyBranch: 'Vælg branche',
        companyTypes: 'Virksomhedsformer',
        selectCompanyTypes: 'Vælg virksomhedsformer',
        gender: 'Køn',
        [Gender.MALE]: 'Mand',
        [Gender.FEMALE]: 'Kvinde',
        [Gender.BOTH]: 'Begge',
        zipcode: 'Postnummer',
        selectZipcode: 'Vælg postnumre',
        satisfactions: 'Tilfredshedssvar',
        casesGroup: 'Sager',
        caseStatus: 'Sagsstatus',
        selectCaseStatus: 'Vælg sagsstatus',
        endReasons: 'Afslutningsårsag',
        selectEndReasons: 'Vælg afslutningsårsag',
        caseGroup: 'Sagsgruppe',
        selectCaseGroup: 'Vælg sagsgruppe',
        caseImport: 'Sagsimport',
        selectCaseImport: 'Vælg sagsimport',
        caseCreatedAfter: 'Sag oprettet efter',
        caseCreatedAfterPlaceholder: 'Efter',
        caseCreatedBefore: 'Sag oprettet før',
        caseCreatedBeforePlaceholder: 'Før',
        caseSeqIds: 'Sagsnumre',
        exceptCaseSeqIds: 'Undtag sagsnumre',
        caseSeqIdsDescription: 'Sagsnumre i tekstform separeret med linjeskift, mellemrum, komma eller semikolon',
        caseSeqIdFilterBadge: 'Efter sagsnumre',
        updatesGroup: 'Opgaver',
        caseIsCurrently: 'Sager lige nu er',
        caseIsCurrentlyPaused: 'Pausede sager',
        caseIsCurrentlyNotPaused: 'Sager som ikke er pauset',
        paused: 'Pauset',
        notPaused: 'Ikke pauset',
        selectStatus: 'Vælg status',
        hasFollowingStatus: 'Har følgende status',
        hasFollowingStatusSub: 'Har denne status nu eller har haft den tidligere.',
        hasFollowingStatusBadge: 'Har status',
        doNotHaveFollowingStatus: 'Har ikke følgende status',
        doNotHaveFollowingStatusSub: 'Har hverken denne status nu eller haft den tidligere.',
        doNotHaveFollowingStatusBadge: 'Har ikke status',
        isPausedFollowingStatus: 'Er pauset med status',
        isPausedFollowingStatusSub: 'Er pauset med en af følgende status lige nu.',
        isPausedFollowingStatusBadge: 'Er pauset med status',
        isNotPausedFollowingStatus: 'Er ikke pauset status',
        isNotPausedFollowingStatusSub: 'Er ikke pauset med en af følgende status lige nu.',
        isNotPausedFollowingStatusBadge: 'Er ikke pauset status',
        economyGroup: 'Økonomi',
        economyOnlyVoucherTypeIds: 'Kun udvalgte posteringstyper',
        economyMinAmount: 'Min.-balance',
        economyMaxAmount: 'Maks.-balance',
        economyBillingModels: 'Sager med afregningsmodel',
        economyBillingAppendixSetups: 'Sager med bilagsopsætning',
        billingModels: 'Afregningsmodeller',
        economyMin: 'Min.',
        economyMax: 'Maks.',
        economySelectedBillingModels: 'Valgte afregningsmodeller',
        economySelectedBillingAppendixSetups: 'Valgte bilagsopsætninger',
        workflowsGroup: 'Workflows',
        inSelectedWorkflows: 'Valgte workflows',
        isInWorkflows: 'Er i workflow',
        selectWorkflows: 'Vælg workflows',
        selectNextTaskIds: 'Vælg opgaver',
        nextTaskIds: 'Næste opgave i workflow',
        selectCurrentTaskIds: 'Vælg opgaver',
        currentTaskIds: 'Nuværende opgave i workflow',
        noNextTask: 'Ingen næste opgave',
        documentsGroup: 'Dokumenter',
        hasDocumentOfType: 'Har dokument af typen',
        hasDocumentOfTypeBadge: 'Har dokument af type',
        selectDocumentTypes: 'Vælg dokumenttyper',
        documentsIsSigned: 'Valgte dokumenter er signeret',
        hasFoundation: 'Har fundament',
        hasNoFoundation: 'Har ikke fundament',
        paymentPlansGroup: 'Afdragsordninger',
        paymentPlanStatuses: 'Afdragsordninger med status',
        selectPaymentPlanStatus: 'Vælg status',
        paymentPlanIsNotHavingStatuses: 'Vælg kun sager med afdragsordniger uden ovenstående',
        paymentPlanIsNotHavingStatusesBadge: 'Afdragsordniger uden statusser',
        interactionsGroup: 'Interaktioner',
        interactionType: 'Interaktionstype',
        selectInteractionType: 'Vælg interaktionstype',
        interactionState: 'Interaktionsstatus',
        selectInteractionState: 'Vælg interaktionsstatus',
        interactionDirection: 'Interaktionsretning',
        selectInteractionDirection: 'Vælg interaktionsretning',
        noneOfTheAboveBadge: 'Interaktioner uden valgte muligheder',
        noneOfTheAbove: 'Interaktioner er det modsatte af ovenstående',
        properties: 'Attributer',
        property: 'Attribut',
        propertyExplanation: '',
        accountsGroups: 'Brugere',
        selectedCreditors: 'kreditor(er) valgt',
        caseVisitedBy: 'Sag besøgt af',
        selectAccount: 'Vælg bruger',
        caseVisitedBefore: 'Sag besøgt før',
        to: 'Til',
        caseVisitedAfter: 'Sag besøgt efter',
        from: 'Fra',
        offset: 'Start fra x antal sag',
        offsetExplanation: 'Vælg hvor mange sager der skal springes over',
        limit: 'Begrænsning',
        limitExplanation: 'Vælg maksimum-antallet af sager som skal vælges',
        pagination: 'Begræns antal sager',
    },
    aggregations: {
        aggregate: 'Aggreger sager',
    },
    aggregationTypes: {
        [AggregationType.CountAll]: 'Antal sager',
        [AggregationType.ByCaseGroup]: 'Sagsgruppe',
        [AggregationType.ByBillingModel]: 'Afregningsmodel',
        [AggregationType.ByBillingAppendixSetup]: 'Bilagsopsætning',
        [AggregationType.ByWorkflow]: 'Workflow',
        [AggregationType.ByCaseStatus]: 'Sagsstatus',
        [AggregationType.ByCreditor]: 'Kreditor',
        [AggregationType.ByMigratedWorkflowTaskId]: 'Alternativ workflow-sti',
    },
    bulkActions: {
        runBulkAction: 'Kør massebehandling',
        bulkActionStarted: 'Massebehandling igangsat. Du vil modtage en email når den er færdig.',
        bulkActions: 'Massebehandling',
        bulkActionsConfirm: 'Er du sikker på, at du vil køre den valgte massebehandling på de valgte sager?',
        bulkActionBillingModelPlaceholder: 'Afregningsmodel',
        bulkActionWorkflowPlaceholder: 'Workflow',
        bulkActionMoveToTaskInWorkflowPlaceholder: 'Vælg opgave i workflow',
        bulkActionChangeCaseGroup: 'Vælg sagsgruppe',
        pleaseSelectAWorkflow: 'Vælg et workflow i sagsfilteret',
    },
    bulkActionTypes: {
        [BulkActionType.MoveCaseStatus]: 'Skift sagsstatus',
        [BulkActionType.PauseCases]: 'Paus med opgave på valgte sager',
        [BulkActionType.ContinueCases]: 'Fortsæt opgave på valgte sager',
        [BulkActionType.RunProcedure]: 'Kør genvej for valgte sager',
        [BulkActionType.ChangeBillingModel]: 'Skift afregningsmodel',
        [BulkActionType.ChangeBillingAppendixSetup]: 'Skift bilagsopsætning',
        [BulkActionType.ChangeWorkflow]: 'Skift workflow',
        [BulkActionType.MoveCaseToWorkflowTask]: 'Ryk til workflow opgave',
        [BulkActionType.RollbackOneTask]: 'Tilbagerul senest kørte workflow-opgave',
        [BulkActionType.RollbackAllTasks]: 'Tilbagerul alle kørte workflow-opgaver',
        [BulkActionType.RunBillingModel]: 'Kør afregningsmodel',
        [BulkActionType.ResubscribeCosmo]: 'Gentilmeld Cosmo',
        [BulkActionType.ChangeCaseGroup]: 'Skift sagsgruppe',
        [BulkActionType.ResyncCosmo]: 'Synkroniser cosmo',
    },
    bulkActionDescriptions: {
        [BulkActionType.MoveCaseStatus]: 'Skift sagsstatus til',
        [BulkActionType.PauseCases]: 'Paus med opgave på valgte sager',
        [BulkActionType.ContinueCases]: 'Fortsæt opgave på valgte sager',
        [BulkActionType.RunProcedure]: 'Kør genvej for valgte sager',
        [BulkActionType.ChangeBillingModel]: 'Skift afregningsmodel',
        [BulkActionType.ChangeBillingAppendixSetup]: 'Skift bilagsopsætning',
        [BulkActionType.ChangeWorkflow]: 'Skift workflow',
        [BulkActionType.MoveCaseToWorkflowTask]: 'Ryk til workflow opgave',
        [BulkActionType.RollbackOneTask]: 'Tilbagerul senest kørte workflow-opgave',
        [BulkActionType.RollbackAllTasks]: 'Tilbagerul alle kørte workflow-opgaver',
        [BulkActionType.RunBillingModel]: 'Kør afregningsmodel',
        [BulkActionType.ResubscribeCosmo]: 'Gentilmeld Cosmo',
        [BulkActionType.ChangeCaseGroup]: 'Skift sagsgruppe',
        [BulkActionType.ResyncCosmo]: 'Synkroniser cosmo',
    },
    bulkActionsEmailConfirmationSubject: {
        [BulkActionType.MoveCaseStatus]: 'Sager har nu skiftet status',
        [BulkActionType.PauseCases]: 'Sager pauset',
        [BulkActionType.ContinueCases]: 'Sager fortsat',
        [BulkActionType.RunProcedure]: 'Genvej eksekveret',
        [BulkActionType.ChangeBillingModel]: 'Afregningsmodeller skiftet',
        [BulkActionType.ChangeBillingAppendixSetup]: 'Bilagsopsætninger skiftet',
        [BulkActionType.ChangeWorkflow]: 'Workflows skiftet',
        [BulkActionType.MoveCaseToWorkflowTask]: 'Sager er nu rykket til workflow opgave',
        [BulkActionType.RollbackOneTask]: 'Workflow-opgaver er nu tilbagerullet',
        [BulkActionType.RollbackAllTasks]: 'Workflow-opgaver er nu tilbagerullet',
        [BulkActionType.RunBillingModel]: 'Afregningsmodel er nu kørt',
        [BulkActionType.ResubscribeCosmo]: 'Gentilmelding til Cosmo er nu kørt',
        [BulkActionType.ChangeCaseGroup]: 'Sagsgrupper er nu ændret',
        [BulkActionType.ResyncCosmo]: 'Cosmo synkroniseret',
    },
    bulkActionsEmailConfirmationBody: {
        [BulkActionType.MoveCaseStatus]: 'Din massebehandling er nu kørt, og de valgte sager er har skiftet status.',
        [BulkActionType.PauseCases]: 'Din massebehandling er nu kørt, og de valgte sager er pauset.',
        [BulkActionType.ContinueCases]: 'Din massebehandling er nu kørt, og de valgte sager er fortsat.',
        [BulkActionType.RunProcedure]: 'Din massebehandling er nu kørt, og de valgte sager har fået genvejen eksekveret.',
        [BulkActionType.ChangeBillingModel]: 'Din massebehandling er nu kørt, og de valgte sager har fået skiftet afregningsmodel.',
        [BulkActionType.ChangeBillingAppendixSetup]: 'Din massebehandling er nu kørt, og de valgte sager har fået skiftet bilagsopsætning.',
        [BulkActionType.ChangeWorkflow]: 'Din massebehandling er nu kørt, og de valgte sager har fået skiftet workflow.',
        [BulkActionType.MoveCaseToWorkflowTask]: 'Din massebehandling er nu kørt, og de valgte sager er rykket til workflow opgaven.',
        [BulkActionType.RollbackOneTask]: 'Din massebehandling er nu kørt, og de valgte sagers workflow-opgaver er rullet tilbage.',
        [BulkActionType.RollbackAllTasks]: 'Din massebehandling er nu kørt, og de valgte sagers workflow-opgaver er rullet tilbage.',
        [BulkActionType.RunBillingModel]: 'Din massebehandling er nu kørt, og de valgte sagers afregningsmodel er nu kørt.',
        [BulkActionType.ResubscribeCosmo]: 'Din massebehandling er nu kørt, og de valgte sager er nu blevet gentilmeldt Cosmo.',
        [BulkActionType.ChangeCaseGroup]: 'Din massebehandling er nu kørt, og de valgte sagers sagsgrupper er nu ændret.',
        [BulkActionType.ResyncCosmo]: 'Din massebehandling er nu kørt, og de valgte sager er nu blevet gensynkroniseret med Cosmo.',
    },
    paymentPlansInsights: {
        paymentPlans: 'Afdragsordninger',
        quantityEntries: 'Antal afdrag',
        amountEntries: 'Beløb for afdrag',
    },
    insights: {
        fromDate: 'Fra dato',
        toDate: 'Til dato',
        getReport: 'Hent rapport',
        powerbi: {
            downloadPbids: 'Hent en PBIDS fil som datakilde for din Power BI opsætning',
        },
        connectToApi: 'Opret forbindelse til din data via et API.',
        downloadLimit: 'Der er en grænse på anmodninger til datakilden på én gang per døgn.',
        apiTypes: {
            ['cases']: 'Sager',
            ['users']: 'Brugere',
            ['satisfactions']: 'Tilfredshedssvar',
            ['case-vouchers']: 'Sagsposteringer',
            ['billing-vouchers']: 'Afregningsposteringer',
            ['creditors']: 'Kreditorer',
            ['updates']: 'Opgaver',
            ['update-types']: 'Opgavetyper',
            ['workflows']: 'Workflows',
            ['workflow-tasks']: 'Workflow-opgaver',
            ['case-statuses']: 'Sagsstatus-log',
            ['interactions']: 'Interaktioner',
            ['documents']: 'Dokumenter',
            ['payment-plans']: 'Afdragsordninger',
            ['payment-plan-entries']: 'Afdrag',
            ['users-on-customers']: 'Brugere på kunder',
            ['customers']: 'Kunder',
            ['properties']: 'Attributter',
        },
        connectGuide: {
            description: 'Du kan tilgå din data igennem et API for ekstern brug.',
            liIntroStep1: 'Gå til Indstillinger og vælg "Udviklere"',
            liIntroStep2: 'Opret ny API-Nøgle',
            liIntroStep3: 'Giv nøglen et passende navn og vælg det tilsvarende scope',
            liIntroStep4: 'Det tilsvarende scope er i dette tilfælde',
            liIntroStep5: "Du kan dernæst bruge din oprettede API-nøgle til at forbinde til url'en",
            powerbiDescription: 'Hvis du vil forbinde til Power BI, kan du se en gennemgang forneden',
            liPowerbiStep1: "Forbind til en ny 'Web' datakilde i Power BI",
            liPowerbiStep2: 'Udfyld som på nedenstående billede, hvor du erstatter',
            liPowerbiStep3: "med url'en fra punkt 5 og",
            liPowerbiStep4: 'med din nyoprettet API-nøgle',
            liPowerbiStep5: 'Tryk dernæst OK og du er klar',
            understood: 'Modtaget',
        },
        connect: 'Forbind',
        download: 'Hent',
        orderReport: 'Bestil rapport',
        billingFile: 'Fil med betalinger',
        billingFileDesc: 'Fil med indbetalinger i det valgte tidsinterval.',
        reportOrdered: 'Rapport bestilt',
        reportOrderedText: 'Du vil modtage en mail inden længe med din rapport.',
        reportOrderedCloseButton: 'Luk',
        interactionsReports: 'Interaktionsrapport',
        interactionsReportsDesc: 'Rapport over indgående og udgående kommunikation.',
        interactionsReportsCreatedAt: 'Oprettet d.',
        interactionsReportsState: 'Status',
        interactionsReportsType: 'Type',
        interactionsReportsDirection: 'Retning',
        interactionsReportsCreditorSeqId: 'Kreditornummer',
        interactionsReportsCreditor: 'Kreditor',
        interactionsReportsCaseSeqId: 'Sagsnummer',
        interactionsReportsAddress: 'Adresse',
        interactionsReportsZipcode: 'Postnummer',
        interactionsReportsCity: 'By',
        interactionsReportsCountry: 'Land',
        caseOverview: 'Sagsoverblik',
        caseOverviewDesc: 'Overblik over alle sager per kreditor indeholdende info om debitor, sagsstatus og finansiel data.',
        includeDocuments: 'Inkludér dokumenter',
        includeVouchers: 'Inkludér sagsposteringer',
        includeRki: 'Inkludér RKI rapporteringer',
        documents: 'Dokumenter',
        steps: 'Steps',
        vouchers: 'Posteringer',
        cases: 'Sager',
        collector: 'Inddriver',
        creditor: 'Kreditor',
        rki: 'RKI',
        downloadsYourExportIsReady: 'Din rapport er klar',
        downloadsYourExportIsReadyBody: '<p>Hej</p><p>Din rapport er nu klar.</p>',
        downloadsYourExportIsReadyButton: 'Hent rapport',
        caseOverviewHeaderDocumentId: 'Doc ID',
        caseOverviewHeaderFileLink: 'Link til fil',
        caseOverviewHeaderType: 'Type',
        caseOverviewHeaderSignedAt: 'Dato for underskrift',
        caseOverviewHeaderCreatedAt: 'Dato for oprettelse',
        caseOverviewHeaderDate: 'Dato',
        caseOverviewHeaderDueDate: 'Forfaldsdato',
        caseOverviewHeaderCategory: 'Kategori',
        caseOverviewHeaderImposedBy: 'Pålagt af',
        caseOverviewHeaderText: 'Tekst',
        caseOverviewHeaderInterest: 'Rentesats',
        caseOverviewHeaderInterestStartDate: 'Rentestartdato',
        caseOverviewHeaderInterestEndDate: 'Renteslutdato',
        caseOverviewHeaderAmount: 'Beløb',
        caseOverviewHeaderExpirationDate: 'Forældelsesdato',
        caseOverviewHeaderExpired: 'Forældet',
        caseOverviewCompany: 'Virksomhed',
        caseOverviewPrivate: 'Person',
        caseOverviewHeaderCreditor: 'Kreditor',
        caseOverviewHeaderCreditorSeqId: 'Kreditornummer',
        caseOverviewHeaderCaseGroup: 'Sagsgruppe',
        caseOverviewHeaderImportedAt: 'Importdato',
        caseOverviewHeaderCaseSeqId: 'Sagsnummer',
        caseOverviewHeaderMigratedJournalNumber: 'Migreret j.nr.',
        caseOverviewHeaderReferenceId: 'Referencenummer',
        caseOverviewHeaderDebtorSeqId: 'Debitornummer',
        caseOverviewHeaderDebtorName: 'Navn',
        caseOverviewHeaderDebtorEmail: 'Email',
        caseOverviewHeaderDebtorPhone: 'Telefonnr.',
        caseOverviewHeaderDebtorSatisfaction: 'Tilfredshed',
        caseOverviewHeaderDebtorSatisfactionComment: 'Tilfredshedskommentar',
        caseOverviewHeaderDebtorRKICount: 'Alle RKI-registreringer',
        caseOverviewHeaderDebtorCompanyStatus: 'Virksomhedsstatus',
        caseOverviewHeaderDebtorCVR: 'CVR',
        caseOverviewHeaderDebtorBirthdate: 'Fødselsdato',
        caseOverviewHeaderDebtorAddressProtection: 'Adressebeskyttet',
        caseOverviewHeaderDebtorCountry: 'Land',
        caseOverviewHeaderDebtorZipCode: 'Postnummer',
        caseOverviewHeaderDebtorCity: 'By',
        caseOverviewHeaderDebtorAddress: 'Adresse',
        caseOverviewHeaderDebtorCoAddress: 'CoAdresse',
        caseOverviewHeaderDebtorType: 'Debitortype',
        caseOverviewHeaderDebtorCount: 'Antal debitorer',
        caseOverviewHeaderCreditScore: 'Kreditscore',
        caseOverviewHeaderCurrency: 'Valuta',
        caseOverviewHeaderPrincipal: 'Indleveret hovedstol',
        caseOverviewHeaderPrincipalPaid: 'Indbetalt hovedstol',
        caseOverviewHeaderPrincipalLeft: 'Rest hovedstol',
        caseOverviewHeaderReminderFeeCreditor: 'Indleveret rykkergebyr fra kreditor',
        caseOverviewHeaderReminderFeeCreditorPaid: 'Indbetalt rykkergebyr fra kreditor',
        caseOverviewHeaderReminderFeeCreditorLeft: 'Rest rykkergebyr fra kreditor',
        caseOverviewHeaderReminderFeeCollector: 'Pålagte rykkergebyrer fra inddriver',
        caseOverviewHeaderReminderFeeCollectorPaid: 'Indbetalt pålagte rykkergebyrer',
        caseOverviewHeaderReminderFeeCollectorLeft: 'Rest pålagte rykkergebyrer',
        caseOverviewHeaderCompensationCostCreditor: 'Indleveret kompensationsgebyr fra kreditor',
        caseOverviewHeaderCompensationCostCreditorPaid: 'Indbetalt kompensationsgebyr fra kreditor',
        caseOverviewHeaderCompensationCostCreditorLeft: 'Rest kompensationsgebyr fra kreditor',
        caseOverviewHeaderCompensationCostCollector: 'Pålagte kompensationsgebyrer fra inddriver',
        caseOverviewHeaderCompensationCostCollectorPaid: 'Indbetalt kompensationsgebyrer fra inddriver',
        caseOverviewHeaderCompensationCostCollectorLeft: 'Rest kompensationsgebyrer fra inddriver',
        caseOverviewHeaderCollectionCostCreditor: 'Indleveret inkassoomkostning fra kreditor',
        caseOverviewHeaderCollectionCostCreditorPaid: 'Indbetalt inkassoomkostning fra kreditor',
        caseOverviewHeaderCollectionCostCreditorLeft: 'Rest inkassoomkostning fra kreditor',
        caseOverviewHeaderCollectionCostCollector: 'Pålagte inkassoomkostninger fra inddriver',
        caseOverviewHeaderCollectionCostCollectorPaid: 'Indbetalt inkassoomkostninger fra inddriver',
        caseOverviewHeaderCollectionCostCollectorLeft: 'Rest inkassoomkostninger fra inddriver',
        caseOverviewHeaderCollectionFeeCreditor: 'Indleveret inkassogebyr fra kreditor',
        caseOverviewHeaderCollectionFeeCreditorPaid: 'Indbetalt inkassogebyr fra kreditor',
        caseOverviewHeaderCollectionFeeCreditorLeft: 'Rest inkassogebyr fra kreditor',
        caseOverviewHeaderCollectionFeeCollector: 'Pålagte inkassogebyrer fra inddriver',
        caseOverviewHeaderCollectionFeeCollectorPaid: 'Indbetalt inkassogebyrer fra inddriver',
        caseOverviewHeaderCollectionFeeCollectorLeft: 'Rest inkassogebyrer fra inddriver',
        caseOverviewHeaderCourtCostCollector: 'Retslige omkostninger fra inddriver',
        caseOverviewHeaderCourtCostCollectorPaid: 'Indbetalt retslige omkostninger fra inddriver',
        caseOverviewHeaderCourtCostCollectorLeft: 'Rest retslige omkostninger fra inddriver',
        caseOverviewHeaderCourtCostCreditor: 'Retslige omkostninger fra kreditor',
        caseOverviewHeaderCourtCostCreditorPaid: 'Indbetalt retslige omkostninger fra kreditor',
        caseOverviewHeaderCourtCostCreditorLeft: 'Rest retslige omkostninger fra kreditor',
        caseOverviewHeaderInterestCreditor: 'Indleveret renter fra kreditor',
        caseOverviewHeaderInterestCreditorPaid: 'Indbetalt renter fra kreditor',
        caseOverviewHeaderInterestCreditorLeft: 'Rest renter fra kreditor',
        caseOverviewHeaderInterestCollector: 'Pålagte renter fra inddriver',
        caseOverviewHeaderInterestCollectorPaid: 'Indbetalt renter fra inddriver',
        caseOverviewHeaderInterestCollectorLeft: 'Rest renter fra inddriver',
        caseOverviewHeaderCreditorTotal: 'Indleveret i alt fra kreditor',
        caseOverviewHeaderCreditorTotalPaid: 'Indbetalt i alt fra kreditor',
        caseOverviewHeaderCreditorTotalLeft: 'Rest i alt fra kreditor',
        caseOverviewHeaderCreditorTotalDepositsToCreditor: 'Indbetalt til kreditor i alt',
        caseOverviewHeaderCollectorTotal: 'Pålagte i alt fra inddriver',
        caseOverviewHeaderCollectorTotalPaid: 'Indbetalt i alt til inddriver',
        caseOverviewHeaderCollectorTotalLeft: 'Rest i alt fra inddriver',
        caseOverviewHeaderTotal: 'Total',
        caseOverviewHeaderTotalPaid: 'Indbetalt total',
        caseOverviewHeaderTotalLeft: 'Rest total',
        caseOverviewHeaderLastDepositDate: 'Seneste indbetaling importeret d.',
        caseOverviewHeaderCurrentWorkflow: 'Workflow',
        caseOverviewHeaderCurrentWorkflowTask: 'Nuværende opgave',
        caseOverviewHeaderCurrentWorkflowTaskTime: 'Nuværende opgaves tidspunkt',
        caseOverviewHeaderNextWorkflowTask: 'Næste opgave',
        caseOverviewHeaderNextWorkflowTaskTime: 'Næste opgaves tidspunkt',
        caseOverviewHeaderFoundation: 'Fundament',
        caseOverviewHeaderPaymentPlan: 'Afdragsordning',
        caseOverviewHeaderPaidPaymentPlanEntries: 'Betalte afrag',
        caseOverviewHeaderTotalPaymentPlanEntries: 'Afdrag i alt',
        caseOverviewHeaderCaseStatus: 'Sagsstatus',
        caseOverviewHeaderEndReason: 'Afslutningskode',
        caseOverviewHeaderExitDate: 'Afslutningsdato',
        caseOverviewHeaderStepTitle: 'Step-titel',
        caseOverviewHeaderStepCategory: 'Step-kategori',
        caseOverviewHeaderNextStepTitle: 'Næste step-titel',
        caseOverviewHeaderNextStepCategory: 'Næste step-kategori',
        caseOverviewHeaderSignedFoudations: 'Underskrevede fundamenter',
        caseOverviewHeaderPaymentPlans: 'Afdragsordninger oprettet',
        caseOverviewHeaderFoundationDate: 'Fundamentsdato',
        caseOverviewHeaderFoundationCode: 'Fundamentskode',
        caseOverviewHeaderFoundationType: 'Fundamentstype',
        caseOverviewHeaderRkiRegistry: 'Register',
        caseOverviewHeaderState: 'Status',
        caseOverviewHeaderReportedAt: 'Raporteringsdato',
        caseOverviewHeaderError: 'Fejlbesked',
        caseOverviewHeaderRKIReference: 'RKI Referencenummer',
        caseOverviewHeaderClientNumber: 'Kreditornummer',
        caseOverviewHeaderSurveillance: 'Overvågning',
        caseOverviewHeaderSurveillanceDate: 'Overvågningsdato',
        dailyDeposits: 'Daglige indbetalinger',
        dailyDepositsDesc: 'Daglige indbetalinger per kreditor',
        paymentPlanReport: 'Afdragsordninger',
        paymentPlanReportDesc: 'Rapport vedrørende status på afdragsordninger.',
        dailyDepositsEconomic: 'Daglige indbetalinger (e-conomic)',
        dailyDepositsEconomicDesc: 'Daglige indbetalinger per kreditor til e-conomic uden Frisbii',
        invoiceAppendix: 'Fakturabilag',
        invoiceAppendixDesc: 'Faktura bilag med afregningstal.',
        employeePerformance: 'Medarbejderstatistik',
        employeePerformanceDesc: 'Statistik om medarbejdernes bedrifter i systemet.',
        phoneCalls: 'Oversigt over telefonopkald',
        phoneCallsDesc: 'Overblik over ind- og udgående opkald.',
        phoneCallsDays: 'Vælg antal dage efter opkald indbetalingerne skal være faldet',
        depositAmount: 'Indbetalt beløb',
        depositCount: 'Indbetalinger i antal',
        selectCreditor: 'Vælg kreditor',
        quarter: 'Kvartal',
        optional: 'valgfri',
    },
    tribunal: {
        couldNotCreateTribunalCase: 'Kunne ikke oprette domstolssag',
        createTribunalCase: 'Opret',
        noTribunalCases: 'Endnu ingen sager',
        addTribunalCase: 'Tilføj domstolssag',
        fsNo: 'FS-nummer',
        editFsNo: 'Rediger FS-nummer',
        FsNoUpdated: 'FS-nummer opdateret',
        document: 'Dokument',
        date: 'Dato',
        meetingLocation: 'Mødested',
        meetingDate: 'Mødedato',
        courtCaseCosts: 'Tilkendte sagsomkostninger',
        notRegistered: 'Ikke registreret',
        assignee: 'Mødeansvarlig',
        closedObjection: 'Indsigelse efter 1.-påtegning',
        addDocument: 'Tilføj dokument',
        insolvency: 'Insolvenserklæring',
        insolvencyDate: 'Dato for insolvenserklæring',
        phoneCourtMeeting: 'Retsmøde (eks. telefonisk fogedmøde)',
        register: 'Registrér',
        createFogedrekvisition: 'Opret fogedrekvisition',
        selectDistraintType: 'Vælg udlægstype',
        registerDistraint: 'Registrer udlæg',
        distraintType: 'Udlægstype',
        amount: 'Beløb',
        comment: 'Kommentar',
        address: 'Adresse',
        licenseplate: 'Nummerplade',
        vin: 'VIN',
        distraintDate: 'Dato for tinglysning',
        distraintReferenceId: 'Tinglysningsnummer',
        distraintUpdated: 'Udlæg opdateret',
        distraintCancelled: 'Udlæg annulleret',
        distraintCancelledDate: 'Dato for annullering af udlæg',
        registerPolicePresentation: 'Registrer politifremstilling',
        register1Paategning: 'Registrér 1.-påtegning',
        foerstePaategningDate: 'Dato for 1.-påtegning',
        register2Paategning: 'Registrér 2.-påtegning',
        andenPaategningDate: 'Dato for 2.-påtegning',
        resendBPK: 'Genfremsend revideret betalingspåkrav',
        editBPK: 'Redigér betalingspåkrav',
        debtorSentToPolicePresentation: 'Debitor sendt til politifremstilling',
        resendStaevning: 'Genfremsend stævning',
        editStaevning: 'Redigér stævning',
        resendFogedbegaering: 'Genfremsend fogedbegæring',
        editFogedbegaering: 'Redigér fogedbegæring',
        courtMeetingType: 'Mødetype',
        bailiffInvoice: {
            bailiffInvoice: 'Fogedfaktura',
            client: 'Kreditor',
            debt: 'Gæld',
            paymentFee: 'Betalingspåkravshonorar',
            distress: 'Udlæg',
            yesStartDistress: 'Ja til iværksættelse af udlæg',
            yesAutoCase: 'Ja til automatisk indledning af sag i civilretten',
            createInvoice: 'Opret faktura',
        },
        noFoundation: 'Intet fundament fundet. Tilføj venligst et til sagen for at sende en fogedrekvisition.',
        foundation: 'Fundament',
        economy: 'Økonomi',
        jurisdiction: 'Værneting',
        addFoundation: 'Tilføj fundament',
        requisition: 'Udbetalingsrekvisition',
        court: 'Retskreds',
        responsible: 'Ansvarlig',
        sendRequisition: 'Send udbetalingsrekvisition',
        debt: 'Gæld',
        noCourt: 'Ingen retskreds at finde',
        typeOfRequisituion: 'Type af udbetalingsrekvisition',
        types: {
            [UdbetalingsRekvisitioner.Politifremstilling]: 'Politifremstilling',
            [UdbetalingsRekvisitioner.Betalingspåkrav]: 'Betalingspåkrav',
            [UdbetalingsRekvisitioner.Fogedrekvisition]: 'Fogedrekvisition',
        },
        claim: 'Påstand',
        sendToCourt: 'Send til domstol',
        smallCase: 'Småsag',
        commonCivilCase: 'Almindelig civil sag',
        shortDescription: 'Kort beskrivelse',
        statementClaim: 'Sagsfremstilling og synspunkter',
        addAppendix: 'Tilføj bilag',
        additionalInformation: 'Yderligere information',
        caseCreation: 'Opretter sag',
        caseCreationDescription: `Sagen bliver nu oprettet i domstolens system. Det tager lidt tid, men
    sagen bliver opdateret i Debbie når den er oprettet.`,
        keyCodeTitle: 'Skriv nøglekode til',
        keyCodeDescription: 'Brug NemID nøglekortet til at finde nøglen som svarer til',
        sessionCreation: 'Opretter session',
        sessionCreationFailure: 'Session oprettelse fejlede',
        keySubmittedExplainer: `Nøglekoden bliver nu brugt til at logge ind.`,
        sessionCreationExplainer: `For at sende en sag til domstolen, skal der oprettes session i tribunal. Til det skal vi bruge en nøgle fra jeres NemID nøglekort.`,
        keycode: 'NemID nøglekode',
        authKey: 'Nøgle',
        missingKeyTitle: 'Mangler tribunal nøgle',
        missingKeyExplainer: 'For at kunne sende retssager til domstolen, skal du bruge en nøgle til tribunal.',
    },
    courtMeetingState: {
        [CourtMeetingState.Accepted]: 'Møde accepteret',
        [CourtMeetingState.Concluded]: 'Færdig',
        [CourtMeetingState.NeedsApproval]: 'Venter på godkendelse',
        [CourtMeetingState.NeedsRevision]: 'Venter på revision',
        [CourtMeetingState.NotesSent]: 'Noter modtaget',
        [CourtMeetingState.ReadyForMeeting]: 'Venter på mødenoter',
        [CourtMeetingState.Rejected]: 'Afvist af mødetager',
        [CourtMeetingState.Canceled]: 'Aflyst',
    },
    debtorWeb: {
        overpaymentHeader: 'Du har penge til gode',
        overpaymentPreAmount: 'Du har',
        overpaymentPostAmount: 'til gode. Anfør dine kontooplysninger nedenfor, og du vil få dit tilgodehavende udbetalt.',
        userInfoUpdateSuccess: 'Du har nu anmodet om at opdatere dine oplysninger, tak.',
        userInfoUpdateNoDataChanged: 'Ingen ændringer registreret',
        congratsNoDebt: 'Du har ingen gæld på denne sag.',
        congratsDeposit: 'Tak for din indbetaling på denne sag.',
        congratsCaseEnd: 'Din sag er afsluttet',
        satisfactionOne: 'Vi vil meget gerne høre om din oplevelse. Tryk',
        satisfactionTwo: 'her',
        satisfactionThree: 'for at indsende den.',
        documentation: 'Dokumentation',
        goToPayment: 'Gå til betaling',
    },
    caseGroups: {
        caseGroups: 'Sagsgrupper',
        createCaseGroup: 'Opret sagsgruppe',
        addCaseGroup: 'Tilføj sagsgruppe',
        editCaseGroup: 'Rediger sagsgruppe',
        selectCaseGroup: 'Vælg sagsgruppe',
        confirmDelete: 'Er du sikker på, at du vil slette sagsgruppen? Alle sager i sagsgruppen, vil blive fjernet fra sagsgruppen.',
        deleteCaseGroup: 'Slet',
        caseGroup: 'Sagsgruppe',
        label: 'Navn',
        categorisedDebtOverview: 'Tilføj attributter til flettefeltet kategoriseret gældsoversigt',
        showPropertyLabel: 'Navn',
        addShowProperty: 'Tilføj attribut',
    },
    createTenantContent: {
        defaultCaseGroupLabel: 'Sager til inddrivelse',
        defaultBankAccountName: 'Bankkonto',
    },
    tenants: {
        prices: 'Priser',
        identityCollector: 'Inddriver',
        invoicePipeFilter: 'Standard afregningsopsætning',
        defaultBillingModel: 'Standard afregningsmodel',
        defaultBillingAppendixSetup: 'Standard bilagsopsætning',
        configurationOptions: 'Konfigurationer',
        depositBankAccountForCreditors: 'Indbetalingskonto til kreditorer',
        depositBankAccountForCreditorsName: 'Bankens navn',
        billingCustomText: {
            title: 'Brugerdefinerede tekstfelter på afregningsbilag',
            underCreditorName: 'Under kreditors navn',
            endWhenReceivingPayment: 'Under betalingsinformation når kreditor skal betale',
            endWhenSendingPayment: 'Under betalingsinformation når kreditor skal have noget udbetalt',
        },
        collectionCommission: 'Inddrivelseshonorar',
        depositOrder: 'Betalingsrækkefølge',
        date: 'Dato',
        voucherFrom: 'Postering pålagt af',
        voucherType: 'Posteringstype',
        voucherCategory: 'Posteringskategori',
        newestFirst: 'Nyeste først',
        oldestFirst: 'Ældste først',
        caseCloseFee: 'Sagsafslutningshonorarer',
        clientCaseCreationFee: 'Sagsopstartshonorarer kreditor',
        tenantCaseCreationFee: 'Sagsopstartshonorarer tenant',
        RKIRegistrationFee: 'RKI-registreringshonorarer',
        paymentDemandFee: 'Betalingspåkravshonorarer',
        folkeregisteropslagsFee: 'Folkeregisteropslag',
        anmeldelseAfKravFee: 'Anmeldelse af krav',
        legalAdviceHourlyRate: 'Timepris for juridisk bistand',
        afslysningAfUdlaeg: 'Aflysning af udlæg',
        automaticDebtRegister: 'Automatisk registrering i RKI',
        autoRKIOpen: 'Åben RKI',
        autoRKIIgnoreUnresolvedOppositions: 'Ignorer uafklarede interaktioner (indsigelser)',
        autoRKI: 'Auto-RKI',
        autoRKIDeleteOnCaseEnd: 'Slet automatisk RKI-registrering ved sagsafslutning',
        experianConfig: 'Experian konfigurationer',
        autoDebtRegisterInfoTip: 'Klik her for mere info',
        areYouSureAutoDebtRegister: 'Er du sikker?',
        autoDebtRegisterRKI: {
            headline: 'Automatisk registrering i RKI.',
            info: 'Denne funktion tager højde for følgende:',
            exclude: 'Der tages IKKE højde for følgende: ',
            endingInfo: 'Slå derfor kun denne funktion til hvis du/I ved at jeres sager overholder ovenstående.',
            note: 'Bemærk at denne funktions også kan slås til/fra på kreditorniveau.',
        },
        autoImposeCompensationCost: 'Pålæg automatisk ét kompensationsgebyr pr. faktura på erhvervssager',
        autoSendInteractionsAfterXVerifications: 'Antal godkendelser før automatisk afsendelse',
        preventSendingLetters: 'Undlad at sende breve (webhooks kan hjælpe til at sende på anden vis)',
        selfCollection: 'Egeninkasso (pålægger egeninkassoomkostninger)',
        twoFactorRequired: 'Two-faktor-godkendelse for brugere',
        outboundCall: 'Udgående opkald',
        autoExpireVouchers: 'Automatisk forældelse af posteringer',
        fogedrekvisitionFee: 'Fogedrekvisitionshonorarer',
        AKSSettings: 'AKS indstillinger',
        AKSKey: 'AKS nøgle',
        AKSCode: 'AKS kode',
        AKSUsername: 'AKS brugernavn',
        AKSPassword: 'AKS adgangskode',
    },
    intents: {
        intent: 'Hensigt',
        days: 'Dage',
        discount: 'Rabat',
        type: 'Type',
        percentDiscount: 'Procent rabat',
        noDiscount: 'Ingen rabat',
    },
    intentDiscountTypes: {
        [DiscountType.Amount]: 'Beløb',
        [DiscountType.Fraction]: 'Procent',
    },
    intentTypes: {
        [IntentType.Unknown]: 'Ukendt',
        [IntentType.Deposit]: 'Indbetaling',
    },
    errors: {
        notFound: 'Siden du forsøger at besøge findes ikke.',
        pleaseCreateTicket: 'Opret venligst et ticket hvis dette er en fejl.',
        unknownError: 'Der opstod en fejl.',
        authError: 'Din bruger har ikke adgang.',
        meError: 'Der var et problem med at få din bruger info. Hvis det ikke er forventet, så prøv igen.',
        unauthorizedError: 'Du har ikke tilladelse til at udføre denne handling',
    },
    letterTemplates: {
        journalNumber: 'J.nr.:',
        caseReferenceId: 'Reference:',
        returnAddress: 'Returadresse:',
        w: 'W',
        e: 'E',
        t: 'T',
        centralRegisterId: 'CVR',
    },
    mentionContent: {
        reminderFeeRow: 'Rykkergebyr jf. rentelovens § 9b, stk. 2',
        debtCollectionFeeRow: 'Inkassogebyr jf. rentelovens § 9b, stk. 3',
        debtCollectionCostRow: 'Udenretlige inkassoomkostninger jf. rentelovens § 9a, stk. 1',
        compensationFeeRow: 'Kompensationsgebyr jf. rentelovens § 9a, stk. 3',
        fixedInterestRow: 'Tidligere påløbne renter',
        processInterestRow: 'Påløbne renter fra forfaldsdato',
        yearlyInterestRow: 'Påløbne renter',
        otherCosts: 'Yderligere omkostninger',
        sum: 'Udestående i alt',
        paid: 'Indbetalt i alt',
        invoice: 'Faktura',
        caseVoucher: 'Postering',
        currency: 'Valuta',
        date: 'Dato',
        dueDate: 'Forfaldsdato',
        amount: 'Beløb',
        email: 'Email',
        phone: 'Telefonnr.',
        signature: 'Underskrift',
        journalNumber: 'j.nr.:',
        genericEmailSubjectPre: 'Vedrørende din gæld til',
        genericEmailSubjectForAlternativeContactPre: 'Sag hos',
        satisfactionsOrClick: 'eller klik',
        satisfactionsHere: 'her',
        principalReferenceIdsAnd: ' og ',
    },
    emailSignature: {
        privacyPolicyText: 'Behandling af persondata. Vi behandler persondata om dig, som vi bl.a. har indsamlet fra andre. Du kan se vores persondatapolitik her:',
        regards: 'Med venlig hilsen',
    },
    invoice: {
        deposit: 'Indbetaling',
        overpayment: 'Overindbetaling',
        deposits: 'Indbetalinger',
        creditorSeqId: 'Id',
        period: 'Periode',
        description: 'Beskrivelse',
        amount: 'Beløb',
        ofVoucher: 'Af postering',
        subTotal: 'Subtotal',
        customerReferenceId: 'Kundenummer',
        imposedBy: 'Pålagt af',
        vat: 'Moms',
        total: 'Total',
        date: 'Dato',
        number: 'Nummer',
        appendix: 'Bilag',
        voucher: 'Postering',
        voucherReferenceId: 'Posteringsreference',
        text: 'Tekst',
        disbursements: 'Udlæg',
        fees: 'Honorarer',
        collectionCommission: 'Inddrivelseshonorar',
        creditorName: 'Kreditor',
        creditorReference: 'Kreditorreferencenummer',
        caseGroup: 'Sagsgruppe',
        caseSeqId: 'Sagsnummer',
        caseReferenceId: 'Sagsref.nr.',
        debtorName: 'Debitornavn',
        depositId: 'Indbetalings-id',
        paidToClient: 'Indbetalt til kreditor',
        economicMovement: 'Kreditorbevægelse',
        creditorDeposit: 'Kreditorindbetaling',
        previous: 'Tidl.',
        credited: 'Tilbageført fra nota',
        currency: 'Valuta',
    },
    standardProcedureTitles: {
        ['2bf2187e-259e-4176-a762-859e4688ba3b']: 'Overindbetaling',
        ['4b9cc5d8-c3af-441b-8eb1-a3afa882e59d']: 'Tilbud om afdragsordning',
        ['61ddc972-b02d-44e0-b9bc-3c746e1c1be4']: 'Sag delvist betalt',
        ['77b8678a-a6dd-4005-b320-7a9cc963f751']: 'Sag fuldt betalt',
        ['e205691e-4197-4152-81a6-09de315cb70a']: 'Sagens krav er opdateret',
        ['47d383b7-f239-4566-abb2-58cae4d9bd30']: 'Betaling på sag i retten',
    },
    standardProcedureDescriptions: {
        ['2bf2187e-259e-4176-a762-859e4688ba3b']: 'Der er betalt mere end der er opkrævet',
        ['4b9cc5d8-c3af-441b-8eb1-a3afa882e59d']: 'Send et tilbud om en afdragsordning',
        ['61ddc972-b02d-44e0-b9bc-3c746e1c1be4']: 'Sag delvist betalt. Giv kontaktperson besked',
        ['77b8678a-a6dd-4005-b320-7a9cc963f751']: 'Luk sagen og giv kontaktperson besked',
        ['e205691e-4197-4152-81a6-09de315cb70a']: 'Sagens krav er opdateret',
        ['47d383b7-f239-4566-abb2-58cae4d9bd30']: 'Betaling på sag i retten. Giv retten besked',
    },
    properties: {
        properties: 'Attributter',
        createNewPropertyType: 'Opret ny attribut',
        infoGuideMentions: 'For at indsætte feltets data i en skabelon, skal du bruge flettefeltet',
        infoGuideImport: 'For at importere data til flettefeltet kan du indsætte en kolonne i dit excel-import-ark med følgende overskrift',
        newProperty: 'Ny attribut',
        newPropertyFor: 'Opret en ny attribut for',
        label: 'Label',
        description: 'Beskrivelse',
        handle: 'Handle',
        type: 'Type',
        ref: 'Reference',
        scope: 'Tilknytning',
        required: 'Påkrævet',
        usage: 'Brug',
        historical: 'Historisk data',
        create: 'Opret attributten',
        dropdownOptions: 'Dropdown valgmuligheder',
        cases: 'Sager',
        caseVouchers: 'Sagsposteringer',
        creditors: 'Kreditorer',
        delete: 'Slet',
        or: 'eller',
        deleteAreYouSure: 'Hvis denne attribut slettes, vil den blive slettet fra alle sager og evt. skabeloner. Er du sikker?',
    },
    entities: {
        [Entity.Billing]: 'Afregning',
        [Entity.Case]: 'Sag',
        [Entity.Creditor]: 'Kreditor',
        [Entity.Customer]: 'Kunde',
        [Entity.TribunalCase]: 'Domstolssag',
        [Entity.Debtor]: 'Debitor',
        [Entity.Collector]: 'Inddriver',
        [Entity.BillingVoucher]: 'Afregningspostering',
        [Entity.CaseVoucher]: 'Sagspostering',
    },
    filterType: {
        [FilterType.Exact]: 'Filtrer på præcis værdi',
        [FilterType.Containing]: 'Filtrer på indeholdt værdi',
    },
    propertyTypeLabels: {
        ['Name']: 'Navn',
        ['Address']: 'Adresse',
        ['Phone']: 'Telefon',
        ['Email']: 'Email',
        ['Type']: 'Type',
        ['Company']: 'Virksomhed',
    },
    propertyTypeDescriptions: {
        ['Name of the alternative contact person.']: 'Repræsentantens navn.',
        ['Address for the alternative contact person.']: 'Repræsentantens adresse.',
        ['Phone to the alternative contact person.']: 'Repræsentantens telefonnummer.',
        ['Email to the alternative contact person.']: 'Repræsentantens email.',
        ['Type of the alternative contact person.']: 'Repræsentantens type.',
        ['Company where the alternative contact person works.']: 'Repræsentantens arbejdsplads/virksomhed.',
    },
    alternativeContactTypes: {
        [AlternativeContactType.Lawyer]: 'Advokat',
        [AlternativeContactType.Proprietorship]: 'Boligadministrator',
        [AlternativeContactType.Owner]: 'Ejer',
        [AlternativeContactType.Guardian]: 'Værge',
        [AlternativeContactType.Curator]: 'Kurator',
        [AlternativeContactType.Landlord]: 'Udlejer',
        [AlternativeContactType.FinancialAdvisor]: 'Økonomisk rådgiver',
        [AlternativeContactType.TaxAuthority]: 'SKAT',
        [AlternativeContactType.PowerOfAttorney]: 'Fuldmagtshaver',
        [AlternativeContactType.Administrator]: 'Administrator',
        [AlternativeContactType.Police]: 'Politi',
        [AlternativeContactType.Guarantor]: 'Kautionist',
        [AlternativeContactType.Other]: 'Anden',
    },
    voucherApplications: {
        header: 'Regler',
        createError: 'Der opstod en fejl under oprettelsen. Tjek at du ikke laver cirkulære referencer.',
        creditorCustomApplicationList: 'Kreditorspecifikke regler',
        noCustomApplications: 'Ingen regler',
        textSelector1: 'Når en ny ',
        textSelector2: ' oprettes, hvor sagens type er ',
        textSelector3: ', oprettes følgende postering.',
        forCreditor: 'Når kreditor er',
        addCreditor: 'Vælg kreditor',
    },
    voucherApplicationTypeLabels: {
        [VoucherApplicationType.Case]: 'sag',
        [VoucherApplicationType.VoucherCategory]: 'postering med kategorien',
        [VoucherApplicationType.VoucherType]: 'postering af typen',
    },
    voucherApplicationTargetLabels: {
        [VoucherApplicationTarget.Both]: 'privat eller erhverv',
        [VoucherApplicationTarget.Person]: 'privat',
        [VoucherApplicationTarget.Company]: 'erhverv',
    },
    creditScore: {
        estimated: 'Estimeret',
        estimateZero: 'sandsynlighed for inddrivelse',
        estimate: 'sandsynlighed for inddrivelse af restgælden',
        paid: 'Gælden er betalt',
    },
    customerCare: {
        serviceRequestsHeader: 'Serviceanmodning',
        serviceRequestsDescription: 'Har du brug for hjælp til Debbie? Det kan være ting som ændring af indstillinger, oprettelse af workflows eller hvordan man journaliserer en e-mail. Vi er her for at guide dig gennem processen og sikre, at du får mest muligt ud af vores løsning.',
        serviceRequestsButton: 'Få hjælp',
        serviceRequestsSupportUsersDescription: 'Med jeres support-pakke har I muligheden for, at vælge {maxUsers} kontaktperson(er), som er ansvarlig(e) for dialogen med Debbie. Hvis I har brug for flere kontaktpersoner, kan I opgradere jeres support-pakke.',
        serviceRequestsSupportUsersSelect: 'Vælg venligst jeres faste kontaktpersoner:',
        serviceRequestsSupportUsersSelected: 'valgt',
        serviceRequestsSupportUsersSave: 'Gem',
        knowledgeBase: 'Knowledgebase',
        knowledgeBaseDesc: 'Få hjælp, vejledning og gode råd ved at læse Debbies artikler.',
        ticket: 'Ticket',
        ticketDesc: 'Opret et ticket og få hjælp af Debbies support.',
        ticketUpgradeToGetAccess: 'Opgrader jeres support-pakke for at flere kan få adgang til Debbies ticket-support',
        contactPerson: 'Kontaktperson',
        contactPersonDesc: 'Tag fat på en af jeres kontaktpersoner, hvis du har brug for hjælp',
        contactPersonEmailSubject: 'Hjælp til Debbie',
        contactPersonEmailBody: `Hej,
Jeg har brug for hjælp til ...`,
        incidentsHeader: 'Fejlhændelser',
        incidentsDescription: 'Hvis du støder på et problem, uanset størrelse, må du meget gerne indrapportere det. Det kan være fejl, nedetid, eller uønskede hændelser. Vi er her for at hjælpe dig med at få det løst, så du kan komme tilbage til at nyde en problemfri oplevelse.',
        incidentsButton: 'Rapporter et problem',
        featureRequestsHeader: 'Forslag til forbedringer',
        featureRequestsDescription: 'Hvis du har en idé til en ny funktion eller forbedring af en eksisterende, vil vi meget gerne høre det! Del dine tanker med os, og vi vil tage dem med i vores betragtninger, mens vi arbejder på at gøre vores løsning endnu bedre.',
        featureRequestsButton: 'Anmod om funktionalitet',
        requestForConsultancyHeader: 'Konsulentarbejde',
        requestForConsultancyDescription: 'Har du brug for hjælp til noget ud over det sædvanlige? Vi tilbyder konsulentarbejde, hvor vi kan hjælpe dig med at udvikle integrationer, rapporteringer og meget mere.',
        requestForConsultancyButton: 'Indhent tilbud',
        requestForConsultancyEmailSubject: 'Konsulentarbejde',
        requestForConsultancyEmailBody: `Hej Debbie,
Vi kunne godt tænke os ...`,
    },
    interestFromLabels: {
        [InterestFrom.Date]: 'fra oprettelsesdato',
        [InterestFrom.DueDate]: 'fra forfaldsdato',
    },
    todoQueue: {
        sorting: 'Sortering',
        oldest: 'Ældste',
        creditScore: 'Kreditscore',
    },
    views: {
        filter: 'Filtrér',
        view: 'visning',
        name: 'Navn på visning',
        introHeader: 'Ingen visninger her',
        introDescription: 'Du kan oprette en visning ved at klikke på knappen oppe i højre hjørne.',
        clear: 'Ryd',
        collapse: 'Se færre',
        expand: 'Se flere',
        noData: 'Siden er tom',
        is: 'er',
        oneOf: 'er en af',
        before: 'før',
        after: 'efter',
        values: 'værdier',
        isNot: 'er ikke',
        noneOf: 'er ikke en af',
        localChanges: 'Visning ændret lokalt',
        resetLocalChanges: 'Nulstil ændringer',
        invalidNumberError: ' er ikke et validt tal',
        displayOptions: 'Værdier',
        orderedBy: 'Sorter baseret på',
        orderedByDirection: 'Sorteringsretning',
        primaryLabel: 'Primære label',
        secondaryLabel: 'sekundære label',
        betaDisclaimer: 'Visninger er en beta-funktion. Der kan forekomme ændringer eller opdateringer, som potentielt kan påvirke tidligere oprettede visninger. Vi arbejder løbende på at forbedre funktionen og sætter pris på din tålmodighed',
        commaSeparated: 'Komma-separeret',
    },
    viewFilterTypeLabels: {
        caseStatus: 'Sagsstatus',
        creditorId: 'Kreditor',
        creditorState: 'Kreditor status',
        interactionDirection: 'Interaktionsretning',
        interactionType: 'Interaktionstype',
        caseVoucherState: 'Posteringsstatus',
        caseVoucherSource: 'Posteringskilde',
        caseVoucherCurrency: 'Posteringsvaluta',
        caseVoucherType: 'Posteringstype',
        pausedWithUpdates: 'Pauset opgave',
        creditorCreatedAt: 'Kreditor oprettet',
        updatePausedAt: 'Opgave pauset',
        updateContinuedAt: 'Opgave fortsat',
        updateRemindedAt: 'Opgave påmindet',
        caseCreatedAt: 'Sag oprettet',
        caseVoucherDate: 'Posteringsdato',
        caseVoucherExpirationDate: 'Posterings forældelsesdato',
        caseVoucherIrrecoverableDate: 'Posterings uerholdelig dato',
        caseVoucherCreatedAt: 'Postering oprettet',
        satisfactionCreatedAt: 'Anmeldelse oprettet',
        interactionCreatedAt: 'Interaktion oprettet',
        endReasonId: 'Afslutningsårsag',
        caseGroupId: 'Sagsgruppe',
        historicallyPausedUpdates: 'Historisk pauset opgave',
        billingModelId: 'Afregningsmodel',
        documentType: 'Dokument type',
        caseWorkflow: 'Sags workflow',
        currentCaseWorkflowTask: 'Sags nuværende workflow opgave',
        nextCaseWorkflowTask: 'Sags næste workflow opgave',
        caseStatusTime: 'Sags status tidspunkt',
        caseNumbers: 'Sags-id',
        properties: 'Attribut',
    },
    viewLabels: {
        'cases.id': 'Sags-id',
        'cases.status': 'Sagsstatus',
        'cases.createdAt': 'Sags oprettelsesdato',
        'cases.createdBy': 'Sag oprettet af',
        'creditors.name': 'Kreditor navn',
        'creditors.id': 'Kreditor id',
        'billingModels.name': 'Afregningsmodel',
        'caseGroups.label': 'Sagsgruppe',
        'workflows.title': 'Workflow',
        'caseVouchers.amount': 'Posterings beløb',
        caseVoucherProperties: 'Posteringsattributter',
        caseProperties: 'Sagsattributter',
        contactName: 'Kontaktpersons navn',
        'voucherTypes.label': 'Posteringstype',
        caseResponsible: 'Sagsansvarlig',
        caseEndReason: 'Sags afslutningsårsag',
        caseUpdates: 'Pausede sagsopgaver',
    },
    languages: {
        aa: 'Afar',
        ab: 'Abkhasisk',
        ae: 'Avestisk',
        af: 'Afrikaans',
        ak: 'Akan',
        am: 'Amharisk',
        an: 'Aragonisk',
        ar: 'Arabisk',
        as: 'Assamesisk',
        av: 'Avarisk',
        ay: 'Aymara',
        az: 'Aserbajdsjansk',
        ba: 'Basjkirsk',
        be: 'Hviderussisk',
        bg: 'Bulgarsk',
        bh: 'Bihari',
        bi: 'Bislama',
        bm: 'Bambara',
        bn: 'Bengali',
        bo: 'Tibetansk',
        br: 'Bretonsk',
        bs: 'Bosnisk',
        ca: 'Katalansk',
        ce: 'Tjetjensk',
        ch: 'Chamorro',
        co: 'Korsikansk',
        cr: 'Cree',
        cs: 'Tjekkisk',
        cu: 'Kirkeslavisk',
        cv: 'Tsjuvansk',
        cy: 'Walisisk',
        da: 'Dansk',
        de: 'Tysk',
        dv: 'Dhivehi',
        dz: 'Dzongkha',
        ee: 'Ewe',
        el: 'Græsk',
        en: 'Engelsk',
        eo: 'Esperanto',
        es: 'Spansk',
        et: 'Estisk',
        eu: 'Baskisk',
        fa: 'Persisk',
        ff: 'Fulfulde',
        fi: 'Finsk',
        fj: 'Fijisk',
        fo: 'Færøsk',
        fr: 'Fransk',
        fy: 'Frisisk',
        ga: 'Irsk',
        gd: 'Skotsk gælisk',
        gl: 'Galicisk',
        gn: 'Guaraní',
        gu: 'Gujarati',
        gv: 'Mansk',
        ha: 'Hausa',
        he: 'Hebraisk',
        hi: 'Hindi',
        ho: 'Hiri motu',
        hr: 'Kroatisk',
        ht: 'Haitisk kreolsk',
        hu: 'Ungarsk',
        hy: 'Armensk',
        hz: 'Herero',
        ia: 'Interlingua',
        id: 'Indonesisk',
        ie: 'Interlingue',
        ig: 'Ibo',
        ii: 'Yi',
        ik: 'Inupiak',
        io: 'Ido',
        is: 'Islandsk',
        it: 'Italiensk',
        iu: 'Inuittisk',
        ja: 'Japansk',
        jv: 'Javanesisk',
        ka: 'Georgisk',
        kg: 'Congolesisk',
        ki: 'Gikuyu',
        kj: 'Kwanyama',
        kk: 'Kasakhisk',
        kl: 'Kalaallisut',
        km: 'Khmer',
        kn: 'Kannada',
        ko: 'Koreansk',
        kr: 'Kanuri',
        ks: 'Kashmirisk',
        ku: 'Kurdisk',
        kv: 'Komi',
        kw: 'Kornisk',
        ky: 'Kirgisisk',
        la: 'Latin',
        lb: 'Letzeburgsk',
        lg: 'Luganda',
        li: 'Limburgisk',
        ln: 'Lingala',
        lo: 'Laotisk',
        lt: 'Litauisk',
        lu: 'Luba-katanga',
        lv: 'Lettisk',
        mg: 'Gassisk',
        mh: 'Marshallesisk',
        mi: 'Maoriski',
        mk: 'Makedonsk',
        ml: 'Malayalam',
        mn: 'Mongolsk',
        mr: 'Marathi',
        ms: 'Malajisk',
        mt: 'Maltesisk',
        my: 'Burmesisk',
        na: 'Naurisk',
        nb: 'Norsk bokmål',
        nd: 'Nord-ndebele',
        ne: 'Nepali',
        ng: 'Ndonga',
        nl: 'Hollandsk',
        nn: 'Nynorsk',
        no: 'Norsk',
        nr: 'Syd-ndebele',
        nv: 'Navajo',
        ny: 'Chichewa',
        oc: 'Occitansk',
        oj: 'Ojibwa',
        om: 'Oromo',
        or: 'Oriya',
        os: 'Ossetisk',
        pa: 'Punjabi',
        pi: 'Pali',
        pl: 'Polsk',
        ps: 'Pashto',
        pt: 'Portugisisk',
        qu: 'Quechua',
        rm: 'Rætoromansk',
        rn: 'Kirundi',
        ro: 'Rumænsk',
        ru: 'Russisk',
        rw: 'Kinyarwanda',
        sa: 'Sanskrit',
        sc: 'Sardisk',
        sd: 'Sindhi',
        se: 'Nordsamisk',
        sg: 'Sango',
        si: 'Singalesisk',
        sk: 'Slovakisk',
        sl: 'Slovensk',
        sm: 'Samoansk',
        sn: 'Shona',
        so: 'Somali',
        sq: 'Albansk',
        sr: 'Serbisk',
        ss: 'Swati',
        st: 'Sesotho',
        su: 'Sundanesisk',
        sv: 'Svensk',
        sw: 'Swahili',
        ta: 'Tamilsk',
        te: 'Telugu',
        tg: 'Tadtjikkisk',
        th: 'Thai',
        ti: 'Tigrinya',
        tk: 'Turkmensk',
        tl: 'Tagalog',
        tn: 'Tswana',
        to: 'Tonganesisk',
        tr: 'Tyrkisk',
        ts: 'Tsonga',
        tt: 'Tatarsk',
        tw: 'Twi',
        ty: 'Tahitisk',
        ug: 'Uighur',
        uk: 'Ukrainsk',
        ur: 'Urdu',
        uz: 'Usbekisk',
        ve: 'Venda',
        vi: 'Vietnamesisk',
        vo: 'Volapük',
        wa: 'Vallonsk',
        wo: 'Wolof',
        xh: 'Xhosa',
        yi: 'Jiddisch',
        yo: 'Yoruba',
        za: 'Zhuang',
        zh: 'Kinesisk',
        zu: 'Zulu',
    },
    weekdays: {
        0: 'Mandag',
        1: 'Tirsdag',
        2: 'Onsdag',
        3: 'Torsdag',
        4: 'Fredag',
        5: 'Lørdag',
        6: 'Søndag',
    },
};
//# sourceMappingURL=da.js.map